<template>
    <div class="main">
        <div class="tts">
            <button
                v-if="$store.state.miniProgramCoinFeatureEnabled"
                type="button"
                class="mini-program-top-notice"
                @click="openMiniProgramGuide"
            >
                <span class="mini-program-top-notice__badge">小程序免费</span>
                <span class="mini-program-top-notice__text">网站端文字转语音已开启金币计费，微信小程序端当前免费使用，点击扫码进入小程序。</span>
            </button>
            <div class="tts-top-row">
            <div class="container">
                <div class="tts-engine-switch">
                    <span class="tts-engine-switch__label">合成引擎</span>
                    <el-radio-group v-model="ttsEngine" size="mini">
                        <el-radio-button label="azure">微软</el-radio-button>
                        <el-radio-button label="volc">火山引擎</el-radio-button>
                    </el-radio-group>
                </div>
                <div class="nav" :class="{ 'nav--single': ttsEngine !== 'azure' }">
                    <span @click="clickitem('wenben')" :class="wenbenactive">文本</span>
                    <span v-if="ttsEngine === 'azure'" @click="clickitem('ssml')" :class="ssmlactive">SSML</span>
                    <span v-if="ttsEngine === 'azure'" @click="clickitem('live2d')" :class="live2dactive">数字人预览</span>
                </div>
                <div class="contents">
                    <div class="contenttext" v-show="wenbenactive == 'active'">
                        <div class="content-toolbar">
                            <el-button-group>
                                <el-button v-if="ttsEngine === 'azure'" type="primary" size="mini" round @click="showpause = true"
                                    icon="el-icon-video-pause">插入停顿</el-button>
                                <el-button v-if="ttsEngine === 'azure'" type="primary" size="mini" round
                                    @click="InsertData('<break strength=&quot;none&quot; />')" icon="el-icon-delete">删除停顿
                                </el-button>
                                <el-button type="primary" size="mini" round icon="el-icon-delete" @click="clearText">清空文本</el-button>
                                <el-button type="primary" size="mini" round icon="el-icon-document-add" @click="pasteText">粘贴文本</el-button>
                                <el-button type="primary" size="mini" round icon="el-icon-document" @click="openTemplateDialog">文本模板</el-button>
                                <el-button v-if="ttsReadMode === 'single'" type="primary" size="mini" round icon="el-icon-full-screen" @click="showTextEditorDialog = true">展开编辑</el-button>
                            </el-button-group>
                        </div>
                        <el-dialog :visible.sync="showpause" center :width="showwidth" custom-class="insert-pause-dialog" :close-on-click-modal="true">
                            <div slot="title" class="insert-pause-title">
                                <i class="el-icon-video-pause"></i>
                                <span>插入停顿</span>
                            </div>
                            <p class="insert-pause-desc"><i class="el-icon-info"></i> 设置语音合成中的停顿时长，将插入到当前光标位置。</p>
                            <div class="insert-pause-body">
                                <div class="insert-pause-field">
                                    <label class="insert-pause-label"><i class="el-icon-time"></i> 停顿时长</label>
                                    <el-input-number v-model="pausenum" :min="0" :max="pauseunit == 'ms' ? 5000 : 5"
                                        :step="pauseunit == 'ms' ? 50 : 0.25" controls-position="right" size="medium" class="insert-pause-input"></el-input-number>
                                </div>
                                <div class="insert-pause-field">
                                    <label class="insert-pause-label"><i class="el-icon-s-operation"></i> 单位</label>
                                    <el-radio-group v-model="pauseunit" class="insert-pause-unit">
                                        <el-radio-button label="s">秒</el-radio-button>
                                        <el-radio-button label="ms">毫秒</el-radio-button>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div slot="footer" class="insert-pause-footer">
                                <el-button icon="el-icon-close" @click="showpause = false">取消</el-button>
                                <el-button type="primary" icon="el-icon-check" @click="InsertBreak">确认插入</el-button>
                            </div>
                        </el-dialog>
                        <el-dialog :visible.sync="showTextEditorDialog" center :width="showwidth" custom-class="tts-editor-dialog" :close-on-click-modal="false">
                            <div slot="title" class="tts-editor-title">
                                <i class="el-icon-edit-outline"></i>
                                <span>编辑原文</span>
                            </div>
                            <el-input
                                v-model="voicevalue.wenben"
                                type="textarea"
                                resize="none"
                                class="tts-dialog-textarea"
                                :autosize="{ minRows: 20, maxRows: 24 }"
                                :placeholder="ttsTextareaPlaceholder"
                            />
                            <div slot="footer" class="tts-editor-footer">
                                <el-button icon="el-icon-close" @click="showTextEditorDialog = false">关闭</el-button>
                            </div>
                        </el-dialog>
                        <el-dialog :visible.sync="showFavoriteDialogueImportDialog" center :width="showwidth" custom-class="tts-editor-dialog" :close-on-click-modal="false">
                            <div slot="title" class="tts-editor-title">
                                <i class="el-icon-document-copy"></i>
                                <span>粘贴文案识别对话</span>
                            </div>
                            <el-input
                                v-model="favoriteDialogueDraft"
                                type="textarea"
                                resize="none"
                                class="tts-dialog-textarea"
                                :autosize="{ minRows: 20, maxRows: 24 }"
                                :placeholder="ttsTextareaPlaceholder"
                            />
                            <div slot="footer" class="tts-editor-footer">
                                <el-button icon="el-icon-document" @click="fillFavoriteDialogueTemplate">模板</el-button>
                                <el-button icon="el-icon-close" @click="showFavoriteDialogueImportDialog = false">取消</el-button>
                                <el-button type="primary" icon="el-icon-check" @click="confirmFavoriteDialogueImport">识别对话</el-button>
                            </div>
                        </el-dialog>
                        <el-dialog :visible.sync="showFavoriteDialogueEditDialog" center :width="showwidth" custom-class="tts-editor-dialog" :close-on-click-modal="false">
                            <div slot="title" class="tts-editor-title">
                                <i class="el-icon-edit"></i>
                                <span>编辑对话</span>
                            </div>
                            <el-input
                                v-model="favoriteDialogueEditText"
                                type="textarea"
                                resize="none"
                                class="tts-dialog-textarea"
                                :autosize="{ minRows: 20, maxRows: 24 }"
                                :placeholder="ttsTextareaPlaceholder"
                            />
                            <div slot="footer" class="tts-editor-footer">
                                <el-button icon="el-icon-close" @click="showFavoriteDialogueEditDialog = false">取消</el-button>
                                <el-button type="primary" icon="el-icon-check" @click="confirmFavoriteDialogueEdit">保存对话</el-button>
                            </div>
                        </el-dialog>
                        <div v-if="ttsReadMode === 'single'" class="tts-original-panel">
                            <textarea class="wenben" ref="wenben" v-model="voicevalue.wenben"
                                :placeholder="ttsTextareaPlaceholder"></textarea>
                            <p class="inputtext">您当前输入了<span
                                    style="color:red;font-size:18px">{{ voicevalue.wenben.length }}</span>个字符</p>
                        </div>
                        <div class="tts-segment-panel">
                            <div class="tts-segment-panel__toolbar">
                                <div class="tts-segment-panel__mode">
                                    <span class="tts-segment-panel__label">配音模式</span>
                                    <el-radio-group v-model="ttsReadMode" size="mini" @change="handleTtsReadModeChange">
                                        <el-radio-button label="single">单人配音</el-radio-button>
                                        <el-radio-button v-if="ttsEngine === 'azure'" label="favorite">多人配音</el-radio-button>
                                    </el-radio-group>
                                </div>
                                <div v-if="ttsEngine === 'volc'" class="tts-segment-panel__actions">
                                    <el-tag size="mini" type="warning">火山引擎当前先支持单人配音</el-tag>
                                </div>
                                <div v-if="ttsReadMode === 'favorite'" class="tts-segment-panel__actions">
                                    <el-button
                                        size="mini"
                                        type="primary"
                                        plain
                                        icon="el-icon-document-copy"
                                        @click="openFavoriteDialogueImportDialog"
                                    >{{ parsedTtsSegments.length ? '重新识别对话' : '粘贴文案识别对话' }}</el-button>
                                    <el-button
                                        v-if="parsedTtsSegments.length"
                                        size="mini"
                                        plain
                                        icon="el-icon-edit"
                                        @click="openFavoriteDialogueEditDialog"
                                    >编辑对话</el-button>
                                </div>
                            </div>
                            <div v-if="ttsReadMode === 'favorite'" class="tts-segment-panel__body">
                                <div v-if="parsedTtsSegments.length" class="tts-segment-panel__status">
                                    <span>已识别 {{ parsedTtsSegments.length }} 段对话</span>
                                    <span v-if="parsedFavoriteMatchedCount">匹配收藏 {{ parsedFavoriteMatchedCount }} 段</span>
                                    <span v-if="parsedFavoriteFallbackCount">默认配置 {{ parsedFavoriteFallbackCount }} 段</span>
                                    <span v-if="parsedFavoriteMissingCount" class="tts-segment-panel__warning">
                                        未匹配收藏 {{ parsedFavoriteMissingCount }} 段
                                    </span>
                                    <span v-if="parsedSegmentsDirty" class="tts-segment-panel__warning">原始文案已变化，请重新识别对话</span>
                                </div>
                                <div v-if="!parsedTtsSegments.length" class="tts-segment-panel__empty tts-segment-panel__empty--action">
                                    <el-button
                                        type="primary"
                                        round
                                        icon="el-icon-document-copy"
                                        @click="openFavoriteDialogueImportDialog"
                                    >粘贴文案识别对话</el-button>
                                    <p class="tts-segment-panel__empty-tip">把带角色前缀的文案粘贴进来，系统会自动按对话拆段。</p>
                                </div>
                                <div v-else-if="parsedTtsSegments.length" class="tts-segment-list">
                                    <div v-if="!favoriteList.length" class="tts-segment-panel__empty">
                                        当前还没有收藏配置，识别后也可以手动给每段选择“当前默认配置”。
                                    </div>
                                    <div v-for="segment in parsedTtsSegments" :key="segment.id" class="tts-segment-card">
                                        <div class="tts-segment-card__header">
                                            <div class="tts-segment-card__title-wrap">
                                                <span class="tts-segment-card__title">第 {{ segment.order }} 段</span>
                                                <span v-if="segment.detectedFavoriteName" class="tts-segment-card__speaker">前缀：{{ segment.detectedFavoriteName }}</span>
                                                <span v-if="segment.unmatchedFavoriteName" class="tts-segment-panel__warning tts-segment-card__speaker">
                                                    未找到收藏“{{ segment.unmatchedFavoriteName }}”
                                                </span>
                                            </div>
                                            <el-select
                                                v-model="segment.configKey"
                                                size="mini"
                                                class="tts-segment-card__select"
                                                @change="onParsedSegmentConfigChange(segment, $event)"
                                            >
                                                <el-option
                                                    v-for="option in favoriteVoiceConfigOptions"
                                                    :key="option.value"
                                                    :label="option.label"
                                                    :value="option.value"
                                                />
                                            </el-select>
                                        </div>
                                        <div class="tts-segment-card__content">{{ segment.text }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="ttsEngine === 'azure'" class="contenttext" v-show="ssmlactive == 'active'">
                        <textarea class="wenben" :value="getDataXML"></textarea>
                    </div>
                    <div v-if="ttsEngine === 'azure'" class="contenttext contenttext--live2d" v-show="live2dactive == 'active'">
                        <azure-tts-live2d-panel ref="live2dPanel" />
                    </div>
                </div>
            </div>

            <div class="right" v-loading="loading || rightParamsLoading || ttsBatchInProgress" :element-loading-text="rightPanelLoadingHint">
                <!-- 收藏 & 最近使用操作栏 -->
                <div class="voice-quick-actions" v-if="$store.state.user && ttsEngine === 'azure'">
                    <el-button size="mini" icon="el-icon-star-off" @click="addFavorite">收藏配置</el-button>
                    <el-dropdown trigger="click" @command="applyFavorite" v-if="favoriteList.length">
                        <el-button size="mini" icon="el-icon-star-on">我的收藏<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="fav in favoriteList" :key="fav.id" :command="fav">
                                <span>{{ fav.name }}</span>
                                <i class="el-icon-delete" style="margin-left:8px;color:#f56c6c" @click.stop="deleteFavorite(fav.id)"></i>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown trigger="click" @command="applyRecentVoice" v-if="recentVoiceList.length">
                        <el-button size="mini" icon="el-icon-time">最近使用<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="item in recentVoiceList" :key="item.id" :command="item">
                                {{ getRecentVoiceLabel(item) }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <el-collapse v-if="ttsEngine === 'azure'" accordion>
                    <el-collapse-item>
                        <template slot="title">
                            <span style="font-weight:bold"><i class="iconfont icon-duoyuyan"></i>语言:
                                {{ voicevalue.language.languagename }}</span>
                        </template>
                        <el-select v-model="voicevalue.language" class="select" value-key="ID">
                            <el-option v-for="item in languages" :key="item.id" :label="item.languagename"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-collapse-item>
                    <el-collapse-item>
                        <template slot="title">
                            <span style="font-weight:bold"><i class="iconfont icon-geren"></i>发音人:
                                {{ voicevalue.voice.voicename }} {{ voicevalue.style.stylename }}
                                {{ voicevalue.role.rolename }}</span>
                        </template>
                        <el-divider>请选择发音人</el-divider>
                        <div class="voice-picker-entry" @click="openVoicePickerDialog">
                            <div class="voice-picker-entry__main">
                                <div class="voice-picker-entry__label">发音人</div>
                                <div class="voice-picker-entry__value">
                                    {{ voicevalue.voice.voicename || '请选择发音人' }}
                                    <span v-if="voicevalue.voice.sex || voicevalue.voice.old" class="voice-picker-entry__meta">
                                        {{ voicevalue.voice.sex || '未知性别' }} / {{ voicevalue.voice.old || '未知年龄段' }}
                                    </span>
                                </div>
                            </div>
                            <div class="voice-picker-entry__actions">
                                <el-button size="mini" type="primary" plain icon="el-icon-headset" @click.stop="previewCurrentVoice">试听</el-button>
                                <i class="el-icon-arrow-right voice-picker-entry__arrow"></i>
                            </div>
                        </div>
                        <div class="myitemstyle">
                            <span class="tip">说话风格:</span>
                            <el-select v-model="voicevalue.style" value-key="id" class="styleselect">
                                <el-option v-for="item in styles" :key="item.id" :label="item.stylename" :value="item">
                                </el-option>
                            </el-select>
                            <span class="tip" v-if="styles.length >= 1">风格强度:</span>
                            <el-slider v-if="styles.length >= 1" class="styleslider" v-model="voicevalue.Stylestrength"
                                :max="200" :min="0"></el-slider>
                        </div>
                        <div class="myitem" v-if="roles.length > 0">
                            <div class="slidertip">角色扮演</div>
                            <el-select v-model="voicevalue.role" class="selectinner"
                                value-key="id">
                                <el-option v-for="item in roles" :key="item.id" :label="item.rolename" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item>
                        <template slot="title">
                            <span style="font-weight:bold"><i
                                    class="iconfont icon-24gl-volumeHigh"></i>音量：{{ voicevalue.volume }}(默认100)</span>
                        </template>
                        <el-slider class="slider" v-model="voicevalue.volume" :max="150" :min="1"></el-slider>
                        <div class="param-reset-row">
                            <el-button size="mini" plain icon="el-icon-refresh-left" @click.stop="resetVoiceParam('volume')">重置</el-button>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item>
                        <template slot="title">
                            <span style="font-weight:bold"><i
                                    class="iconfont icon-suduspeed8"></i>语速：{{ voicevalue.speech_rate }}(默认100)</span>
                        </template>
                        <el-slider class="slider" v-model="voicevalue.speech_rate" :max="200" :min="50"></el-slider>
                        <div class="param-reset-row">
                            <el-button size="mini" plain icon="el-icon-refresh-left" @click.stop="resetVoiceParam('speech_rate')">重置</el-button>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item>
                        <template slot="title">
                            <span style="font-weight:bold"><i
                                    class="iconfont icon-tiaojie"></i>语调：{{ voicevalue.pitch_rate }}(默认100)</span>
                        </template>
                        <el-slider class="slider" v-model="voicevalue.pitch_rate" :max="150" :min="50"></el-slider>
                        <div class="param-reset-row">
                            <el-button size="mini" plain icon="el-icon-refresh-left" @click.stop="resetVoiceParam('pitch_rate')">重置</el-button>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="背景音乐">
                        <template slot="title">
                            <span style="font-weight:bold"><i
                                    class="iconfont icon-yinleyinpin"></i>背景音乐：{{ backgroundMusicDisplayName }}</span>
                        </template>
                        <div class="musictip">提示：如果提供的背景音频短于文本转语音或淡出持续时间，则会循环该音频。
                            如果其长度超过文本转语音的持续时间，则它在完成淡出后将会停止。你可以在线预览系统背景音乐，也可以上传自己的 mp3/wav 文件。</div>
                        <div class="bgm-picker-card">
                            <div class="bgm-picker-card__main">
                                <div class="bgm-picker-card__label">当前背景音乐</div>
                                <div class="bgm-picker-card__value">{{ backgroundMusicDisplayName }}</div>
                            </div>
                            <div class="bgm-picker-card__actions">
                                <el-button type="primary" icon="el-icon-headset" @click="openBackgroundMusicDialog">选择背景音乐</el-button>
                                <el-button v-if="hasSelectedBackgroundMusic" icon="el-icon-refresh-left" @click="Resetmusic">重置</el-button>
                            </div>
                        </div>
                        <div v-if="hasSelectedBackgroundMusic" class="bgm-selected-tip">
                            已选背景音乐将参与 SSML 生成。当前设置：{{ backgroundMusicSettingsSummary }}。
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div v-else class="volc-control-panel">
                    <div class="volc-control-panel__title">火山引擎参数</div>
                    <div class="volc-control-panel__item">
                        <div class="volc-control-panel__voice-row">
                            <div class="slidertip slidetip--voice">发音人：</div>
                            <div class="volc-control-panel__voice-main">
                                <div class="voice-picker-entry voice-picker-entry--volc" @click="openVolcVoicePickerDialog">
                                    <div class="voice-picker-entry__main">
                                        <div class="voice-picker-entry__label">发音人</div>
                                        <div class="voice-picker-entry__value">
                                            {{ selectedVolcVoiceLabel }}
                                            <span v-if="selectedVolcVoiceHint" class="voice-picker-entry__meta">{{ selectedVolcVoiceHint }}</span>
                                        </div>
                                    </div>
                                    <div class="voice-picker-entry__actions">
                                        <el-button size="mini" type="primary" plain icon="el-icon-search">选择</el-button>
                                        <i class="el-icon-arrow-right voice-picker-entry__arrow"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="volc-control-panel__item">
                        <div class="volc-control-panel__slider-row">
                            <div class="slidertip"><i class="iconfont icon-suduspeed8"></i>语速：{{ Number(volcSpeedRatio || 1).toFixed(1) }}</div>
                            <el-slider class="slider" v-model="volcSpeedRatio" :max="3" :min="0.2" :step="0.1"></el-slider>
                        </div>
                    </div>
                    <div class="volc-control-panel__item">
                        <div class="volc-control-panel__slider-row">
                            <div class="slidertip"><i class="iconfont icon-24gl-volumeHigh"></i>音量：{{ Number(volcVolumeRatio || 1).toFixed(1) }}</div>
                            <el-slider class="slider" v-model="volcVolumeRatio" :max="3" :min="0.1" :step="0.1"></el-slider>
                        </div>
                    </div>
                    <div class="volc-control-panel__item">
                        <div class="volc-control-panel__slider-row">
                            <div class="slidertip"><i class="iconfont icon-tiaojie"></i>语调：{{ Number(volcPitchRatio || 1).toFixed(1) }}</div>
                            <el-slider class="slider" v-model="volcPitchRatio" :max="3" :min="0.1" :step="0.1"></el-slider>
                        </div>
                    </div>
                    <div class="volc-control-panel__tip">已按当前账号常见可用范围隐藏 24k 音色。</div>
                </div>
                <el-radio-group v-if="ttsEngine === 'azure'" v-model="voicevalue.format" class="btngroup">
                    <el-radio label="mp3"></el-radio>
                    <el-radio label="wav"></el-radio>
                </el-radio-group>
                <div v-else class="volc-format-tip">
                    <el-tag size="small" type="info">火山引擎当前固定输出 WAV</el-tag>
                </div>
                <div class="audiodiv">
                    <audio autoplay="autoplay" ref="audio" controls controlsList="nodownload" @ended="audioplayover" @play="onListAudioPlay" @pause="onListAudioPause"></audio>
                </div>
                <div class="btn">
                    <el-button class="buttonstyle" :type="btnAuditionstyle[btnAuditionstyleindex].btnstyle"
                        @click="Makevoice('Audition')" :icon="btnAuditionstyle[btnAuditionstyleindex].ico"
                        v-show="voicevalue.wenben.length > 50">{{ btnAuditionstyle[btnAuditionstyleindex].PlayBtnText }}
                    </el-button>
                    <el-button class="buttonstyle" :type="btnstyle[btnstyleindex].btnstyle" @click="Makevoice('play')"
                        :icon="btnstyle[btnstyleindex].ico">{{ btnstyle[btnstyleindex].PlayBtnText }}</el-button>
                    <el-tag v-if="isCurrentAudioDownloaded" type="success" size="small" class="downloaded-tag">已下载</el-tag>
                    <el-button class="buttonstyle" type="primary" @click="DownFile" icon="el-icon-download">{{ isCurrentAudioDownloaded ? '再次下载' : '下载音频' }}
                    </el-button>
                    <!-- <el-button class="buttonstyle" v-if="false" type="primary" v-clipboard:copy="copydata"
                        v-clipboard:error="onError" v-clipboard:success="onCopy" icon="el-icon-document-copy">复制链接
                    </el-button> -->
                </div>
                <div v-if="$store.state.miniProgramCoinFeatureEnabled" class="mini-program-free-tip">
                    <div class="mini-program-free-tip__badge">免费通道</div>
                    <i class="el-icon-mobile-phone"></i>
                    <div class="mini-program-free-tip__content">
                        <div class="mini-program-free-tip__title">{{ miniProgramTitle }}可免费生成音频</div>
                        <div class="mini-program-free-tip__desc">不扣金币，账号互通，扫码进入后可直接使用。</div>
                    </div>
                    <button type="button" class="mini-program-free-tip__link" @click="openMiniProgramGuide">立即前往</button>
                </div>
            </div>
            </div>
            <div class="synth-progress-strip" v-show="synthProgressStripVisible">
                <el-progress :percentage="synthProgressRounded" :stroke-width="12" :status="synthProgressBarStatus" />
                <p v-if="synthEtaHint" class="synth-eta-hint">{{ synthEtaHint }}</p>
            </div>
        </div>
        <div  v-loading="pingjieloading" class="record-table-wrap">
            <div class="record-table-tip">
                <i class="el-icon-info"></i>
                <span>默认只显示最近生成的10条音频</span>
            </div>
            <div class="record-search-bar">
                <el-input
                    v-model="recordSearchKeyword"
                    placeholder="搜索内容（从数据库查询）"
                    prefix-icon="el-icon-search"
                    clearable
                    class="record-search-input"
                />
                <el-date-picker
                    v-model="recordSearchStartDate"
                    type="date"
                    placeholder="起始日期"
                    value-format="yyyy-MM-dd"
                    clearable
                    class="record-search-date"
                />
                <el-date-picker
                    v-model="recordSearchEndDate"
                    type="date"
                    placeholder="终止日期"
                    value-format="yyyy-MM-dd"
                    clearable
                    class="record-search-date"
                />
                <div class="record-search-actions">
                    <el-button type="primary" icon="el-icon-search" class="record-search-btn" @click="doRecordSearch">搜索</el-button>
                    <el-button class="record-reset-btn" @click="resetRecordList">恢复默认</el-button>
                    <el-button type="success" icon="el-icon-download" size="small" @click="exportExcel">导出Excel</el-button>
                </div>
            </div>
            <el-table v-if="showTypeColumn" :max-height="400"   highlight-current-row  @current-change="handleCurrentChange" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"   @selection-change="handleSelectionChange">
                <template slot="empty">
                    <p class="record-table-empty">{{ hasSearchParams ? '无匹配记录' : '暂无数据，生成音频后会显示在这里' }}</p>
                </template>
                <el-table-column type="selection" :width="selectionColWidth" :show-overflow-tooltip="false" class-name="col-selection">  </el-table-column>
                <el-table-column label="内容" :show-overflow-tooltip="false" class-name="col-content" min-width="200">
                    <template slot-scope="scope">
                        <span class="col-content-text">{{ scope.row.data || '' }}</span>
                    </template>
                </el-table-column>           
                <el-table-column v-if="showTypeColumn" label="类型" width="100">
                    <template slot-scope="scope">
                        <span >{{ scope.row.maketype==="Audition" ? '试听' : scope.row.maketype==="Splice" ? '拼接音频' : '完整音频' }}</span>
                    </template>
                </el-table-column>    
                <el-table-column :label="datetimeColLabel" :width="datetimeColWidth" class-name="col-datetime">
                    <template slot-scope="scope">
                        <i class="el-icon-time record-time-icon"></i>
                        <span class="record-time-text">{{ formatRecordDate(scope.row.datetime, !showTypeColumn) }}</span>
                    </template>
                </el-table-column>
                <el-table-column  label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag v-if="downloadedFileIds.indexOf(scope.row.filename) >= 0" type="success" size="mini">已下载</el-tag>
                        <span v-else class="status-pending">—</span>
                    </template>
                </el-table-column>
                <el-table-column  label="播放"  width="80">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" :type="isListRowPlaying(scope.row) && !listAudioPaused ? 'warning' : 'primary'" :icon="isListRowPlaying(scope.row) && !listAudioPaused ? 'el-icon-video-pause' : 'el-icon-video-play'">{{ isListRowPlaying(scope.row) && !listAudioPaused ? '暂停' : '播放' }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="下载"  width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="downloadoldmusic(scope.$index, scope.row)" type="primary">{{ downloadedFileIds.indexOf(scope.row.filename) >= 0 ? '再次下载' : '下载' }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="删除"  width="80">
                    <template slot-scope="scope">
                        <el-button  size="mini" @click="deleteoldmusic(scope.$index, scope.row)" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="!showTypeColumn" class="record-card-list">
                <p v-if="!tableData.length" class="record-table-empty">{{ hasSearchParams ? '无匹配记录' : '暂无数据，生成音频后会显示在这里' }}</p>
                <div v-for="(row, index) in tableData" :key="row.filename || index" class="record-card" :class="{ 'record-card-current': row.filename === currentRecordFilename }" @click="selectRecordCard(row)">
                    <div class="record-card-head">
                        <el-checkbox :value="isCardSelected(row)" @change="(v) => toggleCardSelection(row, v)" class="record-card-checkbox"></el-checkbox>
                        <span class="record-card-time">{{ formatRecordDate(row.datetime, false) }}</span>
                        <el-tag size="mini" type="info" class="record-card-type">{{ row.maketype === 'Audition' ? '试听' : row.maketype === 'Splice' ? '拼接音频' : '完整音频' }}</el-tag>
                        <el-tag v-if="downloadedFileIds.indexOf(row.filename) >= 0" type="success" size="mini">已下载</el-tag>
                        <span v-else class="status-pending">—</span>
                    </div>
                    <div class="record-card-content">{{ row.data || '' }}</div>
                    <div class="record-card-actions">
                        <el-button size="mini" @click="handleEdit(index, row)" :type="isListRowPlaying(row) && !listAudioPaused ? 'warning' : 'primary'" :icon="isListRowPlaying(row) && !listAudioPaused ? 'el-icon-video-pause' : 'el-icon-video-play'">{{ isListRowPlaying(row) && !listAudioPaused ? '暂停' : '播放' }}</el-button>
                        <el-button size="mini" @click="downloadoldmusic(index, row)" type="primary">{{ downloadedFileIds.indexOf(row.filename) >= 0 ? '再次下载' : '下载' }}</el-button>
                        <el-button size="mini" @click="deleteoldmusic(index, row)" type="danger">删除</el-button>
                    </div>
                </div>
            </div>
            <div v-if="tableData.length" class="splice-btns">
                <el-button class="splice-btn" type="primary" @click="splicemusic">拼接选中的文件</el-button>
                <el-button class="splice-btn" type="danger" icon="el-icon-delete" @click="deleteSelectedRecords">删除</el-button>
            </div>
        </div>
        <div class="toptip">
            <div class="toptip-section">
                <button type="button" class="toptip-toggle" @click="showUsageTipsExpanded = !showUsageTipsExpanded">
                    <span class="toptip-toggle__main">
                        <span class="toptip-toggle__title">温馨提示</span>
                        <span class="toptip-toggle__hint">下载前建议先试听，手机微信内仅支持播放。</span>
                    </span>
                    <i :class="showUsageTipsExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </button>
                <div v-show="showUsageTipsExpanded" class="toptip-body">
                    <div class="tishitip">1.如果您是通过手机微信、手机旺旺聊天窗口打开的本系统，生成的音频<span>只能播放，不能下载</span>，请更换浏览器后再生成语音</div>
                    <div class="tishitip">2.点击播放按钮后系统会从微软服务器将文字转成语音数据，会有一定的延时，延时的时间长短和文字数量、网速、本系统同时使用的人数有关系</div>
                    <div class="tishitip">3.<span>请先播放音频，播放后再点击下载音频</span></div>
                    <div class="tishitip">4.<span>如果要生成超过50个字符的音频，为了节约资源，请先试听，试听没有问题后再播放音频,然后再下载</span></div>
                </div>
            </div>
            <div class="toptip-section">
                <button type="button" class="toptip-toggle" @click="showLimitTipsExpanded = !showLimitTipsExpanded">
                    <span class="toptip-toggle__main">
                        <span class="toptip-toggle__title">相关限制</span>
                        <span class="toptip-toggle__hint">单段最多 2500 字，超出会自动拆分后拼接。</span>
                    </span>
                    <i :class="showLimitTipsExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </button>
                <div v-show="showLimitTipsExpanded" class="toptip-body">
                    <div class="tishitip">
                        单次合成每段不超过2500字；超过则自动拆成多段依次提交 Azure，每段按字数扣金币，全部成功后服务器自动拼接为一条完整音频并加入列表（拼接不另扣金币）。单次总字数上限约 {{ ttsMaxCharsHint }} 字。
                    </div>
                </div>
            </div>
            <div class="toptip-section">
                <button type="button" class="toptip-toggle" @click="showBrowserTipsExpanded = !showBrowserTipsExpanded">
                    <span class="toptip-toggle__main">
                        <span class="toptip-toggle__title">浏览器支持情况</span>
                        <span class="toptip-toggle__hint">电脑端基本都支持，遇到兼容问题可直接联系我们。</span>
                    </span>
                    <i :class="showBrowserTipsExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </button>
                <div v-show="showBrowserTipsExpanded" class="toptip-body">
                    <div class="tishitip">本系统在电脑上支持几乎所有的浏览器，如果有哪个浏览器不支持，请您<el-link @click="$store.commit('SetOpenContactDialog', true)" type="primary">联系我们
                        </el-link>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="showmp" :width="showwidth" center class="mini-program-guide-dialog">
            <div slot="title" class="mini-program-guide-title">
                <i class="el-icon-mobile-phone"></i>
                <span>小程序免费生成</span>
            </div>
            <div class="mini-program-guide-body">
                <div class="mini-program-guide-tip">
                    <i class="el-icon-present"></i>
                    <span>微信扫码进入{{ miniProgramTitle }}，生成音频免费，不扣金币。</span>
                </div>
                <div class="mini-program-guide-qr-wrap">
                    <img class="mini-program-guide-qr" :src="miniProgramGuideQr" alt="小程序二维码">
                </div>
                <p class="mini-program-guide-note">网站和小程序共用同一账号。</p>
                <div class="dialog-footer">
                    <el-button type="primary" @click="showmp = false">我知道了</el-button>
                </div>
            </div>
        </el-dialog>
        <VoicePickerDialog
            :visible.sync="showVoicePickerDialog"
            :voices="voices"
            :selected-voice-key="selectedVoicePickerKey"
            :previewing-voice-key="voicePreviewingKey"
            :preview-loading-key="voicePreviewLoadingKey"
            :preview-progress="voicePreviewProgress"
            :current-voice-name="voicevalue.voice.voicename || ''"
            @preview="handleVoicePreview"
            @confirm="applyVoiceSelection"
            @close="handleVoicePickerClosed"
        />
        <VolcVoicePickerDialog
            :visible.sync="showVolcVoicePickerDialog"
            :voices="volcVoiceOptions"
            :selected-voice-value="volcVoiceType"
            :previewing-voice-key="volcVoicePreviewingKey"
            :preview-loading-key="volcVoicePreviewLoadingKey"
            :preview-progress="volcVoicePreviewProgress"
            :current-voice-name="selectedVolcVoiceLabel"
            @preview="handleVolcVoicePreview"
            @confirm="applyVolcVoiceSelection"
            @close="handleVolcVoicePickerClosed"
        />
        <!-- 下载前未登录提示：须先登录或注册后才能下载 -->
        <el-dialog title="下载提示" :visible.sync="showLoginPrompt" :width="showwidth" center>
            <p class="qqtext">请先登录或注册后再下载音频。登录用户可享受免费下载额度（注册即送10金币）。下载按字数扣金币：每500字1金币，不足500按500算。</p>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="goLoginFromPrompt">去登录</el-button>
                <el-button type="primary" @click="goRegisterFromPrompt">去注册</el-button>
                <el-button @click="showLoginPrompt = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 选择下载方式：复用统一组件 -->
        <CoinChoiceDialog
            :visible.sync="showCoinChoiceDialog"
            :dialog-title="coinChoiceDialogTitle"
            title-icon="el-icon-download"
            :char-count="pendingDownloadCharCount"
            :coins-required="downloadCoinsRequired"
            :rule-text="coinChoiceRuleText"
            :primary-button-text="coinChoicePrimaryText"
            :char-label="pendingDownloadType === '拼接音频' ? '' : '约 '"
            :show-mini-program-option="$store.state.miniProgramCoinFeatureEnabled"
          
            @use-coin="chooseUseCoin"
            @watch-video="chooseWatchVideo"
            @open-mini-program="openMiniProgramGuide"
            @pay-direct="choosePayDirect"
        />
        <el-dialog :visible.sync="showcode" :width="showwidth" center class="verify-code-dialog" :show-close="true">
            <div slot="title" class="verify-code-dialog-title">
                <i class="el-icon-message"></i>
                <span>输入验证码</span>
            </div>
            <div class="verify-code-body">
                <div class="verify-code-tip">
                    <i class="el-icon-info"></i>
                    <span>请用手机微信扫描下方二维码获取验证码，登录用户可通过看视频赚金币</span>
                </div>
                <div class="verify-code-qr-wrap">
                    <img class="verify-code-qr" src="@/assets/code.png" alt="扫码获取验证码">
                </div>
                <div class="verify-code-input-wrap">
                    <label class="verify-code-label">验证码</label>
                    <el-input v-model="inputcode" maxlength="6" show-word-limit placeholder="请输入6位验证码" clearable size="medium" class="verify-code-input"></el-input>
                </div>
            </div>
            <div slot="footer" class="verify-code-footer">
                <el-button v-if="codetype !== '赚金币'" type="danger" icon="el-icon-wallet" @click="alipay">支付后直接下载</el-button>
                <el-button type="primary" icon="el-icon-check" @click="checkcode">确 定</el-button>
                <el-button @click="showcode = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 购买金币 -->
        <el-dialog :visible.sync="showBuyCoinsDialog" width="420px" center class="buy-coins-dialog">
            <div slot="title" class="buy-coins-dialog-title">
                <i class="el-icon-coin"></i>
                <span>购买金币</span>
            </div>
            <div class="buy-coins-body">
                <div class="buy-coins-field">
                    <label class="buy-coins-label">购买数量</label>
                    <el-input-number v-model="buyCoinsCount" :min="10" :max="9999" controls-position="right" class="buy-coins-input"></el-input-number>
                </div>
                <div class="buy-coins-summary">
                    <div class="buy-coins-row">
                        <span class="buy-coins-desc">单价</span>
                        <span class="buy-coins-price">{{ pricePerCoin }} 元/金币</span>
                    </div>
                    <div class="buy-coins-row total">
                        <span class="buy-coins-desc">应付金额</span>
                        <span class="buy-coins-amount">{{ buyPaymentAmount }} 元</span>
                    </div>
                    <div class="buy-coins-row">
                        <span class="buy-coins-desc">支付方式</span>
                        <el-radio-group v-model="buyCoinsPayType" size="small">
                            <el-radio-button label="alipay">支付宝</el-radio-button>
                            <el-radio-button label="wechat">微信支付</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div class="buy-coins-footer">
                    <el-button type="primary" icon="el-icon-wallet" @click="confirmBuyCoins" class="buy-coins-btn">确认支付</el-button>
                    <el-button @click="showBuyCoinsDialog = false">取 消</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog center :before-close="function(){}" :show-close="false" :destroy-on-close="true" :visible.sync="dialogTableVisible" width="680px">
            <pay :img="qrimg" :money="money" :paytype="currentPayType"></pay>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="paystatus" plain >已完成支付</el-button>
              <el-button type="info" @click="paystatus" plain >支付遇到问题</el-button>
            </span>
          </el-dialog>

        <!-- 百度网盘免费下载：等待弹窗（居中小弹窗） -->
        <el-dialog
            :visible.sync="showBaiduPanLoadingDialog"
            width="420px"
            center
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            custom-class="baidu-pan-dialog"
        >
            <div slot="title" class="baidu-pan-loading-title">
                <div class="baidu-pan-title-icon" :class="{ success: !!baiduPanShareUrl }">
                    <i v-if="!baiduPanShareUrl" class="el-icon-loading"></i>
                    <i v-else class="el-icon-success"></i>
                </div>
                <div class="baidu-pan-title-text">
                    <div class="baidu-pan-title-main">{{ baiduPanShareUrl ? '分享链接已生成' : '百度网盘免费下载' }}</div>
                    <div class="baidu-pan-title-sub">{{ baiduPanShareUrl ? '可复制或点击下载打开' : '正在为你处理，请稍候…' }}</div>
                </div>
            </div>
            <div class="baidu-pan-loading-body">
                <div class="baidu-pan-status">
                    <i v-if="!baiduPanShareUrl" class="el-icon-loading baidu-pan-status-icon"></i>
                    <i v-else class="el-icon-success baidu-pan-status-icon success"></i>
                    <span class="baidu-pan-status-text">{{ baiduPanLoadingBody }}</span>
                </div>

                <div v-if="baiduPanShareUrl" class="baidu-pan-result">
                    <div class="baidu-pan-field">
                        <div class="baidu-pan-label">分享链接</div>
                        <el-input :value="baiduPanShareUrl" size="small" readonly></el-input>
                    </div>
                    <div v-if="baiduPanSharePwd" class="baidu-pan-field">
                        <div class="baidu-pan-label">提取码（已填好）</div>
                        <el-input :value="baiduPanSharePwd" size="small" readonly></el-input>
                    </div>
                    <div class="baidu-pan-actions">
                        <el-button type="primary" size="small" @click="openBaiduPanShareUrl">点击下载</el-button>
                        <el-button size="small" @click="copyBaiduPanShareText">复制整段内容</el-button>
                        <el-button size="small" @click="showBaiduPanLoadingDialog=false">关闭</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- :src="datapath" -->

        <!-- 文本模板选择弹窗 -->
        <el-dialog :visible.sync="showTemplateDialog" :width="showwidth" center custom-class="tpl-dialog">
            <div slot="title" class="tpl-dialog-title"><i class="el-icon-document"></i> 文本模板</div>
            <div v-if="templateList.length === 0" class="tpl-empty">暂无模板</div>
            <div v-else>
                <el-radio-group v-model="templateCategory" size="small" style="margin-bottom:12px">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button v-for="cat in templateCategories" :key="cat" :label="cat">{{ cat }}</el-radio-button>
                </el-radio-group>
                <div class="tpl-list-scroll">
                    <div v-for="tpl in filteredTemplates" :key="tpl.id" class="tpl-card" @click="useTemplate(tpl)">
                        <div class="tpl-card-title">{{ tpl.title }}</div>
                        <div class="tpl-card-preview">{{ (tpl.content || '').slice(0, 100) }}{{ (tpl.content || '').length > 100 ? '...' : '' }}</div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="showBackgroundMusicDialog"
            :width="backgroundMusicDialogWidth"
            center
            custom-class="bgm-dialog"
            @close="closeBackgroundMusicDialog"
        >
            <div slot="title" class="bgm-dialog-title">
                <i class="el-icon-headset"></i>
                <span>选择背景音乐</span>
            </div>
            <div class="bgm-dialog-toolbar">
                <div class="bgm-dialog-toolbar__left">
                    <div class="bgm-dialog-toolbar__label">系统曲库</div>
                    <el-radio-group
                        v-if="musicTypes.length"
                        v-model="activeMusicType"
                        size="small"
                        class="bgm-type-group"
                        @change="handleBackgroundMusicTypeChange"
                    >
                        <el-radio-button v-for="type in musicTypes" :key="type" :label="type">{{ type }}</el-radio-button>
                    </el-radio-group>
                    <div v-else class="bgm-empty-state">暂无系统背景音乐</div>
                </div>
                <div class="bgm-dialog-toolbar__right">
                    <el-upload
                        class="bgm-upload"
                        :action="backgroundUploadAction"
                        accept="audio/mpeg,audio/wav"
                        :show-file-list="false"
                        :before-upload="beforeBackgroundUpload"
                        :on-success="handleBackgroundUploadSuccess"
                        :on-error="handleBackgroundUploadError"
                    >
                        <el-button type="primary" plain icon="el-icon-upload2">上传自己的背景音乐</el-button>
                    </el-upload>
                </div>
            </div>
            <div class="bgm-dialog-body">
                <div class="bgm-dialog-library">
                    <div class="bgm-dialog-list">
                        <div v-if="backgroundMusicList.length === 0" class="bgm-empty-state">当前分类暂无可用背景音乐</div>
                        <div
                            v-for="item in backgroundMusicList"
                            :key="item.value"
                            class="bgm-item"
                            :class="{ active: isBackgroundMusicSelected(item) }"
                        >
                            <div class="bgm-item__main" @click="selectBackgroundMusic(item)">
                                <div class="bgm-item__name">{{ item.text }}</div>
                                <div class="bgm-item__meta">{{ item.type || '背景音乐' }}</div>
                            </div>
                            <div class="bgm-item__actions">
                                <el-tag v-if="isBackgroundMusicSelected(item)" size="mini" type="success">已选中</el-tag>
                                <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    :icon="isPreviewingBackgroundMusic(item) ? 'el-icon-video-pause' : 'el-icon-video-play'"
                                    @click.stop="toggleBackgroundMusicPreview(item)"
                                >{{ isPreviewingBackgroundMusic(item) ? '停止' : '试听' }}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bgm-dialog-side">
                    <div class="bgm-dialog-current">
                        <span class="bgm-dialog-current__label">当前已选：</span>
                        <span class="bgm-dialog-current__value">{{ backgroundMusicDisplayName }}</span>
                    </div>
                    <div v-if="hasSelectedBackgroundMusic" class="bgm-dialog-settings">
                        <div class="bgm-dialog-settings__title">当前背景音乐参数</div>
                        <div class="bgm-dialog-settings__row">
                            <div class="bgm-dialog-settings__label">音量：{{ voicevalue.backgroundaudio.volume / 10 }}（默认 0.2）</div>
                            <el-slider
                                v-model="voicevalue.backgroundaudio.volume"
                                :format-tooltip="val => val / 10"
                                :max="100"
                                :min="0"
                            ></el-slider>
                        </div>
                        <div class="bgm-dialog-settings__row">
                            <div class="bgm-dialog-settings__label">淡入持续时间：{{ voicevalue.backgroundaudio.fadein }} 毫秒</div>
                            <el-slider
                                v-model="voicevalue.backgroundaudio.fadein"
                                :max="10000"
                                :min="0"
                            ></el-slider>
                        </div>
                        <div class="bgm-dialog-settings__row">
                            <div class="bgm-dialog-settings__label">淡出持续时间：{{ voicevalue.backgroundaudio.fadeout }} 毫秒</div>
                            <el-slider
                                v-model="voicevalue.backgroundaudio.fadeout"
                                :max="10000"
                                :min="0"
                            ></el-slider>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="hasSelectedBackgroundMusic" icon="el-icon-refresh-left" @click="Resetmusic">重置背景音乐</el-button>
                <el-button @click="showBackgroundMusicDialog = false">关闭</el-button>
                <el-button type="primary" icon="el-icon-check" @click="confirmBackgroundMusicSelection">确认使用</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import pay from './pay.vue'
import CoinChoiceDialog from './CoinChoiceDialog.vue'
import AzureTtsLive2dPanel from './AzureTtsLive2dPanel.vue'
import VoicePickerDialog from './VoicePickerDialog.vue'
import VolcVoicePickerDialog from './VolcVoicePickerDialog.vue'
import * as XLSX from 'xlsx'
import { MINIPROGRAM_TTS_QR_IMAGE, MINIPROGRAM_WIDGET_TITLE } from '@/config'

const TTS_PLAY_CHUNK_SIZE = 2500
const TTS_PLAY_MAX_CHUNKS = 40
const VOLC_SCENARIO_CATEGORY_ORDER = [
    '通用',
    '趣味',
    '新闻播报',
    '广告/短视频',
    '多语种场景',
    '超自然音色',
    '短视频玩法',
    '教育/陪伴'
]
const VOLC_DEFAULT_VOICE_OPTIONS = [
    { label: '中文 / 灿灿 2.0', value: 'BV700_V2_streaming' },
    { label: '中文 / 炀炀', value: 'BV705_streaming' },
    { label: '中文 / 擎苍 2.0', value: 'BV701_V2_streaming' },
    { label: '中文 / 通用女声 2.0', value: 'BV001_V2_streaming' },
    { label: '中文 / 灿灿', value: 'BV700_streaming' },
    { label: '中文 / 超自然音色-梓梓 2.0', value: 'BV406_V2_streaming' },
    { label: '中文 / 超自然音色-梓梓', value: 'BV406_streaming' },
    { label: '中文 / 超自然音色-燃燃 2.0', value: 'BV407_V2_streaming' },
    { label: '中文 / 超自然音色-燃燃', value: 'BV407_streaming' },
    { label: '中文 / 通用女声', value: 'BV001_streaming' },
    { label: '中文 / 通用男声', value: 'BV002_streaming' },
    { label: '中文 / 擎苍', value: 'BV701_streaming' },
    { label: '中文 / 阳光青年', value: 'BV123_streaming' },
    { label: '中文 / 反卷青年', value: 'BV120_streaming' },
    { label: '中文 / 通用赘婿', value: 'BV119_streaming' },
    { label: '中文 / 古风少御', value: 'BV115_streaming' },
    { label: '中文 / 霸气青叔', value: 'BV107_streaming' },
    { label: '中文 / 质朴青年', value: 'BV100_streaming' },
    { label: '中文 / 温柔淑女', value: 'BV104_streaming' },
    { label: '中文 / 开朗青年', value: 'BV004_streaming' },
    { label: '中文 / 甜宠少御', value: 'BV113_streaming' },
    { label: '中文 / 儒雅青年', value: 'BV102_streaming' },
    { label: '中文 / 甜美小源', value: 'BV405_streaming' },
    { label: '中文 / 亲切女声', value: 'BV007_streaming' },
    { label: '中文 / 知性女声', value: 'BV009_streaming' },
    { label: '中文 / 诚诚', value: 'BV419_streaming' },
    { label: '中文 / 童童', value: 'BV415_streaming' },
    { label: '中文 / 亲切男声', value: 'BV008_streaming' },
    { label: '中文 / 译制片男声', value: 'BV408_streaming' },
    { label: '中文 / 懒小羊', value: 'BV426_streaming' },
    { label: '中文 / 清新文艺女声', value: 'BV428_streaming' },
    { label: '中文 / 鸡汤女声', value: 'BV403_streaming' },
    { label: '中文 / 智慧老者', value: 'BV158_streaming' },
    { label: '中文 / 慈爱姥姥', value: 'BV157_streaming' },
    { label: '中文 / 说唱小哥', value: 'BR001_streaming' },
    { label: '中文 / 活力解说男', value: 'BV410_streaming' },
    { label: '中文 / 影视解说小帅', value: 'BV411_streaming' },
    { label: '中文 / 解说小帅-多情感', value: 'BV437_streaming' },
    { label: '中文 / 影视解说小美', value: 'BV412_streaming' },
    { label: '中文 / 纨绔青年', value: 'BV159_streaming' },
    { label: '中文 / 直播一姐', value: 'BV418_streaming' },
    { label: '中文 / 沉稳解说男', value: 'BV142_streaming' },
    { label: '中文 / 潇洒青年', value: 'BV143_streaming' },
    { label: '中文 / 阳光男声', value: 'BV056_streaming' },
    { label: '中文 / 活泼女声', value: 'BV005_streaming' },
    { label: '中文 / 小萝莉', value: 'BV064_streaming' },
    { label: '中文 / 奶气萌娃', value: 'BV051_streaming' },
    { label: '中文 / 动漫海绵', value: 'BV063_streaming' },
    { label: '中文 / 动漫海星', value: 'BV417_streaming' },
    { label: '中文 / 动漫小新', value: 'BV050_streaming' },
    { label: '中文 / 天才童声', value: 'BV061_streaming' },
    { label: '中文 / 促销男声', value: 'BV401_streaming' },
    { label: '中文 / 促销女声', value: 'BV402_streaming' },
    { label: '中文 / 磁性男声', value: 'BV006_streaming' },
    { label: '中文 / 新闻女声', value: 'BV011_streaming' },
    { label: '中文 / 新闻男声', value: 'BV012_streaming' },
    { label: '中文 / 知性姐姐-双语', value: 'BV034_streaming' },
    { label: '中文 / 温柔小哥', value: 'BV033_streaming' },
    { label: '英语 / 慵懒女声-Ava', value: 'BV511_streaming' },
    { label: '英语 / 议论女声-Alicia', value: 'BV505_streaming' },
    { label: '英语 / 情感女声-Lawrence', value: 'BV138_streaming' },
    { label: '英语 / 美式女声-Amelia', value: 'BV027_streaming' },
    { label: '英语 / 讲述女声-Amanda', value: 'BV502_streaming' },
    { label: '英语 / 活力女声-Ariana', value: 'BV503_streaming' },
    { label: '英语 / 活力男声-Jackson', value: 'BV504_streaming' },
    { label: '多语种 / 天才少女', value: 'BV421_streaming' },
    { label: '多语种 / Stefan', value: 'BV702_streaming' },
    { label: '英语 / 天真萌娃-Lily', value: 'BV506_streaming' },
    { label: '英语 / 亲切女声-Anna', value: 'BV040_streaming' },
    { label: '英语 / 澳洲男声-Henry', value: 'BV516_streaming' },
    { label: '日语 / 元气少女', value: 'BV520_streaming' },
    { label: '日语 / 萌系少女', value: 'BV521_streaming' },
    { label: '日语 / 气质女声', value: 'BV522_streaming' },
    { label: '日语 / 日语男声', value: 'BV524_streaming' },
    { label: '葡语 / 活力男声Carlos（巴西）', value: 'BV531_streaming' },
    { label: '葡语 / 活力女声（巴西）', value: 'BV530_streaming' },
    { label: '西语 / 气质御姐（墨西哥）', value: 'BV065_streaming' },
    { label: '方言 / 东北老铁', value: 'BV021_streaming' },
    { label: '方言 / 东北丫头', value: 'BV020_streaming' },
    { label: '方言 / 方言灿灿', value: 'BV704_streaming' },
    { label: '方言 / 西安佟掌柜', value: 'BV210_streaming' },
    { label: '方言 / 沪上阿姐', value: 'BV217_streaming' },
    { label: '方言 / 广西表哥', value: 'BV213_streaming' },
    { label: '方言 / 甜美台妹', value: 'BV025_streaming' },
    { label: '方言 / 台普男声', value: 'BV227_streaming' },
    { label: '方言 / 港剧男神', value: 'BV026_streaming' },
    { label: '方言 / 广东女仔', value: 'BV424_streaming' },
    { label: '方言 / 相声演员', value: 'BV212_streaming' },
    { label: '方言 / 重庆小伙', value: 'BV019_streaming' },
    { label: '方言 / 四川甜妹儿', value: 'BV221_streaming' },
    { label: '方言 / 重庆幺妹儿', value: 'BV423_streaming' },
    { label: '方言 / 乡村企业家', value: 'BV214_streaming' },
    { label: '方言 / 湖南妹坨', value: 'BV226_streaming' },
    { label: '方言 / 长沙靓女', value: 'BV216_streaming' },
    { label: '24k / 灿灿', value: 'BV700_24k_streaming' },
    { label: '24k / 擎苍', value: 'BV701_24k_streaming' },
    { label: '24k / 通用女声', value: 'BV001_24k_streaming' },
    { label: '24k / 通用男声', value: 'BV002_24k_streaming' },
    { label: '24k / 甜美小源', value: 'BV405_24k_streaming' },
    { label: '24k / 懒小羊', value: 'BV426_24k_streaming' },
    { label: '24k / 小萝莉', value: 'BV064_24k_streaming' },
    { label: '24k / 超自然音色-梓梓', value: 'BV406_24k_streaming' },
    { label: '24k / 超自然音色-燃燃', value: 'BV407_24k_streaming' },
    { label: '24k / 天才童声', value: 'BV061_24k_streaming' },
    { label: '24k / 儒雅青年', value: 'BV102_24k_streaming' },
    { label: '24k / 开朗青年', value: 'BV004_24k_streaming' },
    { label: '24k / 阳光青年', value: 'BV123_24k_streaming' },
    { label: '24k / 霸气青叔', value: 'BV107_24k_streaming' },
    { label: '24k / 知性女声', value: 'BV009_24k_streaming' },
    { label: '24k / 质朴青年', value: 'BV100_24k_streaming' },
    { label: '24k / 甜宠少御', value: 'BV113_24k_streaming' },
    { label: '24k / 古风少御', value: 'BV115_24k_streaming' },
    { label: '24k / 通用赘婿', value: 'BV119_24k_streaming' },
    { label: '24k / 反卷青年', value: 'BV120_24k_streaming' },
    { label: '24k / 活力女声-Ariana', value: 'BV503_24k_streaming' },
    { label: '24k / 情感女声-Lawrence', value: 'BV138_24k_streaming' }
]

export default {
    name: "AzureTts",

    data() {
        return {
            pingjieloading:false,
            dialogTableVisible:false,
            money:0.1,
            qrimg:"",
            xuanzhongindex:-1,
            row:{},
            havecode:false,
            inputcode:"",
            showcode:false,
            showmp:false,
            showTypeColumn: true,
            ttsEngine: 'azure',
            tableData: [],
            recordSearchKeyword: '',
            recordSearchStartDate: null,
            recordSearchEndDate: null,
            currentRecordFilename: null,
            multipleSelection:[],
            sex: "",
            old: "",
            copydata: "",
            showwidth: '80vw',
            pauseunit: "ms",
            pausenum: 0,
            showpause: false,
            break: "<break time='20ms' />",
            paymentOrderNo: "",
            currentPayType: 'alipay',
            buyCoinsPayType: 'alipay',
            voicetext: "",
            uploadfilename: "",
            showBackgroundMusicDialog: false,
            allBackgroundMusic: [],
            backgroundMusicList: [],
            activeMusicType: '',
            backgroundMusicPreviewUrl: '',
            backgroundMusicPreviewName: '',
            volcVoiceType: '',
            volcVoiceOptions: [],
            volcSpeedRatio: 1,
            volcVolumeRatio: 1,
            volcPitchRatio: 1,
            btnstyle: [{
                btnstyle: "primary",
                PlayBtnText: '播放音频',
                ico: "el-icon-video-play"
            },
            {
                btnstyle: "info",
                PlayBtnText: '暂停播放',
                ico: "el-icon-video-pause"
            },
            ],
            btnstyleindex: 0,

            btnAuditionstyle: [{
                btnstyle: "primary",
                PlayBtnText: '试听音频',
                ico: "el-icon-headset"
            },
            {
                btnstyle: "info",
                PlayBtnText: '暂停播放',
                ico: "el-icon-video-pause"
            },
            ],
            btnAuditionstyleindex: 0,

            totalnum: 250000,
            loading: false,
            /** 长文本分段合成期间保持右侧遮罩（makeaudio 会清 loading，故单独用此标志） */
            ttsBatchInProgress: false,
            ttsBatchLoadingText: '',
            rightParamsLoading: false,
            datapath: "",
            lastPlayedFilename: "",
            lastGeneratedWasAudition: false,
            listPlayingFilename: null,
            listAudioPaused: true,
            voicevalue: {
                wenben: "",
                language: {},
                voice: {},
                style: {},
                role: {},
                volume: 100,
                speech_rate: 100,
                pitch_rate: 100,
                format: "mp3",
                Stylestrength: 100,
                backgroundaudio: {
                    src: "",
                    volume: 2,
                    fadein: 0,
                    fadeout: 0
                }
            },
            languages: [],
            voices: [],
            styles: [],
            roles: [],
            ssmlactive: '',
            wenbenactive: "active",
            live2dactive: '',
            // 下载前登录提示
            showLoginPrompt: false,
            // 有金币时选择下载方式：抵扣金币 / 扫码赚金币 / 直接付款
            showCoinChoiceDialog: false,
            pendingDownloadType: null,
            downloadedFileIds: [], // 已下载过的 fileId，再次下载不扣费
            /** 走过「播放音频→百度网盘免费下载」的 fileId：后续下载仍需再次弹扣费框 */
            baiduPanPlayPaidFileIds: [],
            /** 走过百度网盘免费下载的 fileId：不标注“已下载/再次下载” */
            baiduPanFreeFileIds: [],
            lastPlayedCharCount: 0,
            pendingDownloadCharCount: 0,
            codetype: '', // 验证码用途：'赚金币' | '下载音频' | '下载视频' 等
            // 购买金币
            showBuyCoinsDialog: false,
            buyCoinsCount: 10,
            pricePerCoin: 0.1,
            isBuyCoinsPayment: false,
            // 收藏语音配置
            favoriteList: [],
            // 最近使用语音
            recentVoiceList: [],
            isRestoringConfig: false,
            // 文本模板
            templateList: [],
            showTemplateDialog: false,
            showTextEditorDialog: false,
            showOriginalTextPanel: true,
            showUsageTipsExpanded: false,
            showLimitTipsExpanded: false,
            showBrowserTipsExpanded: false,
            showFavoriteDialogueImportDialog: false,
            favoriteDialogueDraft: '',
            showFavoriteDialogueEditDialog: false,
            favoriteDialogueEditText: '',
            isSyncingFavoriteSourceText: false,
            templateCategory: '',
            /** 播放音频已扣费/已付款、待合成成功则清空；合成失败则按此补偿金币 */
            ttsPaidCompensation: null,
            /** 合成进度条（缓慢逼近阈值，完成时一次性拉满） */
            synthProgress: 0,
            synthProgressStripVisible: false,
            synthEtaHint: '',
            synthProgressTimer: null,
            synthProgressFinishTimer: null,
            // 百度网盘等待弹窗
            showBaiduPanLoadingDialog: false,
            baiduPanLoadingBody: '正在上传百度网盘并生成分享链接，请稍候…',
            baiduPanShareUrl: '',
            baiduPanSharePwd: '',
            baiduPanShareText: '',
            baiduPanPwdCopied: false,
            currentVisemeTrack: null,
            ttsReadMode: 'single',
            parsedTtsSegments: [],
            parsedSegmentsDirty: false,
            showVoicePickerDialog: false,
            showVolcVoicePickerDialog: false,
            voicePreviewingKey: '',
            voicePreviewLoadingKey: '',
            voicePreviewProgress: 0,
            voicePreviewObjectUrl: '',
            voicePreviewSampleText: '你好，欢迎使用顶伯AI工具，这是一段发音人试听示例。',
            voicePreviewAudio: null,
            volcVoicePreviewingKey: '',
            volcVoicePreviewLoadingKey: '',
            volcVoicePreviewProgress: 0,
            volcVoicePreviewObjectUrl: '',
            volcVoicePreviewAudio: null,
            backgroundMusicPreviewAudio: null,
        }
    },
    components: {
        pay,
        CoinChoiceDialog,
        AzureTtsLive2dPanel,
        VoicePickerDialog,
        VolcVoicePickerDialog,
    },
    methods: {
        attachLive2dAudio() {
            this.$nextTick(() => {
                if (this.$refs.live2dPanel && this.$refs.audio) {
                    this.$refs.live2dPanel.attachAudioElement(this.$refs.audio)
                }
            })
        },
        openMiniProgramGuide() {
            this.showmp = true
        },
        buildTtsCoinLogContext() {
            const token = (this.$store.state.user && this.$store.state.user.token) ? this.$store.state.user.token : ''
            return {
                token,
                headers: token ? { Authorization: 'Bearer ' + token } : {}
            }
        },
        async spendCoinsForTtsAction({ amount, remark, fileId, failureHint }) {
            const required = Math.max(0, parseInt(amount, 10) || 0)
            const charged = this.coinChargeEnabled && required > 0
            const curBefore = (this.$store.state.user && this.$store.state.user.coins) || 0
            if (charged) {
                this.$store.commit('SetUserCoins', Math.max(0, curBefore - required))
            }
            const { token, headers } = this.buildTtsCoinLogContext()
            try {
                const r = await this.$axios.post('/user/coin/log', {
                    token: token || '',
                    type: 'spend',
                    amount: required,
                    remark,
                    fileId: fileId || undefined
                }, { headers })
                if (r.data && r.data.coins != null) this.$store.commit('SetUserCoins', r.data.coins)
                this.ttsPaidCompensation = charged ? { mode: 'coin', coins: required } : null
                return { charged, required }
            } catch (err) {
                if (charged) this.$store.commit('SetUserCoins', curBefore)
                this.ttsPaidCompensation = null
                if (charged) {
                    this.handlePlayCoinShortage(err, failureHint || '流水记录失败')
                } else {
                    const msg = (err.response && err.response.data && err.response.data.message)
                        ? err.response.data.message
                        : (err.response && err.response.status === 401 ? '请先登录（或登录已过期）' : (failureHint || '操作失败'))
                    this.$message({ message: msg, type: 'warning' })
                }
                throw err
            }
        },
        openVolcVoicePickerDialog() {
            if (!this.volcVoiceOptions || !this.volcVoiceOptions.length) {
                this.$message.warning('当前暂无可用火山发音人')
                return
            }
            this.showVolcVoicePickerDialog = true
        },
        handleVolcVoicePickerClosed() {
            this.stopVolcVoicePreview()
        },
        applyVolcVoiceSelection(voice) {
            if (!voice || !voice.value) return
            this.stopVolcVoicePreview()
            this.volcVoiceType = String(voice.value).trim()
            this.showVolcVoicePickerDialog = false
            this.$message.success(`已切换为 ${voice.label || voice.value}`)
        },
        decodeHtmlEntities(value) {
            let decoded = String(value || '')
            if (!decoded || decoded.indexOf('&') < 0) return decoded
            for (let i = 0; i < 2; i += 1) {
                const next = this.decodeHtmlEntitiesOnce(decoded)
                if (next === decoded) break
                decoded = next
            }
            return decoded
        },
        decodeHtmlEntitiesOnce(value) {
            if (typeof document !== 'undefined') {
                const textarea = document.createElement('textarea')
                textarea.innerHTML = value
                return textarea.value
            }
            return String(value || '')
                .replace(/&#x([0-9a-f]+);/gi, (_, code) => String.fromCharCode(parseInt(code, 16)))
                .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(parseInt(code, 10)))
                .replace(/&amp;/g, '&')
        },
        normalizeVolcRatio(value, defaultValue, minValue, maxValue) {
            const num = Number(value)
            if (!isFinite(num)) return defaultValue
            if (minValue != null && num < minValue) return minValue
            if (maxValue != null && num > maxValue) return maxValue
            return Number(num.toFixed(1))
        },
        getDefaultVolcRatios() {
            return {
                speedRatio: 1,
                volumeRatio: 1,
                pitchRatio: 1
            }
        },
        resetVolcRatios() {
            const defaults = this.getDefaultVolcRatios()
            this.volcSpeedRatio = defaults.speedRatio
            this.volcVolumeRatio = defaults.volumeRatio
            this.volcPitchRatio = defaults.pitchRatio
        },
        isBlockedVolcVoiceType(value) {
            return /_24k_streaming$/i.test(String(value || '').trim())
        },
        getVolcScenarioCategoryRank(category) {
            const idx = VOLC_SCENARIO_CATEGORY_ORDER.indexOf(String(category || '').trim())
            return idx >= 0 ? idx : VOLC_SCENARIO_CATEGORY_ORDER.length
        },
        resolveVolcVoiceCategory({ label, name, sourceCategory }) {
            const safeLabel = String(label || '')
            const safeName = String(name || '')
            const safeSourceCategory = String(sourceCategory || '')
            const text = `${safeLabel} ${safeName} ${safeSourceCategory}`

            if (safeLabel.indexOf('超自然音色') >= 0 || safeName.indexOf('超自然音色') >= 0) return '超自然音色'
            if (safeLabel.indexOf('双语') >= 0 || safeName.indexOf('双语') >= 0) return '多语种场景'
            if (['英语', '日语', '葡语', '西语', '多语种'].indexOf(safeSourceCategory) >= 0) return '多语种场景'
            if (/新闻/.test(text)) return '新闻播报'
            if (/促销|直播|解说|译制片/.test(text)) return '广告/短视频'
            if (/方言|东北|西安|沪上|广西|台妹|台普|港剧|相声|重庆|四川|乡村|湖南|长沙|幺妹|说唱|动漫|海绵|海星|小新/.test(text)) return '短视频玩法'
            if (/童|萌娃|萝莉|亲切|温柔|慈爱|姥姥|老者|天才童声|陪伴/.test(text)) return '教育/陪伴'
            if (/古风|少御|纨绔|赘婿|青叔|反卷|甜宠|懒小羊|鸡汤|活泼|清新文艺|情感/.test(text)) return '趣味'
            return '通用'
        },
        sanitizeVolcVoiceType(value, fallbackValue = 'BV700_V2_streaming') {
            const voiceType = String(value || '').trim()
            if (voiceType && !this.isBlockedVolcVoiceType(voiceType)) return voiceType
            return String(fallbackValue || '').trim() || 'BV700_V2_streaming'
        },
        normalizeVolcVoiceOptions(list, preferredVoiceType) {
            const source = Array.isArray(list) && list.length ? list : VOLC_DEFAULT_VOICE_OPTIONS
            const map = new Map()
            source.forEach(item => {
                if (!item) return
                const value = String((item && item.value) || '').trim()
                if (!value) return
                if (this.isBlockedVolcVoiceType(value)) return
                const label = this.decodeHtmlEntities(String((item && item.label) || value).trim() || value)
                const parts = label.split(/\s*\/\s*/)
                const sourceCategory = this.decodeHtmlEntities(String((item && item.sourceCategory) || parts[0] || '中文').trim() || '中文')
                const name = this.decodeHtmlEntities(String((item && item.name) || (parts.length > 1 ? parts.slice(1).join(' / ') : label)).trim() || value)
                const category = this.decodeHtmlEntities(String((item && item.category) || this.resolveVolcVoiceCategory({ label, name, sourceCategory })).trim() || '通用')
                if (!map.has(value)) {
                    map.set(value, {
                        label,
                        value,
                        category,
                        sourceCategory,
                        name,
                        previewText: String((item && item.previewText) || '').trim(),
                        previewUrl: String((item && item.previewUrl) || '').trim(),
                        previewReady: !!(item && item.previewReady)
                    })
                }
            })
            const preferred = String(preferredVoiceType || '').trim()
            if (preferred && !this.isBlockedVolcVoiceType(preferred) && !map.has(preferred)) {
                map.set(preferred, {
                    label: preferred,
                    value: preferred,
                    category: '通用',
                    sourceCategory: '自定义',
                    name: preferred,
                    previewText: '',
                    previewUrl: '',
                    previewReady: false
                })
            }
            return Array.from(map.values()).sort((a, b) => {
                const rankDiff = this.getVolcScenarioCategoryRank(a.category) - this.getVolcScenarioCategoryRank(b.category)
                if (rankDiff !== 0) return rankDiff
                return String(a.label || '').localeCompare(String(b.label || ''), 'zh-CN')
            })
        },
        getVolcVoicePreviewKey(voice) {
            return voice && voice.value ? String(voice.value).trim() : ''
        },
        resolveVolcPreviewUrl(value) {
            const raw = value == null ? '' : String(value).trim()
            if (!raw) return ''
            if (/^https?:\/\//i.test(raw)) return raw
            return this.$store.state.basicurl + raw.replace(/^\/+/, '')
        },
        async getVolcPreviewErrorMessage(error, fallbackMessage) {
            const blob = error && error.response && error.response.data
            if (typeof Blob !== 'undefined' && blob instanceof Blob) {
                try {
                    const text = await blob.text()
                    const parsed = JSON.parse(text)
                    if (parsed && parsed.message) return parsed.message
                } catch (e) {
                    // Ignore blob parse failures and fall back to generic error text.
                }
            }
            return (error && error.response && error.response.data && error.response.data.message)
                ? error.response.data.message
                : ((error && error.message) ? error.message : fallbackMessage)
        },
        stopVolcVoicePreview() {
            const audio = this.volcVoicePreviewAudio
            if (audio) {
                audio.pause()
                audio.currentTime = 0
                audio.ontimeupdate = null
                audio.onloadedmetadata = null
                audio.onended = null
                audio.onerror = null
            }
            if (this.volcVoicePreviewObjectUrl) {
                URL.revokeObjectURL(this.volcVoicePreviewObjectUrl)
            }
            this.volcVoicePreviewAudio = null
            this.volcVoicePreviewObjectUrl = ''
            this.volcVoicePreviewingKey = ''
            this.volcVoicePreviewLoadingKey = ''
            this.volcVoicePreviewProgress = 0
        },
        playVolcVoicePreviewSource({ key, url, objectUrl = '' }) {
            return new Promise((resolve, reject) => {
                const audio = new Audio(url)
                let settled = false
                const rejectOnce = (error) => {
                    if (settled) return
                    settled = true
                    this.stopVolcVoicePreview()
                    reject(error instanceof Error ? error : new Error(String(error || '试听失败')))
                }
                audio.preload = 'auto'
                audio.onloadedmetadata = () => {
                    this.volcVoicePreviewProgress = 0
                }
                audio.ontimeupdate = () => {
                    const duration = Number(audio.duration || 0)
                    const currentTime = Number(audio.currentTime || 0)
                    this.volcVoicePreviewProgress = duration > 0 ? Math.min(1, currentTime / duration) : 0
                }
                audio.onended = () => {
                    this.stopVolcVoicePreview()
                }
                audio.onerror = () => {
                    if (!settled) {
                        rejectOnce(new Error('试听音频加载失败'))
                        return
                    }
                    this.stopVolcVoicePreview()
                }
                this.volcVoicePreviewAudio = audio
                this.volcVoicePreviewObjectUrl = objectUrl
                this.volcVoicePreviewingKey = key
                this.volcVoicePreviewProgress = 0
                Promise.resolve(audio.play()).then(() => {
                    if (settled) return
                    settled = true
                    resolve()
                }).catch(rejectOnce)
            })
        },
        async synthesizeVolcVoicePreviewFallback(voice) {
            const response = await this.$axios.post('/volcengine/tts/preview', {
                voiceType: voice && voice.value ? String(voice.value).trim() : '',
                text: voice && voice.previewText ? voice.previewText : '',
                speedRatio: 1,
                volumeRatio: 1,
                pitchRatio: 1
            }, {
                responseType: 'blob'
            })
            const contentType = (response && response.headers && response.headers['content-type']) || 'audio/mpeg'
            const blob = response && response.data instanceof Blob
                ? response.data
                : new Blob([response.data], { type: contentType })
            const objectUrl = URL.createObjectURL(blob)
            return {
                url: objectUrl,
                objectUrl
            }
        },
        async handleVolcVoicePreview(voice) {
            const key = this.getVolcVoicePreviewKey(voice)
            if (!key) return
            if (this.volcVoicePreviewLoadingKey && this.volcVoicePreviewLoadingKey !== key) return
            if (this.volcVoicePreviewingKey === key && this.volcVoicePreviewAudio && !this.volcVoicePreviewAudio.paused) {
                this.stopVolcVoicePreview()
                return
            }
            this.stopVolcVoicePreview()
            this.volcVoicePreviewLoadingKey = key
            try {
                const previewUrl = this.resolveVolcPreviewUrl(voice && voice.previewUrl)
                if (previewUrl) {
                    try {
                        await this.playVolcVoicePreviewSource({ key, url: previewUrl })
                        return
                    } catch (error) {
                        this.stopVolcVoicePreview()
                    }
                }
                const fallback = await this.synthesizeVolcVoicePreviewFallback(voice)
                await this.playVolcVoicePreviewSource({ key, url: fallback.url, objectUrl: fallback.objectUrl })
            } catch (error) {
                this.stopVolcVoicePreview()
                const message = await this.getVolcPreviewErrorMessage(error, '火山试听失败，请稍后重试')
                this.$message.error(message || '火山试听失败，请稍后重试')
            } finally {
                if (this.volcVoicePreviewLoadingKey === key) this.volcVoicePreviewLoadingKey = ''
            }
        },
        loadVolcConfig() {
            return this.$axios.get('/volcengine/tts/config').then(response => {
                const data = response.data || {}
                const voiceType = this.sanitizeVolcVoiceType(data.voiceType, '')
                const fallbackVoiceType = this.sanitizeVolcVoiceType(this.volcVoiceType || 'BV700_V2_streaming')
                this.volcVoiceOptions = this.normalizeVolcVoiceOptions(data.voiceOptions, voiceType || fallbackVoiceType)
                if (voiceType) this.volcVoiceType = voiceType
                else if (!this.volcVoiceType || this.isBlockedVolcVoiceType(this.volcVoiceType)) {
                    this.volcVoiceType = this.volcVoiceOptions.length ? this.volcVoiceOptions[0].value : 'BV700_V2_streaming'
                }
                this.resetVolcRatios()
            }).catch(() => {
                this.volcVoiceType = this.sanitizeVolcVoiceType(this.volcVoiceType || 'BV700_V2_streaming')
                this.volcVoiceOptions = this.normalizeVolcVoiceOptions(this.volcVoiceOptions, this.volcVoiceType)
                this.resetVolcRatios()
            })
        },
        normalizeBackgroundAudioUrl(value) {
            const raw = value == null ? '' : String(value).trim()
            if (!raw) return ''
            if (/^https?:\/\//i.test(raw)) return raw
            return this.$store.state.basicurl + raw.replace(/^\/+/, '')
        },
        loadBackgroundMusic() {
            this.$axios.get('/getbackgroundmusic').then(response => {
                const list = (response.data || []).map(item => ({
                    value: item.filename,
                    text: item.name || item.filename || '未命名背景音乐',
                    type: item.type || '背景音乐'
                }))
                this.allBackgroundMusic = list
                if (!this.activeMusicType && this.musicTypes.length) this.activeMusicType = this.musicTypes[0]
                this.refreshBackgroundMusicByType(this.activeMusicType)
            }).catch(() => {
                this.allBackgroundMusic = []
                this.backgroundMusicList = []
            })
        },
        refreshBackgroundMusicByType(type) {
            this.backgroundMusicList = type
                ? this.allBackgroundMusic.filter(item => item.type === type)
                : this.allBackgroundMusic.slice()
        },
        handleBackgroundMusicTypeChange(type) {
            this.stopBackgroundMusicPreview()
            this.activeMusicType = type || ''
            this.refreshBackgroundMusicByType(this.activeMusicType)
        },
        openBackgroundMusicDialog() {
            if (!this.activeMusicType && this.musicTypes.length) this.activeMusicType = this.musicTypes[0]
            this.refreshBackgroundMusicByType(this.activeMusicType)
            this.showBackgroundMusicDialog = true
        },
        closeBackgroundMusicDialog() {
            this.stopBackgroundMusicPreview()
        },
        confirmBackgroundMusicSelection() {
            if (!this.hasSelectedBackgroundMusic) {
                this.$message({ message: '请先选择或上传背景音乐', type: 'warning' })
                return
            }
            this.showBackgroundMusicDialog = false
        },
        isBackgroundMusicSelected(item) {
            if (!item) return false
            return this.normalizeBackgroundAudioUrl(item.value) === this.normalizeBackgroundAudioUrl(this.voicevalue.backgroundaudio.src)
        },
        stopBackgroundMusicPreview() {
            const audio = this.backgroundMusicPreviewAudio
            if (audio) {
                audio.pause()
                audio.currentTime = 0
                audio.onended = null
            }
            this.backgroundMusicPreviewAudio = null
            this.backgroundMusicPreviewUrl = ''
            this.backgroundMusicPreviewName = ''
        },
        isPreviewingBackgroundMusic(item) {
            if (!item) return false
            return this.backgroundMusicPreviewUrl === this.normalizeBackgroundAudioUrl(item.value)
        },
        toggleBackgroundMusicPreview(item) {
            if (!item) return
            const targetUrl = this.normalizeBackgroundAudioUrl(item.value)
            if (!targetUrl) return
            if (this.backgroundMusicPreviewUrl === targetUrl) {
                this.stopBackgroundMusicPreview()
                return
            }
            this.stopBackgroundMusicPreview()
            const audio = new Audio(targetUrl)
            audio.onended = () => {
                this.stopBackgroundMusicPreview()
            }
            audio.onerror = () => {
                this.stopBackgroundMusicPreview()
                this.$message({ message: '背景音乐试听失败，请稍后重试', type: 'warning' })
            }
            this.backgroundMusicPreviewAudio = audio
            this.backgroundMusicPreviewUrl = targetUrl
            this.backgroundMusicPreviewName = item.text || ''
            audio.play().catch(() => {
                this.stopBackgroundMusicPreview()
                this.$message({ message: '当前浏览器拦截了自动播放，请手动重试', type: 'warning' })
            })
        },
        selectBackgroundMusic(item) {
            if (!item) return
            this.voicevalue.backgroundaudio.src = this.normalizeBackgroundAudioUrl(item.value)
            this.uploadfilename = item.text || item.value || '未选择背景音乐'
            this.stopBackgroundMusicPreview()
        },
        beforeBackgroundUpload(file) {
            const name = file && file.name ? String(file.name).toLowerCase() : ''
            if (!/\.(mp3|wav)$/i.test(name)) {
                this.$message({ message: '只能上传 mp3 或 wav 文件', type: 'warning' })
                return false
            }
            return true
        },
        handleBackgroundUploadSuccess(response, file) {
            this.uploadfilename = (file && file.name) ? file.name : (response || '自定义背景音乐')
            this.voicevalue.backgroundaudio.src = this.normalizeBackgroundAudioUrl('upload/' + response)
            this.stopBackgroundMusicPreview()
            this.$message({ message: '背景音乐上传成功，已设为当前背景音乐', type: 'success' })
        },
        handleBackgroundUploadError(error) {
            let msg = '背景音乐上传失败'
            if (error && error.message) msg = error.message
            this.$message({ message: msg, type: 'warning' })
        },
        resetVoiceParam(key) {
            const defaults = {
                volume: 100,
                speech_rate: 100,
                pitch_rate: 100
            }
            if (!Object.prototype.hasOwnProperty.call(defaults, key)) return
            this.voicevalue[key] = defaults[key]
        },
        getVoicePickerKey(voice) {
            if (!voice || typeof voice !== 'object') return ''
            return String(voice.id != null ? voice.id : (voice.ID != null ? voice.ID : (voice.voice || voice.voicename || '')))
        },
        openVoicePickerDialog() {
            if (!this.voices || !this.voices.length) {
                this.$message.warning('当前语言下暂无可用发音人')
                return
            }
            this.showVoicePickerDialog = true
        },
        handleVoicePickerClosed() {
            this.stopVoicePreview()
        },
        applyVoiceSelection(voice) {
            if (!voice || !voice.voice) return
            this.voicevalue.voice = voice
            this.showVoicePickerDialog = false
            this.stopVoicePreview()
            this.$message.success(`已切换为 ${voice.voicename || voice.voice}`)
        },
        previewCurrentVoice() {
            const voice = this.voicevalue.voice
            if (!voice || !voice.voice) {
                this.$message.warning('请先选择发音人')
                return
            }
            this.handleVoicePreview(voice)
        },
        buildVoicePreviewSsml(voice) {
            const lang = (voice && voice.language) || (this.voicevalue.language && this.voicevalue.language.language) || 'zh-CN'
            const config = {
                language: { language: lang },
                voice,
                style: {},
                role: {},
                volume: this.voicevalue.volume,
                speech_rate: this.voicevalue.speech_rate,
                pitch_rate: this.voicevalue.pitch_rate,
                Stylestrength: 100
            }
            const body = this.buildVoiceSsmlFragment(config, this.voicePreviewSampleText)
            return `<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="${this.escapeXmlAttr(lang)}">${body}</speak>`
        },
        synthesizeVoicePreview(voice, tokenType) {
            const voiceKey = this.getVoicePickerKey(voice)
            const ssml = this.buildVoicePreviewSsml(voice)
            const sdk = this.$sdk || require("microsoft-cognitiveservices-speech-sdk")
            return this.$axios.post('/GetAccessToken', { tokentype: tokenType }).then(res => {
                if (!res.data || !res.data.token || !res.data.area) throw new Error('无法获取试听令牌')
                const speechConfig = sdk.SpeechConfig.fromSubscription(res.data.token, res.data.area)
                speechConfig.speechSynthesisOutputFormat = sdk.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
                return new Promise((resolve, reject) => {
                    const synthesizer = new sdk.SpeechSynthesizer(speechConfig, null)
                    synthesizer.speakSsmlAsync(
                        ssml,
                        result => {
                            synthesizer.close()
                            if (result && result.errorDetails) {
                                reject(new Error(result.errorDetails))
                                return
                            }
                            const blob = new Blob([result.audioData], { type: 'audio/mpeg' })
                            resolve({
                                key: voiceKey,
                                url: URL.createObjectURL(blob)
                            })
                        },
                        error => {
                            synthesizer.close()
                            reject(error instanceof Error ? error : new Error(String(error || '试听失败')))
                        }
                    )
                })
            })
        },
        stopVoicePreview() {
            const audio = this.voicePreviewAudio
            if (audio) {
                audio.pause()
                audio.currentTime = 0
                audio.ontimeupdate = null
                audio.onloadedmetadata = null
                audio.onended = null
                audio.onerror = null
            }
            if (this.voicePreviewObjectUrl) {
                URL.revokeObjectURL(this.voicePreviewObjectUrl)
            }
            this.voicePreviewAudio = null
            this.voicePreviewObjectUrl = ''
            this.voicePreviewingKey = ''
            this.voicePreviewLoadingKey = ''
            this.voicePreviewProgress = 0
        },
        async handleVoicePreview(voice) {
            const key = this.getVoicePickerKey(voice)
            if (!key) return
            if (this.voicePreviewLoadingKey && this.voicePreviewLoadingKey !== key) return
            if (this.voicePreviewingKey === key && this.voicePreviewAudio && !this.voicePreviewAudio.paused) {
                this.stopVoicePreview()
                return
            }
            this.stopVoicePreview()
            this.voicePreviewLoadingKey = key
            try {
                let output = null
                try {
                    output = await this.synthesizeVoicePreview(voice, 'ok')
                } catch (e) {
                    output = await this.synthesizeVoicePreview(voice, 'spare')
                }
                this.voicePreviewObjectUrl = output.url
                this.voicePreviewingKey = key
                this.voicePreviewProgress = 0
                const audio = new Audio(output.url)
                audio.onloadedmetadata = () => {
                    this.voicePreviewProgress = 0
                }
                audio.ontimeupdate = () => {
                    const duration = Number(audio.duration || 0)
                    const currentTime = Number(audio.currentTime || 0)
                    this.voicePreviewProgress = duration > 0 ? Math.min(1, currentTime / duration) : 0
                }
                audio.onended = () => {
                    this.stopVoicePreview()
                }
                audio.onerror = () => {
                    this.stopVoicePreview()
                }
                this.voicePreviewAudio = audio
                await audio.play()
            } catch (error) {
                this.stopVoicePreview()
                this.$message.error((error && error.message) ? error.message : '试听失败，请稍后重试')
            } finally {
                if (this.voicePreviewLoadingKey === key) this.voicePreviewLoadingKey = ''
            }
        },
        getCurrentPlayCoinsRequired(charCount) {
            if (this.ttsEngine !== 'azure') {
                return Math.max(1, Math.ceil((charCount || 0) / 500))
            }
            if (this.ttsReadMode === 'favorite') {
                const combinedText = this.buildFavoriteSynthesisText(this.getFavoritePlayUnits())
                return Math.max(1, Math.ceil(String(combinedText || '').length / 500))
            }
            const chunks = this.getPlayTextChunks()
            if (chunks.length > 1) {
                return chunks.reduce((sum, chunk) => sum + Math.max(1, Math.ceil(String(chunk || '').length / 500)), 0)
            }
            return Math.max(1, Math.ceil((charCount || 0) / 500))
        },
        getAxiosErrorMessage(err, fallbackMessage) {
            return (err && err.response && err.response.data && err.response.data.message)
                ? err.response.data.message
                : (err && err.response && err.response.status === 401 ? '请先登录（或登录已过期）' : fallbackMessage)
        },
        handlePlayCoinShortage(err, fallbackMessage) {
            const message = this.getAxiosErrorMessage(err, fallbackMessage || '流水记录失败')
            if (/金币不足/.test(String(message || ''))) {
                this.openMiniProgramGuide()
                this.$message({ message: '当前金币不足，可前往小程序免费生成音频', type: 'info' })
                return true
            }
            this.$message({ message, type: 'warning' })
            return false
        },
        toVisemeMs(offset) {
            const ticks = Number(offset)
            if (!isFinite(ticks) || ticks <= 0) return 0
            return Math.max(0, ticks / 10000)
        },
        buildVisemeTrack(payload = {}) {
            const visemes = Array.isArray(payload.visemes)
                ? payload.visemes
                    .map(item => ({
                        timeMs: Math.max(0, Number(item.timeMs) || 0),
                        visemeId: Math.max(0, parseInt(item.visemeId, 10) || 0)
                    }))
                    .sort((a, b) => a.timeMs - b.timeMs)
                : []
            return {
                key: payload.key || '',
                text: payload.text || '',
                audioDurationMs: Math.max(0, Number(payload.audioDurationMs) || 0),
                visemes
            }
        },
        setCurrentVisemeTrack(track) {
            this.currentVisemeTrack = track ? this.buildVisemeTrack(track) : null
            if (this.$refs.live2dPanel) {
                if (this.currentVisemeTrack && this.currentVisemeTrack.visemes.length) {
                    this.$refs.live2dPanel.setTrack(this.currentVisemeTrack)
                } else {
                    this.$refs.live2dPanel.clearTrack('当前音频没有视素数据')
                }
            }
        },
        clearCurrentVisemeTrack(statusText) {
            this.currentVisemeTrack = null
            if (this.$refs.live2dPanel) {
                this.$refs.live2dPanel.clearTrack(statusText || '等待生成音频')
            }
        },
        clonePlainData(value) {
            if (value == null) return value
            try {
                return JSON.parse(JSON.stringify(value))
            } catch (e) {
                return value
            }
        },
        invalidateGeneratedAudioState(clearTrackText) {
            this.datapath = ''
            this.lastPlayedFilename = ''
            this.lastPlayedCharCount = 0
            this.lastGeneratedWasAudition = false
            this.currentRecordFilename = null
            this.havecode = false
            this.listPlayingFilename = null
            this.clearCurrentVisemeTrack(clearTrackText || '等待生成音频')
        },
        captureCurrentVoiceConfig() {
            return this.clonePlainData({
                language: this.voicevalue.language,
                voice: this.voicevalue.voice,
                style: this.voicevalue.style,
                role: this.voicevalue.role,
                volume: this.voicevalue.volume,
                speech_rate: this.voicevalue.speech_rate,
                pitch_rate: this.voicevalue.pitch_rate,
                Stylestrength: this.voicevalue.Stylestrength
            })
        },
        getFavoriteConfigObject(favoriteLike) {
            if (!favoriteLike) return null
            let config = favoriteLike.config != null ? favoriteLike.config : favoriteLike
            if (typeof config === 'string') {
                try {
                    config = JSON.parse(config)
                } catch (e) {
                    return null
                }
            }
            return this.clonePlainData(config)
        },
        getFavoriteConfigById(id) {
            const key = String(id == null ? '' : id).trim()
            if (!key) return null
            return this.favoriteList.find(item => String(item.id) === key) || null
        },
        findFavoriteByName(name) {
            const keyword = String(name || '').trim()
            if (!keyword) return null
            const lower = keyword.toLowerCase()
            return this.favoriteList.find(item => String(item.name || '').trim().toLowerCase() === lower) || null
        },
        isLikelyDialogueSpeakerName(name) {
            const text = String(name || '').trim()
            if (!text) return false
            if (text.length > 20) return false
            if (/[\r\n]/.test(text)) return false
            if (/^\d+$/.test(text)) return false
            return /^[\u4e00-\u9fa5A-Za-z0-9_\-\s·.()（）]{1,20}$/.test(text)
        },
        buildFavoriteConfigKey(id) {
            return `favorite:${id}`
        },
        splitTextForSynthesis(text, limit = TTS_PLAY_CHUNK_SIZE) {
            const raw = String(text || '').replace(/\&/g, '')
            if (!raw) return []
            if (raw.length <= limit) return [raw]
            const chunks = []
            for (let i = 0; i < raw.length; i += limit) {
                chunks.push(raw.slice(i, i + limit))
            }
            return chunks
        },
        extractFavoriteMarker(paragraph) {
            const raw = String(paragraph || '').replace(/\r\n?/g, '\n').trim()
            if (!raw) return { markerName: '', text: '', matchedFavorite: null }
            const bracketMatch = raw.match(/^(?:\[(.+?)\]|【(.+?)】)\s*([\s\S]*)$/)
            if (bracketMatch) {
                const markerName = String(bracketMatch[1] || bracketMatch[2] || '').trim()
                const text = String(bracketMatch[3] || '').trim()
                return {
                    markerName,
                    text,
                    matchedFavorite: this.findFavoriteByName(markerName)
                }
            }
            const lines = raw.split('\n')
            const firstLine = String(lines[0] || '').trim()
            const colonIndex = firstLine.indexOf('：') >= 0 ? firstLine.indexOf('：') : firstLine.indexOf(':')
            if (colonIndex > 0) {
                const markerName = firstLine.slice(0, colonIndex).trim()
                if (this.isLikelyDialogueSpeakerName(markerName)) {
                    const matchedFavorite = this.findFavoriteByName(markerName)
                    const headRemainder = firstLine.slice(colonIndex + 1).trim()
                    const textLines = []
                    if (headRemainder) textLines.push(headRemainder)
                    if (lines.length > 1) textLines.push(...lines.slice(1))
                    return {
                        markerName,
                        text: textLines.join('\n').trim(),
                        matchedFavorite
                    }
                }
            }
            return { markerName: '', text: raw, matchedFavorite: null }
        },
        isFavoriteSegmentStarter(line) {
            const raw = String(line || '').trim()
            if (!raw) return false
            if (/^(?:\[(.+?)\]|【(.+?)】)\s*/.test(raw)) return true
            const colonIndex = raw.indexOf('：') >= 0 ? raw.indexOf('：') : raw.indexOf(':')
            if (colonIndex <= 0) return false
            const markerName = raw.slice(0, colonIndex).trim()
            return this.isLikelyDialogueSpeakerName(markerName)
        },
        createParsedTtsSegment(paragraph, index) {
            const marker = this.extractFavoriteMarker(paragraph)
            const cleanedText = String(marker.text || '').trim()
            const favorite = marker.matchedFavorite
            return {
                id: `tts-segment-${index + 1}-${Date.now()}`,
                order: index + 1,
                text: cleanedText,
                configKey: favorite ? this.buildFavoriteConfigKey(favorite.id) : 'default',
                detectedFavoriteName: marker.markerName || '',
                unmatchedFavoriteName: marker.markerName && !favorite ? marker.markerName : ''
            }
        },
        getFavoriteParseParagraphs(sourceText) {
            const lines = String(sourceText != null ? sourceText : this.voicevalue.wenben || '')
                .replace(/\r\n?/g, '\n')
                .split('\n')
            const segments = []
            let current = []

            const pushCurrent = () => {
                const text = current.join('\n').trim()
                if (text) segments.push(text)
                current = []
            }

            lines.forEach((line) => {
                const trimmed = String(line || '').trim()
                if (!trimmed) {
                    pushCurrent()
                    return
                }
                if (current.length && this.isFavoriteSegmentStarter(trimmed)) {
                    pushCurrent()
                }
                current.push(trimmed)
            })
            pushCurrent()
            return segments
        },
        parseFavoriteTtsSegments(showMessage, sourceText) {
            const paragraphs = this.getFavoriteParseParagraphs(sourceText)
            if (!paragraphs.length) {
                this.parsedTtsSegments = []
                this.parsedSegmentsDirty = false
                if (showMessage) this.$message.warning('请先输入要解析的文本')
                return []
            }
            const segments = paragraphs
                .map((paragraph, index) => this.createParsedTtsSegment(paragraph, index))
                .filter(segment => String(segment.text || '').trim())
            this.parsedTtsSegments = segments
            this.parsedSegmentsDirty = false
            this.invalidateGeneratedAudioState('段落配置已更新，请重新生成音频')
            if (showMessage) {
                this.$message.success(`已识别 ${segments.length} 段对话`)
            }
            return segments
        },
        syncFavoriteSourceText(text) {
            this.isSyncingFavoriteSourceText = true
            this.voicevalue.wenben = String(text || '')
            this.$nextTick(() => {
                this.isSyncingFavoriteSourceText = false
            })
        },
        getFavoriteDialogueMarkerName(segment) {
            if (!segment) return ''
            const directName = String(segment.detectedFavoriteName || segment.unmatchedFavoriteName || '').trim()
            if (directName) return directName
            const configKey = String(segment.configKey || '')
            if (configKey.indexOf('favorite:') !== 0) return ''
            const favorite = this.getFavoriteConfigById(configKey.replace(/^favorite:/, ''))
            return favorite ? String(favorite.name || '').trim() : ''
        },
        buildFavoriteDialogueEditorText(segments) {
            const list = Array.isArray(segments) ? segments : this.parsedTtsSegments
            return list
                .map((segment) => {
                    const text = String(segment && segment.text ? segment.text : '').trim()
                    if (!text) return ''
                    const markerName = this.getFavoriteDialogueMarkerName(segment)
                    return markerName ? `[${markerName}] ${text}` : text
                })
                .filter(Boolean)
                .join('\n')
        },
        getFavoriteDialogueTemplateNames() {
            const favoriteNames = this.favoriteList
                .map(item => String(item && item.name ? item.name : '').trim())
                .filter(Boolean)
            const defaults = ['旁白', '小男孩', '小女孩', '老师']
            const picked = []
            favoriteNames.forEach((name) => {
                if (!picked.includes(name) && picked.length < 4) {
                    picked.push(name)
                }
            })
            defaults.forEach((name) => {
                if (!picked.includes(name) && picked.length < 4) {
                    picked.push(name)
                }
            })
            return {
                names: picked,
                favoriteCount: favoriteNames.length
            }
        },
        fillFavoriteDialogueTemplate() {
            const templateInfo = this.getFavoriteDialogueTemplateNames()
            const names = templateInfo.names
            if (!templateInfo.favoriteCount) {
                this.$message.warning('还没有收藏配音配置，已先用默认角色帮你填入模板')
            } else if (templateInfo.favoriteCount < 3) {
                this.$message.warning('收藏配置数量较少，剩余角色已用默认名称补齐')
            }
            const line1 = names[0] || '旁白'
            const line2 = names[1] || line1
            const line3 = names[2] || line2
            const line4 = names[3] || line1
            this.favoriteDialogueDraft = [
                `[${line1}] 这里输入第一句台词`,
                `[${line2}] 这里输入第二句台词`,
                `[${line3}] 这里输入第三句台词`,
                `[${line4}] 这里输入补充说明或收尾内容`
            ].join('\n')
        },
        openFavoriteDialogueImportDialog() {
            this.favoriteDialogueDraft = String(this.voicevalue.wenben || '').trim()
            this.showFavoriteDialogueImportDialog = true
        },
        confirmFavoriteDialogueImport() {
            const text = String(this.favoriteDialogueDraft || '').replace(/\r\n?/g, '\n').trim()
            if (!text) {
                this.$message.warning('请先输入要识别的文案')
                return
            }
            this.syncFavoriteSourceText(text)
            const segments = this.parseFavoriteTtsSegments(false, text)
            if (!segments.length) {
                this.$message.warning('未识别出可用对话，请检查文案格式')
                return
            }
            this.showFavoriteDialogueImportDialog = false
            this.$message.success(`已识别 ${segments.length} 段对话`)
        },
        openFavoriteDialogueEditDialog() {
            const source = this.parsedTtsSegments.length
                ? this.buildFavoriteDialogueEditorText(this.parsedTtsSegments)
                : String(this.voicevalue.wenben || '').trim()
            this.favoriteDialogueEditText = source
            this.showFavoriteDialogueEditDialog = true
        },
        confirmFavoriteDialogueEdit() {
            const text = String(this.favoriteDialogueEditText || '').replace(/\r\n?/g, '\n').trim()
            if (!text) {
                this.$message.warning('请先输入要保存的对话文案')
                return
            }
            this.syncFavoriteSourceText(text)
            const segments = this.parseFavoriteTtsSegments(false, text)
            if (!segments.length) {
                this.$message.warning('未识别出可用对话，请检查文案格式')
                return
            }
            this.showFavoriteDialogueEditDialog = false
            this.$message.success(`已更新 ${segments.length} 段对话`)
        },
        handleTtsReadModeChange(mode) {
            this.invalidateGeneratedAudioState('配音模式已切换，请重新生成音频')
            if (mode === 'favorite') {
                if (!this.parsedTtsSegments.length) return
                if (this.parsedSegmentsDirty) this.parseFavoriteTtsSegments(false)
            } else {
                this.parsedSegmentsDirty = false
            }
        },
        onParsedSegmentConfigChange(segment, value) {
            if (!segment) return
            segment.configKey = value
            this.invalidateGeneratedAudioState('段落配置已更新，请重新生成音频')
        },
        onParsedSegmentTextChange() {
            this.invalidateGeneratedAudioState('段落文本已更新，请重新生成音频')
            this.syncFavoriteSourceText(this.buildFavoriteDialogueEditorText(this.parsedTtsSegments))
            this.parsedSegmentsDirty = false
        },
        ensureFavoriteSegmentsReady(showMessage) {
            if (this.ttsReadMode !== 'favorite') return []
            if (!this.parsedTtsSegments.length || this.parsedSegmentsDirty) {
                return this.parseFavoriteTtsSegments(showMessage)
            }
            const usable = this.parsedTtsSegments.filter(item => String(item.text || '').trim())
            if (!usable.length && showMessage) {
                this.$message.warning('请先解析出可配音的段落')
            }
            return usable
        },
        limitFavoriteSegmentsForAudition(segments, limit = 50) {
            const picked = []
            let remain = Math.max(1, parseInt(limit, 10) || 50)
            segments.forEach(segment => {
                if (remain <= 0) return
                const text = String(segment.text || '').replace(/\&/g, '')
                if (!text) return
                const clipped = text.slice(0, remain)
                if (!clipped) return
                picked.push({
                    ...segment,
                    text: clipped
                })
                remain -= clipped.length
            })
            return picked
        },
        buildFavoriteSynthesisUnits(btntype, showMessage = true) {
            const segments = showMessage
                ? this.ensureFavoriteSegmentsReady(true)
                : (
                    this.parsedTtsSegments.length && !this.parsedSegmentsDirty
                        ? this.parsedTtsSegments.filter(item => String(item.text || '').trim())
                        : this.getFavoriteParseParagraphs()
                            .map((paragraph, index) => this.createParsedTtsSegment(paragraph, index))
                            .filter(item => String(item.text || '').trim())
                )
            if (!segments.length) return []
            const sourceSegments = btntype === 'Audition'
                ? this.limitFavoriteSegmentsForAudition(segments, 50)
                : segments
            if (!sourceSegments.length) {
                this.$message.warning('没有可用于合成的段落内容')
                return []
            }
            const defaultConfig = this.captureCurrentVoiceConfig()
            const units = []
            sourceSegments.forEach((segment) => {
                const config = segment.configKey === 'default'
                    ? defaultConfig
                    : this.getFavoriteConfigObject(this.getFavoriteConfigById(String(segment.configKey || '').replace(/^favorite:/, '')))
                units.push({
                    text: String(segment.text || '').replace(/\&/g, ''),
                    config,
                    segmentOrder: segment.order,
                    chunkIndex: 1,
                    configKey: segment.configKey
                })
            })
            return units
        },
        buildFavoriteSynthesisText(units) {
            return units
                .map(item => String(item && item.text ? item.text : '').trim())
                .filter(Boolean)
                .join('\n\n')
        },
        escapeXmlText(str) {
            return String(str || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
        },
        buildVoiceSsmlFragment(config, text, opts = {}) {
            const cfg = config || {}
            const voiceInfo = cfg.voice || {}
            const voiceName = String(voiceInfo.voice || voiceInfo.Voice || '').trim()
            if (!voiceName) return ''
            const language = String((cfg.language && cfg.language.language) || (this.voicevalue.language && this.voicevalue.language.language) || 'zh-CN').trim()
            const escapedText = this.escapeXmlText(text).replace(/\r\n?/g, '\n')
            const inlineText = escapedText
                .split('\n')
                .filter(Boolean)
                .join('<break time="250ms"/>')
            const prosody = `<prosody rate="${((cfg.speech_rate != null ? cfg.speech_rate : 100) - 100) + '%'}" pitch="${((cfg.pitch_rate != null ? cfg.pitch_rate : 100) - 100) + '%'}" volume="${((cfg.volume != null ? cfg.volume : 100) - 100) + '%'}">${inlineText}</prosody>`
            const styleInfo = cfg.style || {}
            const roleInfo = cfg.role || {}
            const styleKey = String(styleInfo.style != null ? styleInfo.style : (styleInfo.Style != null ? styleInfo.Style : '')).trim()
            const roleKey = String(roleInfo.role != null ? roleInfo.role : (roleInfo.Role != null ? roleInfo.Role : '')).trim()
            let deg = (cfg.Stylestrength != null) ? cfg.Stylestrength / 100 : 1
            if (deg < 0.01) deg = 0.01
            if (deg > 2) deg = 2
            const degStr = String(Math.round(deg * 100) / 100)
            let voiceInner = prosody
            if (styleKey || roleKey) {
                const parts = []
                if (styleKey) parts.push(`style="${this.escapeXmlAttr(styleKey)}"`)
                if (roleKey) parts.push(`role="${this.escapeXmlAttr(roleKey)}"`)
                parts.push(`styledegree="${degStr}"`)
                voiceInner = `<mstts:express-as ${parts.join(' ')}>${prosody}</mstts:express-as>`
            }
            if (opts.appendBreak) voiceInner += '<break time="400ms"/>'
            return `<voice name="${this.escapeXmlAttr(voiceName)}"><lang xml:lang="${this.escapeXmlAttr(language)}">${voiceInner}</lang></voice>`
        },
        buildFavoriteSsml(units) {
            const validUnits = Array.isArray(units) ? units.filter(item => item && item.config && item.text) : []
            if (!validUnits.length) return ''
            const firstLang = validUnits[0].config && validUnits[0].config.language && validUnits[0].config.language.language
                ? validUnits[0].config.language.language
                : ((this.voicevalue.language && this.voicevalue.language.language) ? this.voicevalue.language.language : 'zh-CN')
            const bg = this.voicevalue.backgroundaudio
            const bgSrc = (bg && bg.src) ? this.normalizeBackgroundAudioUrl(bg.src) : ''
            const bgAttrs = bgSrc ? ` src="${this.escapeXmlAttr(bgSrc)}" volume="${(bg.volume || 0) / 10}" fadein="${bg.fadein || 0}" fadeout="${bg.fadeout || 0}"` : ''
            const body = validUnits.map((unit, index) => {
                return this.buildVoiceSsmlFragment(unit.config, unit.text, {
                    appendBreak: index !== validUnits.length - 1
                })
            }).filter(Boolean).join('')
            return `<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="${this.escapeXmlAttr(firstLang)}"><mstts:backgroundaudio${bgAttrs}/>${body}</speak>`.replace(/></g, ">\n<")
        },
        async applyVoiceConfigAsync(config, opts = {}) {
            if (!config) return
            const silent = !!opts.silent
            const wait = (ms = 80) => new Promise(resolve => setTimeout(resolve, ms))
            this.isRestoringConfig = true
            try {
                let language = this.voicevalue.language
                if (config.language && config.language.language) {
                    const wantedLang = String(config.language.language).trim()
                    language = this.languages.find(item => String(item.language || '').trim() === wantedLang)
                        || this.languages.find(item => String(item.id || item.ID || '') === String(config.language.id || config.language.ID || ''))
                        || this.clonePlainData(config.language)
                    this.voicevalue.language = language
                }
                const langValue = language && language.language ? language.language : ''
                if (langValue) {
                    const voiceResponse = await this.$axios.post('/getAzurettsvoicedata', { value: langValue })
                    this.voices = voiceResponse.data || []
                }
                await wait()
                let voice = this.voicevalue.voice
                if (config.voice && config.voice.voice) {
                    const wantedVoice = String(config.voice.voice).trim()
                    voice = this.voices.find(item => String(item.voice || '').trim() === wantedVoice)
                        || this.voices.find(item => String(item.id || item.ID || '') === String(config.voice.id || config.voice.ID || ''))
                        || this.clonePlainData(config.voice)
                    this.voicevalue.voice = voice
                } else if (this.voices.length && (!voice || !voice.voice)) {
                    voice = this.voices[0]
                    this.voicevalue.voice = voice
                }
                const voiceValue = voice && voice.voice ? voice.voice : ''
                if (voiceValue) {
                    const [styleResponse, roleResponse] = await Promise.all([
                        this.$axios.post('/getAzurettsstyledata', { value: voiceValue }),
                        this.$axios.post('/getAzurettsroledata', { value: voiceValue })
                    ])
                    this.styles = (styleResponse.data || []).map(row => this.normalizeTtsStyleRow(row))
                    this.roles = (roleResponse.data || []).map(row => this.normalizeTtsRoleRow(row))
                } else {
                    this.styles = []
                    this.roles = []
                }
                if (config.style) {
                    const styleKey = String(config.style.style || config.style.Style || '').trim()
                    const styleId = String(config.style.id != null ? config.style.id : (config.style.ID != null ? config.style.ID : '')).trim()
                    this.voicevalue.style = this.styles.find(item => {
                        const itemKey = String(item.style || item.Style || '').trim()
                        const itemId = String(item.id != null ? item.id : (item.ID != null ? item.ID : '')).trim()
                        return (styleKey && itemKey === styleKey) || (styleId && itemId === styleId)
                    }) || {}
                } else {
                    this.voicevalue.style = this.styles[0] || {}
                }
                if (config.role) {
                    const roleKey = String(config.role.role || config.role.Role || '').trim()
                    const roleId = String(config.role.id != null ? config.role.id : (config.role.ID != null ? config.role.ID : '')).trim()
                    this.voicevalue.role = this.roles.find(item => {
                        const itemKey = String(item.role || item.Role || '').trim()
                        const itemId = String(item.id != null ? item.id : (item.ID != null ? item.ID : '')).trim()
                        return (roleKey && itemKey === roleKey) || (roleId && itemId === roleId)
                    }) || {}
                } else {
                    this.voicevalue.role = this.roles[0] || {}
                }
                if (config.volume != null) this.voicevalue.volume = config.volume
                if (config.speech_rate != null) this.voicevalue.speech_rate = config.speech_rate
                if (config.pitch_rate != null) this.voicevalue.pitch_rate = config.pitch_rate
                if (config.Stylestrength != null) this.voicevalue.Stylestrength = config.Stylestrength
                await wait()
                if (!silent) this.$message.success('已恢复语音配置')
            } finally {
                this.isRestoringConfig = false
            }
        },
        async synthesizeFavoriteUnit(unit, btntype, extraOpts = {}) {
            if (!unit || !unit.text) return null
            if (unit.config) await this.applyVoiceConfigAsync(unit.config, { silent: true })
            this.voicetext = String(unit.text || '').replace(/\&/g, '')
            let out = null
            try {
                out = await this.makeaudio('ok', btntype, {
                    ...extraOpts,
                    segmentText: unit.text
                })
            } catch (e) {
                out = null
            }
            if (!out || !out.ok) {
                try {
                    out = await this.makeaudio('spare', btntype, {
                        ...extraOpts,
                        segmentText: unit.text
                    })
                } catch (e2) {
                    out = null
                }
            }
            return out
        },
        async finalizeFavoriteSingleOutput(out, fullText, btntype) {
            if (!out || !out.filename) throw new Error('no filename')
            const audioUrl = this.$store.state.basicurl + out.filename
            this.datapath = out.filename
            this.lastPlayedFilename = out.filename
            this.lastPlayedCharCount = fullText.length
            this.lastGeneratedWasAudition = (btntype === 'Audition')
            this.voicetext = fullText.replace(/\&/g, '')
            this.listPlayingFilename = null
            this.$refs.audio.src = audioUrl
            if (out.track && out.track.visemes && out.track.visemes.length) {
                this.setCurrentVisemeTrack({ ...out.track, key: out.filename })
            } else {
                this.clearCurrentVisemeTrack('当前音频没有视素数据')
            }
            if (btntype === 'play') this.btnstyleindex = 1
            if (btntype === 'Audition') this.btnAuditionstyleindex = 1
            this.$nextTick(() => {
                const el = this.$refs.audio
                if (el && el.play) el.play().catch(() => {})
            })
            await this.loadRecordList()
            this.saveRecentVoice()
            if (btntype === 'play') {
                await this.registerPaidTtsFile(out.filename)
                this.ttsPaidCompensation = null
            }
        },
        async runFavoriteConfiguredAudition() {
            const units = this.buildFavoriteSynthesisUnits('Audition')
            if (!units.length) return
            const fullText = this.buildFavoriteSynthesisText(units)
            const ssml = this.buildFavoriteSsml(units)
            if (!ssml) {
                this.$message.warning('当前段落缺少可用的配音配置')
                return
            }
            const snapshot = this.captureCurrentVoiceConfig()
            this.clickitem('live2d')
            this.loading = true
            try {
                let auditionOut = null
                try {
                    auditionOut = await this.makeaudio('ok', 'Audition', {
                        quietPlayer: false,
                        skipRegisterPaidFile: true,
                        batchRetainCompensation: false,
                        skipSaveRecent: false,
                        ssmlOverride: ssml,
                        textOverride: fullText
                    })
                } catch (e) {
                    auditionOut = null
                }
                if (!auditionOut || !auditionOut.ok) {
                    auditionOut = await this.makeaudio('spare', 'Audition', {
                        quietPlayer: false,
                        skipRegisterPaidFile: true,
                        batchRetainCompensation: false,
                        skipSaveRecent: false,
                        ssmlOverride: ssml,
                        textOverride: fullText
                    })
                }
                if (!auditionOut || !auditionOut.ok) throw new Error('试听合成失败')
            } finally {
                await this.applyVoiceConfigAsync(snapshot, { silent: true })
                this.loading = false
            }
        },
        mergeVisemeTracks(tracks, key, text) {
            const validTracks = Array.isArray(tracks) ? tracks.filter(Boolean) : []
            let offsetMs = 0
            const visemes = []
            validTracks.forEach(track => {
                const normalized = this.buildVisemeTrack(track)
                normalized.visemes.forEach(item => {
                    visemes.push({
                        timeMs: item.timeMs + offsetMs,
                        visemeId: item.visemeId
                    })
                })
                offsetMs += normalized.audioDurationMs
            })
            return this.buildVisemeTrack({
                key: key || '',
                text: text || '',
                audioDurationMs: offsetMs,
                visemes
            })
        },
        getCurrentFileId(downloadType) {
            if (downloadType === '下载音频') return this.lastPlayedFilename || this.datapath || ''
            if (downloadType === '下载视频') return this.datapath || ''
            if (downloadType === '列表下载音频' && this.row && this.row.filename) return this.row.filename
            return ''
        },
        /** 播放扣费且合成成功后登记 fileId，与下载扣费共用 DbtoolDownloadRecord，再次下载不重复扣费 */
        async registerPaidTtsFile(fileId) {
            const id = fileId != null ? String(fileId).trim() : ''
            if (!id) return
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) return
            try {
                await this.$axios.post('/user/tts-file-entitlement', { token, fileId: id })
                if (this.downloadedFileIds.indexOf(id) < 0) this.downloadedFileIds.push(id)
            } catch (e) {
                /* 登记失败不影响播放；用户可刷新后由 downloaded-list 同步 */
            }
        },
        /** mssql 等返回 id/Style 等字段名不一致，统一成 id + style 供 SSML 与 el-select value-key */
        normalizeTtsStyleRow(row) {
            if (!row || typeof row !== 'object') return row
            const o = { ...row }
            if (o.id == null && o.ID != null) o.id = o.ID
            const s = (o.style != null && String(o.style).trim() !== '') ? String(o.style).trim()
                : ((o.Style != null && String(o.Style).trim() !== '') ? String(o.Style).trim() : '')
            o.style = s
            return o
        },
        normalizeTtsRoleRow(row) {
            if (!row || typeof row !== 'object') return row
            const o = { ...row }
            if (o.id == null && o.ID != null) o.id = o.ID
            const r = (o.role != null && String(o.role).trim() !== '') ? String(o.role).trim()
                : ((o.Role != null && String(o.Role).trim() !== '') ? String(o.Role).trim() : '')
            o.role = r
            return o
        },
        escapeXmlAttr(str) {
            return String(str || '')
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
        },
        doDownloadOnly(downloadType) {
            const token = this.$store.state.user && this.$store.state.user.token
            const baseUrl = this.$store.state.basicurl
            const currentFileId = this.lastPlayedFilename || this.datapath
            const a = document.createElement('a')
            a.style.display = 'none'
            if (downloadType === '下载音频') {
                a.href = token ? `${baseUrl}getdownload?id=${currentFileId}&token=${encodeURIComponent(token)}` : `${baseUrl}getdownload?id=${currentFileId}`
                a.click()
                a.remove()
            } else if (downloadType === '下载视频') {
                this.$axios.post('/makemp4', { filename: this.datapath, token: token || '' }).then(res => {
                    a.href = `${baseUrl}getmp4file?id=${res.data}`
                    a.click()
                    a.remove()
                })
            } else if (downloadType === '列表下载音频' && this.row) {
                a.href = token ? `${baseUrl}getdownload?id=${this.row.filename}&token=${encodeURIComponent(token)}` : `${baseUrl}getdownload?id=${this.row.filename}`
                a.click()
                a.remove()
            }
        },
        shouldForcePayDialogForDownload(downloadType, fileId) {
            const id = (fileId || '').toString().trim()
            if (!id) return false
            // 仅对“下载音频/列表下载音频”强制弹框（你说的右侧下载 + 列表下载）
            if (downloadType !== '下载音频' && downloadType !== '列表下载音频') return false
            return this.baiduPanPlayPaidFileIds.indexOf(id) >= 0
        },
        // 下载前统一入口：未登录弹登录提示，已登录有金币则扣金币下载，无金币则走扫码/付款。已下载过的文件再次下载不扣费。
        tryDownload(downloadType) {
            const user = this.$store.state.user
            if (!user) {
                this.$store.commit('SetPendingDownloadAction', downloadType)
                this.showLoginPrompt = true
                return
            }
            if (downloadType === '拼接音频') {
                if (this.multipleSelection.length < 2 || this.multipleSelection.length > 10) {
                    this.$message({ message: '请选择2～10个文件后再拼接', type: 'info' })
                    return
                }
                const files = this.multipleSelection.map(item => item.filename)
                this.pingjieloading = true
                this.$axios.post('/checksplicemusic', { files }).then(res => {
                    this.pingjieloading = false
                    if (res.data && res.data.ok) {
                        this.pendingDownloadType = '拼接音频'
                        this.pendingDownloadCharCount = 0
                        if (!this.coinChargeEnabled) {
                            this.chooseUseCoin()
                            return
                        }
                        this.showCoinChoiceDialog = true
                    } else {
                        this.$message({ message: (res.data && res.data.message) || '文件校验失败', type: 'warning' })
                    }
                }).catch(() => {
                    this.pingjieloading = false
                    this.$message({ message: '校验失败', type: 'warning' })
                })
                return
            }
            if (downloadType === '下载音频' || downloadType === '下载视频') {
                this.pendingDownloadCharCount = this.lastPlayedCharCount || 0
            } else if (downloadType === '列表下载音频' && this.row && this.row.data) {
                this.pendingDownloadCharCount = (this.row.data || '').length
            } else {
                this.pendingDownloadCharCount = 0
            }
            const fileId = this.getCurrentFileId(downloadType)
            // 若该文件走过「播放音频→百度网盘免费下载」，后续下载必须再次弹扣费框
            if (fileId && this.shouldForcePayDialogForDownload(downloadType, fileId)) {
                this.pendingDownloadType = downloadType
                this.showCoinChoiceDialog = true
                return
            }
            // 百度网盘免费下载过的文件：不标注“已下载/再次下载”，也不走免扣直下，强制弹扣费框
            if (fileId && this.baiduPanFreeFileIds && this.baiduPanFreeFileIds.indexOf(fileId) >= 0) {
                this.pendingDownloadType = downloadType
                this.showCoinChoiceDialog = true
                return
            }
            if (fileId && this.downloadedFileIds.indexOf(fileId) >= 0) {
                this.$message({ message: '该文件已下载过，本次不扣费', type: 'info' })
                this.doDownloadOnly(downloadType)
                return
            }
            this.pendingDownloadType = downloadType
            if (!this.coinChargeEnabled) {
                this.chooseUseCoin()
                return
            }
            this.showCoinChoiceDialog = true
        },
        useCoinAndDownload(downloadType) {
            const token = this.$store.state.user && this.$store.state.user.token
            const baseUrl = this.$store.state.basicurl
            const currentFileId = this.lastPlayedFilename || this.datapath
            const doAudio = () => {
                const a = document.createElement('a')
                a.style.display = 'none'
                a.href = token ? `${baseUrl}getdownload?id=${currentFileId}&token=${encodeURIComponent(token)}` : `${baseUrl}getdownload?id=${currentFileId}`
                a.click()
                a.remove()
            }
            const doVideo = () => {
                this.$axios.post('/makemp4', { filename: this.datapath, token: token || '' }).then(res => {
                    const a = document.createElement('a')
                    a.style.display = 'none'
                    a.href = `${baseUrl}getmp4file?id=${res.data}`
                    a.click()
                    a.remove()
                })
            }
            const doListAudio = () => {
                const a = document.createElement('a')
                a.style.display = 'none'
                a.href = token ? `${baseUrl}getdownload?id=${this.row.filename}&token=${encodeURIComponent(token)}` : `${baseUrl}getdownload?id=${this.row.filename}`
                a.click()
                a.remove()
            }
            const required = this.downloadCoinsRequired
            const fileId = this.getCurrentFileId(downloadType)
            const finish = () => {
                const charged = this.coinChargeEnabled && required > 0
                const cur = this.$store.state.user && this.$store.state.user.coins
                if (charged) this.$store.commit('SetUserCoins', Math.max(0, (cur || 0) - required))
                let msg = '当前为限时免费模式，本次未扣金币'
                if (charged) {
                    msg = `已扣除 ${required} 金币`
                    if (downloadType === '播放音频') msg += `（播放音频，每500字1金币，不足500按500算）`
                    else if (downloadType === '下载音频' || downloadType === '列表下载音频') msg += `（下载音频，固定1金币）`
                    else msg += `（本次约 ${this.pendingDownloadCharCount} 字，每500字1金币，不足500按500算）`
                }
                this.$message({ message: msg, type: 'success' })
                const remark = downloadType === '播放音频' ? `播放音频（约${this.pendingDownloadCharCount}字）` : `${downloadType}（约${this.pendingDownloadCharCount}字）`
                const logToken = (this.$store.state.user && this.$store.state.user.token) ? this.$store.state.user.token : ''
                const logPayload = { token: logToken, type: 'spend', amount: required, remark, fileId: fileId || undefined }
                const logHeaders = logToken ? { Authorization: 'Bearer ' + logToken } : {}
                this.$axios.post('/user/coin/log', logPayload, { headers: logHeaders })
                    .then((res) => {
                        if (res.data && res.data.coins != null) this.$store.commit('SetUserCoins', res.data.coins)
                        if (fileId && this.downloadedFileIds.indexOf(fileId) < 0) this.downloadedFileIds.push(fileId)
                    })
                    .catch((err) => {
                        const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : (err.response && err.response.status === 401 ? '请先登录（或登录已过期）' : '流水记录失败')
                        this.$message({ message: msg, type: 'warning' })
                    })
            }
            if (downloadType === '下载音频') { doAudio(); finish() }
            else if (downloadType === '下载视频') { doVideo(); finish() }
            else if (downloadType === '列表下载音频') { doListAudio(); finish() }
            else if (downloadType === '播放音频') {
                const remark = `播放音频（约${this.pendingDownloadCharCount}字）`
                this.spendCoinsForTtsAction({
                    amount: required,
                    remark,
                    fileId: fileId || undefined,
                    failureHint: '流水记录失败'
                }).then(({ charged }) => {
                        const msg = charged
                            ? `已扣除 ${required} 金币（播放音频，每500字1金币，不足500按500算）`
                            : '当前为限时免费模式，本次未扣金币，正在播放音频'
                        this.$message({ message: msg, type: 'success' })
                        this.Makevoice('play', { skipCoinDialog: true })
                    })
                    .catch(() => {})
            }
        },
        goLoginFromPrompt() {
            this.showLoginPrompt = false
            this.$store.commit('SetShowLoginDialog', { show: true, tab: 'login' })
        },
        goRegisterFromPrompt() {
            this.showLoginPrompt = false
            this.$store.commit('SetShowLoginDialog', { show: true, tab: 'register' })
        },
        chooseUseCoin() {
            this.showCoinChoiceDialog = false
            if (this.pendingDownloadType === '拼接音频') {
                this.doSpliceWithCoin()
                this.pendingDownloadType = null
                return
            }
            if (this.pendingDownloadType === '播放音频') {
                if (this.ttsReadMode === 'favorite' || this.isLongPlayBatch()) this.useCoinAndPlayBatch()
                else this.useCoinAndDownload('播放音频')
                this.pendingDownloadType = null
                return
            }
            if (this.pendingDownloadType) {
                this.useCoinAndDownload(this.pendingDownloadType)
                this.pendingDownloadType = null
            }
        },
        chooseWatchVideo() {
            this.showCoinChoiceDialog = false
            if (this.pendingDownloadType) {
                this.codetype = this.pendingDownloadType
                this.pendingDownloadType = null
                if (this.$store.state.miniProgramCoinFeatureEnabled) {
                    this.$store.commit('SetOpenEarnCoinDialog', true)
                    return
                }
                if (this.$store.state.legacyCoinFeatureEnabled !== false) {
                    this.showcode = true
                    return
                }
                this.$message({ message: '当前未开启看视频功能', type: 'warning' })
            }
        },
        async chooseBaiduPanFree() {
            this.showCoinChoiceDialog = false
            this.baiduPanShareUrl = ''
            this.baiduPanSharePwd = ''
            this.baiduPanShareText = ''
            this.baiduPanPwdCopied = false
            const t = this.pendingDownloadType
            const savedPlayCharCount = this.pendingDownloadCharCount
            this.pendingDownloadType = null
            if (!t) return
            if (t === '播放音频') {
                await this.runBaiduPanPlayAudioFlow(savedPlayCharCount)
                return
            }
            if (t === '下载音频') {
                const fileId = this.lastPlayedFilename || this.datapath
                if (!fileId) {
                    this.$message({ message: '请先播放音频后再上传百度网盘', type: 'warning' })
                    return
                }
                if (this.baiduPanFreeFileIds.indexOf(fileId) < 0) this.baiduPanFreeFileIds.push(fileId)
                return this.uploadToBaiduPanAndOpenShare('tts', fileId)
            }
            if (t === '列表下载音频') {
                const fileId = this.row && this.row.filename
                if (!fileId) {
                    this.$message({ message: '未找到音频文件', type: 'warning' })
                    return
                }
                if (this.baiduPanFreeFileIds.indexOf(fileId) < 0) this.baiduPanFreeFileIds.push(fileId)
                return this.uploadToBaiduPanAndOpenShare('tts', fileId)
            }
            if (t === '下载视频') {
                if (!this.datapath) {
                    this.$message({ message: '请先播放音频后再生成视频', type: 'warning' })
                    return
                }
                try {
                    const r = await this.$axios.post('/makemp4', { filename: this.datapath })
                    const videoName = r && r.data ? String(r.data) : ''
                    if (!videoName) {
                        this.$message({ message: '生成视频失败，请稍后重试', type: 'warning' })
                        return
                    }
                    return this.uploadToBaiduPanAndOpenShare('azure-video', videoName)
                } catch (e) {
                    this.$message({ message: '生成视频失败，请稍后重试', type: 'warning' })
                }
            }
            this.$message({ message: '当前下载类型暂不支持百度网盘免费模式', type: 'warning' })
        },
        openBaiduPanShareUrl() {
            const link = this.buildBaiduPanOpenUrl(this.baiduPanShareUrl, this.baiduPanSharePwd)
            if (!link) return
            // 跳转后不要继续播放（避免用户误以为还在“播放音频”）
            try {
                const audio = this.$refs.audio
                if (audio && audio.pause) audio.pause()
            } catch (e) { /* ignore */ }
            this.btnstyleindex = 0
            this.btnAuditionstyleindex = 0
            this.listPlayingFilename = null
            this.listAudioPaused = true
            window.open(link, '_blank')
        },
        buildBaiduPanOpenUrl(linkRaw, pwdRaw) {
            const link = (linkRaw || '').toString().trim()
            if (!link) return ''
            const pwd = (pwdRaw || '').toString().trim()
            if (!pwd) return link
            // 百度网盘网页端提取码参数常见为 ?pwd=xxxx；部分链接会把参数 hash 在 # 后面，这里也兼容
            const encoded = encodeURIComponent(pwd)
            if (/[?&]pwd=/.test(link) || /[#&?]pwd=/.test(link)) return link
            const hashIdx = link.indexOf('#')
            if (hashIdx >= 0) {
                const base = link.slice(0, hashIdx)
                const hash = link.slice(hashIdx) // includes '#'
                const sep = hash.indexOf('?') >= 0 || hash.indexOf('&') >= 0 ? '&' : '?'
                return base + hash + sep + 'pwd=' + encoded
            }
            return link + (link.indexOf('?') >= 0 ? '&' : '?') + 'pwd=' + encoded
        },
        copyBaiduPanShareText() {
            const text = (this.baiduPanShareText || '').trim()
            if (!text) return
            this.copyTextToClipboard(text, '已复制')
        },
        copyTextToClipboard(text, okMsg) {
            const v = (text || '').toString()
            if (!v) return Promise.resolve(false)
            // 优先使用 Clipboard API
            if (navigator.clipboard && navigator.clipboard.writeText) {
                return navigator.clipboard.writeText(v).then(() => {
                    if (okMsg) this.$message({ message: okMsg, type: 'success' })
                    return true
                }).catch(() => {
                    this.$message({ message: '复制失败，请手动复制', type: 'warning' })
                    return false
                })
            }
            // 兼容老浏览器：textarea + execCommand
            try {
                const ta = document.createElement('textarea')
                ta.value = v
                ta.setAttribute('readonly', 'readonly')
                ta.style.position = 'fixed'
                ta.style.left = '-9999px'
                ta.style.top = '-9999px'
                document.body.appendChild(ta)
                ta.select()
                const ok = document.execCommand && document.execCommand('copy')
                document.body.removeChild(ta)
                if (ok) {
                    if (okMsg) this.$message({ message: okMsg, type: 'success' })
                    return Promise.resolve(true)
                }
            } catch (e) { /* ignore */ }
            this.$message({ message: '当前浏览器不支持一键复制，请手动复制', type: 'warning' })
            return Promise.resolve(false)
        },
        autoCopyBaiduPanPwdIfNeeded() {
            const pwd = (this.baiduPanSharePwd || '').trim()
            if (!pwd || this.baiduPanPwdCopied) return
            this.baiduPanPwdCopied = true
            this.copyTextToClipboard(pwd, '提取码已复制到剪贴板')
        },
        async _doBaiduPanUploadShare(biz, filename) {
            const r = await this.$axios.post('/cloud/baidu-pan/upload-share', { biz, filename })
            const d = r && r.data ? r.data : {}
            if (!d.success) {
                this.$message({ message: d.message || '上传百度网盘失败', type: 'warning' })
                return null
            }
            // 优先使用 /s/ 短链：网页端可直接用 ?pwd=xxxx；部分接口返回的 shareUrl 可能是 verify 页，不适合拼 pwd
            const shortUrl = d.shareShortUrl || ''
            const fullUrl = d.shareUrl || ''
            const preferShort = typeof shortUrl === 'string' && /pan\.baidu\.com\/s\//.test(shortUrl)
            const link = (preferShort ? shortUrl : (fullUrl || shortUrl)) || ''
            const pwd = d.sharePwd || ''
            const shareText = d.shareText || ''
            if (!link) {
                this.$message({ message: '已上传百度网盘，但未返回分享链接', type: 'warning' })
                return null
            }
            return { link, pwd, shareText }
        },
        async uploadToBaiduPanAndOpenShare(biz, filename) {
            const defaultMsg = '正在上传百度网盘并生成分享链接，请稍候…'
            this.baiduPanLoadingBody = defaultMsg
            this.showBaiduPanLoadingDialog = true
            try {
                const out = await this._doBaiduPanUploadShare(biz, filename)
                if (out && out.link) {
                    this.baiduPanShareUrl = out.link
                    this.baiduPanSharePwd = out.pwd || ''
                    this.baiduPanShareText = out.shareText || ''
                    this.baiduPanLoadingBody = '分享链接已生成，请点击下载'
                    this.autoCopyBaiduPanPwdIfNeeded()
                }
            } catch (e) {
                const msg = e && e.response && e.response.data && e.response.data.message
                    ? e.response.data.message
                    : '上传百度网盘失败，请稍后重试'
                this.$message({ message: msg, type: 'warning' })
            } finally {
                // 有链接则留在弹窗里让用户点“点击下载”（避免浏览器拦截）
                if (!this.baiduPanShareUrl) {
                    this.baiduPanLoadingBody = defaultMsg
                    this.showBaiduPanLoadingDialog = false
                }
            }
        },
        async runBaiduPanPlayAudioFlow(savedPlayCharCount) {
            const defaultMsg = '正在上传百度网盘并生成分享链接，请稍候…'
            this.baiduPanLoadingBody = '语音正在合成，请稍候…'
            this.showBaiduPanLoadingDialog = true
            try {
                if (this.ttsReadMode === 'favorite' || this.isLongPlayBatch()) {
                    await this.runBaiduPanPlayBatchSynthesis()
                } else {
                    await this.runBaiduPanPlayShortSynthesis(savedPlayCharCount)
                }
                const fileId = this.lastPlayedFilename || this.datapath
                if (!fileId) {
                    this.$message({ message: '合成完成但未找到音频文件', type: 'warning' })
                    return
                }
                // 只要合成成功产生了文件名，就标记：后续下载仍需再次弹扣费框
                if (this.baiduPanPlayPaidFileIds.indexOf(fileId) < 0) this.baiduPanPlayPaidFileIds.push(fileId)
                // 百度网盘免费下载：不标注“已下载/再次下载”
                if (this.baiduPanFreeFileIds.indexOf(fileId) < 0) this.baiduPanFreeFileIds.push(fileId)
                this.baiduPanLoadingBody = defaultMsg
                try {
                    const out = await this._doBaiduPanUploadShare('tts', fileId)
                    if (out && out.link) {
                        this.baiduPanShareUrl = out.link
                        this.baiduPanSharePwd = out.pwd || ''
                        this.baiduPanShareText = out.shareText || ''
                        this.baiduPanLoadingBody = '分享链接已生成，请点击下载'
                        this.autoCopyBaiduPanPwdIfNeeded()
                    }
                } catch (e) {
                    const msg = e && e.response && e.response.data && e.response.data.message
                        ? e.response.data.message
                        : '上传百度网盘失败，请稍后重试'
                    this.$message({ message: msg, type: 'warning' })
                }
            } finally {
                if (!this.baiduPanShareUrl) {
                    this.baiduPanLoadingBody = defaultMsg
                    this.showBaiduPanLoadingDialog = false
                }
            }
        },
        async runBaiduPanPlayShortSynthesis(savedPlayCharCount) {
            const n = savedPlayCharCount || (this.voicevalue.wenben || '').length
            const required = Math.max(1, Math.ceil(n / 500))
            await this.spendCoinsForTtsAction({
                amount: required,
                remark: `播放音频·网盘（约${n}字）`,
                fileId: undefined,
                failureHint: '流水记录失败'
            })
            // 选择「百度网盘免费下载」时不会经过 Makevoice() 的 voicetext 赋值，这里补上避免合成空文本/旧文本
            this.voicetext = (this.voicevalue.wenben || '').replace(/\&/g, '')
            let out
            try {
                out = await this.makeaudio('ok', 'play', { skipSynthProgress: true, skipRegisterPaidFile: true })
            } catch (e) { out = null }
            if (!out || !out.ok) {
                try {
                    out = await this.makeaudio('spare', 'play', { skipSynthProgress: true, skipRegisterPaidFile: true })
                } catch (e2) { out = null }
            }
            if (!out || !out.ok) {
                this.compensateTtsFailureIfNeeded()
                throw new Error('synth_failed')
            }
        },
        async runBaiduPanPlayBatchSynthesis() {
            if (this.ttsReadMode === 'favorite') {
                try {
                    await this.runFavoriteConfiguredPlayBatch('baidu')
                } catch (e) {
                    this.$message({ message: '语音合成失败，请检查网络或稍后重试', type: 'error' })
                }
                return
            }
            const chunks = this.getPlayTextChunks()
            const fullText = chunks.join('')
            const filenames = []
            const segmentTracks = []
            this.loading = true
            try {
                for (let i = 0; i < chunks.length; i++) {
                    const ch = chunks[i]
                    const required = Math.max(1, Math.ceil(ch.length / 500))
                    await this.spendCoinsForTtsAction({
                        amount: required,
                        remark: `播放音频·网盘 分段 ${i + 1}/${chunks.length}（约${ch.length}字）`,
                        fileId: undefined,
                        failureHint: '流水记录失败'
                    })
                    this.baiduPanLoadingBody = `语音正在合成（第 ${i + 1}/${chunks.length} 段），请稍候…`
                    this.voicetext = ch
                    let out
                    try {
                        out = await this.makeaudio('ok', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: false, skipSaveRecent: true, skipSynthProgress: true })
                    } catch (e) { out = null }
                    if (!out || !out.ok) {
                        try {
                            out = await this.makeaudio('spare', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: false, skipSaveRecent: true, skipSynthProgress: true })
                        } catch (e2) { out = null }
                    }
                    if (!out || !out.ok) {
                        this.compensateTtsFailureIfNeeded()
                        throw new Error('synth_failed')
                    }
                    filenames.push(out.filename)
                    if (out.track && out.track.visemes && out.track.visemes.length) segmentTracks.push(out.track)
                    await this.loadRecordList()
                }
                this.baiduPanLoadingBody = '语音正在合成（拼接长音频），请稍候…'
                await this.concatPlaySegmentsAndFinish(filenames, fullText, {
                    quietUi: true,
                    rethrowOnError: true,
                    visemeTrack: this.mergeVisemeTracks(segmentTracks, '', fullText)
                })
            } finally {
                this.loading = false
            }
        },
        choosePayDirect(payType) {
            this.showCoinChoiceDialog = false
            if (this.pendingDownloadType) {
                this.codetype = this.pendingDownloadType
                let payAmt = this.money
                if (this.pendingDownloadType === '播放音频' && (this.ttsReadMode === 'favorite' || this.isLongPlayBatch())) {
                    const ppc = Number(this.pricePerCoin) > 0 ? Number(this.pricePerCoin) : 0.1
                    payAmt = Number((this.playBatchCoinsTotal() * ppc).toFixed(2))
                    if (isNaN(payAmt) || payAmt < 0.01) payAmt = 0.01
                }
                this.currentPayType = payType === 'wechat' ? 'wepay' : 'alipay'
                this.doPayment(payAmt, '语音合成', this.currentPayType)
                this.pendingDownloadType = null
            }
        },
        formatRecordDate(datetime, monthDayOnly) {
            if (!datetime) return ''
            const s = String(datetime).trim()
            const i = s.indexOf(' ')
            const dateOnly = i >= 0 ? s.substring(0, i) : s
            const full = dateOnly.length >= 10 ? dateOnly.substring(0, 10) : dateOnly
            if (monthDayOnly) {
                const m = dateOnly.match(/\d{4}[-/](\d{1,2})[-/](\d{1,2})/)
                if (m) return m[1].padStart(2, '0') + '-' + m[2].padStart(2, '0')
                if (full.length >= 10) return full.substring(5, 10)
            }
            return full
        },
        loadRecordList() {
            if (!this.userId) {
                this.tableData = []
                return Promise.resolve()
            }
            return this.$axios.post("/getAzurettsRecord", { orderid: this.userId }).then(response => {
                this.tableData = response.data || []
            }).catch(() => { this.tableData = [] })
        },
        getPlayTextChunks() {
            const raw = (this.voicevalue.wenben || '').replace(/\&/g, '')
            if (raw.length <= TTS_PLAY_CHUNK_SIZE) return [raw]
            const chunks = []
            for (let i = 0; i < raw.length; i += TTS_PLAY_CHUNK_SIZE) {
                chunks.push(raw.slice(i, i + TTS_PLAY_CHUNK_SIZE))
            }
            return chunks
        },
        getFavoritePlayUnits() {
            return this.buildFavoriteSynthesisUnits('play', false)
        },
        playBatchCoinsTotal() {
            if (this.ttsReadMode === 'favorite') {
                const fullText = this.buildFavoriteSynthesisText(this.getFavoritePlayUnits())
                return fullText ? Math.max(1, Math.ceil(fullText.length / 500)) : 0
            }
            const units = this.getPlayTextChunks()
            return units.reduce((s, item) => {
                const text = typeof item === 'string' ? item : item.text
                return s + Math.max(1, Math.ceil(String(text || '').length / 500))
            }, 0)
        },
        isLongPlayBatch() {
            if (this.ttsEngine !== 'azure') return false
            if (this.ttsReadMode === 'favorite') return false
            return this.getPlayTextChunks().length > 1
        },
        async runFavoriteConfiguredPlayBatch(mode) {
            const units = this.buildFavoriteSynthesisUnits('play', true)
            if (!units.length) return
            const fullText = this.buildFavoriteSynthesisText(units)
            const ssml = this.buildFavoriteSsml(units)
            if (!ssml) {
                this.$message.warning('当前段落缺少可用的配音配置')
                return
            }
            const filenames = []
            const segmentTracks = []
            const snapshot = this.captureCurrentVoiceConfig()
            const fileId = this.getCurrentFileId('播放音频')
            this.clickitem('live2d')
            this.loading = true
            this.ttsBatchInProgress = true
            this.ttsBatchLoadingText = '正在提交多角色单次合成请求，请稍候…'
            try {
                const requiredTotal = Math.max(1, Math.ceil(fullText.length / 500))
                if (mode === 'coin') {
                    try {
                        await this.spendCoinsForTtsAction({
                            amount: requiredTotal,
                            remark: `播放音频（多角色单次合成，约${fullText.length}字）`,
                            fileId: fileId || undefined,
                            failureHint: '流水记录失败'
                        })
                    } catch (err) {
                        return
                    }
                }
                if (mode === 'baidu') {
                    this.baiduPanLoadingBody = '语音正在合成（多角色单次请求），请稍候…'
                }
                let out = null
                try {
                    out = await this.makeaudio('ok', 'play', {
                        quietPlayer: false,
                        batchRetainCompensation: false,
                        skipSaveRecent: false,
                        skipSynthProgress: mode === 'baidu',
                        skipRegisterPaidFile: mode === 'baidu',
                        ssmlOverride: ssml,
                        textOverride: fullText
                    })
                } catch (e) {
                    out = null
                }
                if (!out || !out.ok) {
                    try {
                        out = await this.makeaudio('spare', 'play', {
                            quietPlayer: false,
                            batchRetainCompensation: false,
                            skipSaveRecent: false,
                            skipSynthProgress: mode === 'baidu',
                            skipRegisterPaidFile: mode === 'baidu',
                            ssmlOverride: ssml,
                            textOverride: fullText
                        })
                    } catch (e2) {
                        out = null
                    }
                }
                if (!out || !out.ok) {
                    if (mode === 'coin' || mode === 'cash') this.compensateTtsFailureIfNeeded()
                    throw new Error('synth_failed')
                }
                if (mode === 'cash') this.ttsPaidCompensation = null
                return out
                for (let i = 0; i < units.length; i++) {
                    const unit = units[i]
                    const required = Math.max(1, Math.ceil(unit.text.length / 500))
                    if (mode === 'coin') {
                        const curBefore = (this.$store.state.user && this.$store.state.user.coins) || 0
                        this.$store.commit('SetUserCoins', Math.max(0, curBefore - required))
                        try {
                            const r = await this.$axios.post('/user/coin/log', {
                                token: token || '',
                                type: 'spend',
                                amount: required,
                                remark: `播放音频分段 ${i + 1}/${units.length}（约${unit.text.length}字）`,
                                fileId: fileId || undefined
                            }, { headers: logHeaders })
                            if (r.data && r.data.coins != null) this.$store.commit('SetUserCoins', r.data.coins)
                        } catch (err) {
                            this.$store.commit('SetUserCoins', curBefore)
                            this.handlePlayCoinShortage(err, '流水记录失败')
                            return
                        }
                        this.ttsPaidCompensation = { mode: 'coin', coins: required }
                    }
                    this.setTtsBatchSegmentProgress(i + 1, units.length)
                    this.voicetext = unit.text
                    const out = await this.synthesizeFavoriteUnit(unit, 'play', {
                        quietPlayer: true,
                        batchRetainCompensation: mode === 'cash' ? i !== units.length - 1 : false,
                        skipSaveRecent: true,
                        skipSynthProgress: mode === 'baidu'
                    })
                    if (!out || !out.ok) {
                        if (mode === 'coin' || mode === 'cash') this.compensateTtsFailureIfNeeded()
                        throw new Error('synth_failed')
                    }
                    filenames.push(out.filename)
                    if (out.track && out.track.visemes && out.track.visemes.length) segmentTracks.push(out.track)
                    await this.loadRecordList()
                    if (mode === 'baidu') {
                        this.baiduPanLoadingBody = `语音正在合成（第 ${i + 1}/${units.length} 段），请稍候…`
                    } else {
                        this.$message({ message: `已完成第 ${i + 1}/${units.length} 段`, type: 'success', duration: 1600 })
                    }
                }
                if (filenames.length > 1) {
                    if (mode === 'cash') this.ttsPaidCompensation = null
                    if (mode === 'baidu') {
                        this.baiduPanLoadingBody = '语音正在合成（拼接长音频），请稍候…'
                    } else {
                        this.setTtsBatchConcatProgress()
                    }
                    await this.concatPlaySegmentsAndFinish(filenames, fullText, {
                        quietUi: mode === 'baidu',
                        rethrowOnError: mode === 'baidu',
                        visemeTrack: this.mergeVisemeTracks(segmentTracks, '', fullText)
                    })
                } else if (filenames.length === 1) {
                    if (mode === 'cash') this.ttsPaidCompensation = null
                    await this.finalizeFavoriteSingleOutput({
                        filename: filenames[0],
                        track: segmentTracks[0] || null
                    }, fullText, 'play')
                }
            } finally {
                await this.applyVoiceConfigAsync(snapshot, { silent: true })
                this.loading = false
                this.clearTtsBatchUi()
            }
        },
        setTtsBatchSegmentProgress(segmentIndex, totalSegments) {
            this.ttsBatchInProgress = true
            this.ttsBatchLoadingText = `正在生成第 ${segmentIndex} 段音频，共 ${totalSegments} 段，请稍候…`
        },
        setTtsBatchConcatProgress() {
            this.ttsBatchInProgress = true
            this.ttsBatchLoadingText = '音频已全部生成完成，正在拼接中，请稍候…'
        },
        clearTtsBatchUi() {
            this.ttsBatchInProgress = false
            this.ttsBatchLoadingText = ''
        },
        /** 粗略估算合成+上传耗时（秒），语速越快朗读时间越短 */
        estimateSynthSeconds(charCount) {
            const n = Math.max(0, parseInt(charCount, 10) || 0)
            const rate = Math.max(0.5, (this.voicevalue && this.voicevalue.speech_rate) ? this.voicevalue.speech_rate / 100 : 1)
            const readSec = n > 0 ? n / (4.8 * rate) : 4
            const overhead = 4 + Math.min(28, n / 200)
            return Math.max(6, readSec + overhead)
        },
        buildSynthEtaHint(charCount) {
            const sec = this.estimateSynthSeconds(charCount)
            if (sec <= 90) {
                const rounded = Math.max(5, Math.round(sec / 5) * 5)
                return `预计约 ${rounded} 秒内完成（仅供参考，受网速影响）`
            }
            const m = Math.max(1, Math.round(sec / 60))
            return `预计约 ${m} 分钟（仅供参考，受网速影响）`
        },
        _innerClearSynthTickers() {
            if (this.synthProgressTimer != null) {
                clearInterval(this.synthProgressTimer)
                this.synthProgressTimer = null
            }
            if (this.synthProgressFinishTimer != null) {
                clearTimeout(this.synthProgressFinishTimer)
                this.synthProgressFinishTimer = null
            }
        },
        cancelSynthProgressAnim() {
            this._innerClearSynthTickers()
            this.synthProgress = 0
            this.synthEtaHint = ''
            this.synthProgressStripVisible = false
        },
        /** mode==='concat' 时仅显示拼接说明，不按字数估时 */
        startSynthProgressAnim(charCount, mode) {
            this._innerClearSynthTickers()
            this.synthProgressStripVisible = true
            this.synthProgress = 4
            if (mode === 'concat') {
                this.synthEtaHint = '服务器正在拼接多段音频，请稍候（耗时因长度而异）'
            } else {
                this.synthEtaHint = this.buildSynthEtaHint(charCount)
            }
            const cap = 93
            this.synthProgressTimer = setInterval(() => {
                const p = this.synthProgress
                if (p >= cap) return
                const step = Math.max(0.35, (cap - p) * 0.034 + 0.22)
                this.synthProgress = Math.min(cap, p + step)
            }, 380)
        },
        finishSynthProgressAnim() {
            this._innerClearSynthTickers()
            this.synthProgress = 100
            this.synthEtaHint = ''
            this.synthProgressFinishTimer = setTimeout(() => {
                this.synthProgress = 0
                this.synthProgressStripVisible = false
                this.synthProgressFinishTimer = null
            }, 420)
        },
        buildSsmlForText(textBody) {
            const v = this.voicevalue.voice
            const voiceName = (v && (v.voice || v.Voice)) ? String(v.voice || v.Voice).trim() : ''
            const lang = (this.voicevalue.language && this.voicevalue.language.language) ? this.voicevalue.language.language : 'zh-CN'
            const bg = this.voicevalue.backgroundaudio
            const bgSrc = (bg && bg.src) ? this.normalizeBackgroundAudioUrl(bg.src) : ''
            const bgAttrs = bgSrc ? ` src="${this.escapeXmlAttr(bgSrc)}" volume="${(bg.volume || 0) / 10}" fadein="${bg.fadein || 0}" fadeout="${bg.fadeout || 0}"` : ''
            const prosody = `<prosody rate="${(this.voicevalue.speech_rate - 100) + '%'}" pitch="${(this.voicevalue.pitch_rate - 100) + '%'}" volume="${(this.voicevalue.volume - 100) + '%'}">${textBody}</prosody>`
            const st = this.voicevalue.style
            const styleKey = (st && (st.style != null || st.Style != null)) ? String(st.style != null ? st.style : st.Style).trim() : ''
            const ro = this.voicevalue.role
            const roleKey = (ro && (ro.role != null || ro.Role != null)) ? String(ro.role != null ? ro.role : ro.Role).trim() : ''
            let deg = (this.voicevalue.Stylestrength != null) ? this.voicevalue.Stylestrength / 100 : 1
            if (deg < 0.01) deg = 0.01
            if (deg > 2) deg = 2
            const degStr = String(Math.round(deg * 100) / 100)
            let voiceInner = prosody
            if (styleKey || roleKey) {
                const parts = []
                if (styleKey) parts.push(`style="${this.escapeXmlAttr(styleKey)}"`)
                if (roleKey) parts.push(`role="${this.escapeXmlAttr(roleKey)}"`)
                parts.push(`styledegree="${degStr}"`)
                voiceInner = `<mstts:express-as ${parts.join(' ')}>${prosody}</mstts:express-as>`
            }
            return `<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="${this.escapeXmlAttr(lang)}"><mstts:backgroundaudio${bgAttrs}/><voice name="${this.escapeXmlAttr(voiceName)}">${voiceInner}</voice></speak>`.replace(/></g, ">\n<")
        },
        async concatPlaySegmentsAndFinish(filenames, fullText, opts = {}) {
            if (!filenames || filenames.length < 2) return
            const quietUi = !!(opts && opts.quietUi)
            const mergedTrack = opts && opts.visemeTrack ? this.buildVisemeTrack(opts.visemeTrack) : null
            const token = this.$store.state.user && this.$store.state.user.token
            const headers = token ? { Authorization: 'Bearer ' + token } : {}
            if (!quietUi) this.startSynthProgressAnim(0, 'concat')
            try {
                const cr = await this.$axios.post('/azuretts/concat-segments', {
                    files: filenames,
                    orderid: String(this.userId),
                    wenben: fullText,
                    token: token || ''
                }, { headers })
                const merged = cr.data && cr.data.filename
                if (!merged) {
                    if (!quietUi) this.cancelSynthProgressAnim()
                    throw new Error('no filename')
                }
                this.datapath = merged
                this.lastPlayedFilename = merged
                this.lastPlayedCharCount = fullText.length
                this.lastGeneratedWasAudition = false
                this.voicetext = fullText.replace(/\&/g, '')
                this.listPlayingFilename = null
                const url = this.$store.state.basicurl + merged
                this.$refs.audio.src = url
                if (mergedTrack && mergedTrack.visemes.length) {
                    this.setCurrentVisemeTrack({ ...mergedTrack, key: merged })
                } else {
                    this.clearCurrentVisemeTrack('当前音频没有视素数据')
                }
                this.btnstyleindex = 1
                this.$nextTick(() => {
                    const el = this.$refs.audio
                    if (el && el.play) el.play().catch(() => {})
                })
                if (!quietUi) {
                    this.$message({ message: '长文本已全部合成并自动拼接完成', type: 'success' })
                }
                await this.loadRecordList()
                this.saveRecentVoice()
                await this.registerPaidTtsFile(merged)
                if (!quietUi) this.finishSynthProgressAnim()
            } catch (e) {
                if (!quietUi) this.cancelSynthProgressAnim()
                this.$message({ message: '分段已生成，但自动拼接失败，请在列表中勾选分段后点「拼接选中的文件」', type: 'warning' })
                if (opts && opts.rethrowOnError) throw e
            }
        },
        async useCoinAndPlayBatch() {
            if (this.ttsReadMode === 'favorite') {
                try {
                    await this.runFavoriteConfiguredPlayBatch('coin')
                } catch (e) {
                    this.$message({ message: '语音合成失败，请检查网络或稍后重试', type: 'error' })
                }
                return
            }
            const chunks = this.getPlayTextChunks()
            const fullText = chunks.join('')
            const fileId = this.getCurrentFileId('播放音频')
            const filenames = []
            const segmentTracks = []
            this.loading = true
            this.setTtsBatchSegmentProgress(1, chunks.length)
            try {
                for (let i = 0; i < chunks.length; i++) {
                    const ch = chunks[i]
                    const required = Math.max(1, Math.ceil(ch.length / 500))
                    try {
                        await this.spendCoinsForTtsAction({
                            amount: required,
                            remark: `播放音频分段 ${i + 1}/${chunks.length}（约${ch.length}字）`,
                            fileId: fileId || undefined,
                            failureHint: '流水记录失败'
                        })
                    } catch (err) {
                        return
                    }
                    this.setTtsBatchSegmentProgress(i + 1, chunks.length)
                    this.voicetext = ch
                    let out
                    try {
                        out = await this.makeaudio('ok', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: false, skipSaveRecent: true })
                    } catch (e) { out = null }
                    if (!out || !out.ok) {
                        try {
                            out = await this.makeaudio('spare', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: false, skipSaveRecent: true })
                        } catch (e2) { out = null }
                    }
                    if (!out || !out.ok) {
                        this.compensateTtsFailureIfNeeded()
                        return
                    }
                    filenames.push(out.filename)
                    if (out.track && out.track.visemes && out.track.visemes.length) segmentTracks.push(out.track)
                    await this.loadRecordList()
                    this.$message({ message: `已完成第 ${i + 1}/${chunks.length} 段`, type: 'success', duration: 1600 })
                }
                this.setTtsBatchConcatProgress()
                await this.concatPlaySegmentsAndFinish(filenames, fullText, {
                    visemeTrack: this.mergeVisemeTracks(segmentTracks, '', fullText)
                })
            } finally {
                this.loading = false
                this.clearTtsBatchUi()
            }
        },
        async startPlayBatchCash() {
            if (this.ttsReadMode === 'favorite') {
                try {
                    await this.runFavoriteConfiguredPlayBatch('cash')
                } catch (e) {
                    this.$message({ message: '语音合成失败，请检查网络或稍后重试', type: 'error' })
                }
                return
            }
            const chunks = this.getPlayTextChunks()
            const fullText = chunks.join('')
            const filenames = []
            const segmentTracks = []
            this.loading = true
            this.setTtsBatchSegmentProgress(1, chunks.length)
            try {
                for (let i = 0; i < chunks.length; i++) {
                    const ch = chunks[i]
                    const isLast = i === chunks.length - 1
                    this.setTtsBatchSegmentProgress(i + 1, chunks.length)
                    this.voicetext = ch
                    let out
                    try {
                        out = await this.makeaudio('ok', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: !isLast, skipSaveRecent: true })
                    } catch (e) { out = null }
                    if (!out || !out.ok) {
                        try {
                            out = await this.makeaudio('spare', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: !isLast, skipSaveRecent: true })
                        } catch (e2) { out = null }
                    }
                    if (!out || !out.ok) {
                        this.compensateTtsFailureIfNeeded()
                        return
                    }
                    filenames.push(out.filename)
                    if (out.track && out.track.visemes && out.track.visemes.length) segmentTracks.push(out.track)
                    await this.loadRecordList()
                }
                this.ttsPaidCompensation = null
                this.setTtsBatchConcatProgress()
                await this.concatPlaySegmentsAndFinish(filenames, fullText, {
                    visemeTrack: this.mergeVisemeTracks(segmentTracks, '', fullText)
                })
            } finally {
                this.loading = false
                this.clearTtsBatchUi()
            }
        },
        async startPlayBatchVideo() {
            if (this.ttsReadMode === 'favorite') {
                try {
                    await this.runFavoriteConfiguredPlayBatch('video')
                } catch (e) {
                    this.$message({ message: '语音合成失败，请检查网络或稍后重试', type: 'error' })
                }
                return
            }
            const chunks = this.getPlayTextChunks()
            const fullText = chunks.join('')
            const filenames = []
            const segmentTracks = []
            this.loading = true
            this.setTtsBatchSegmentProgress(1, chunks.length)
            try {
                for (let i = 0; i < chunks.length; i++) {
                    const ch = chunks[i]
                    this.setTtsBatchSegmentProgress(i + 1, chunks.length)
                    this.voicetext = ch
                    let out
                    try {
                        out = await this.makeaudio('ok', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: false, skipSaveRecent: true })
                    } catch (e) { out = null }
                    if (!out || !out.ok) {
                        try {
                            out = await this.makeaudio('spare', 'play', { segmentText: ch, quietPlayer: true, batchRetainCompensation: false, skipSaveRecent: true })
                        } catch (e2) { out = null }
                    }
                    if (!out || !out.ok) {
                        this.$message({ message: '语音合成失败，请检查网络或稍后重试', type: 'error' })
                        return
                    }
                    filenames.push(out.filename)
                    if (out.track && out.track.visemes && out.track.visemes.length) segmentTracks.push(out.track)
                    await this.loadRecordList()
                    this.$message({ message: `已完成第 ${i + 1}/${chunks.length} 段`, type: 'success', duration: 1600 })
                }
                this.setTtsBatchConcatProgress()
                await this.concatPlaySegmentsAndFinish(filenames, fullText, {
                    visemeTrack: this.mergeVisemeTracks(segmentTracks, '', fullText)
                })
            } finally {
                this.loading = false
                this.clearTtsBatchUi()
            }
        },
        doRecordSearch() {
            if (!this.userId) {
                this.tableData = []
                return
            }
            const body = {
                orderid: this.userId,
                keyword: (this.recordSearchKeyword || '').trim() || undefined,
                startDate: this.recordSearchStartDate || undefined,
                endDate: this.recordSearchEndDate || undefined
            }
            this.$axios.post("/getAzurettsRecord", body).then(response => {
                this.tableData = response.data || []
            }).catch(() => { this.tableData = [] })
        },
        resetRecordList() {
            this.recordSearchKeyword = ''
            this.recordSearchStartDate = null
            this.recordSearchEndDate = null
            this.loadRecordList()
        },
        loadDownloadedList() {
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.downloadedFileIds = []
                return
            }
            this.$axios.get('/user/downloaded-list', { params: { token } }).then(res => {
                this.downloadedFileIds = Array.isArray(res.data) ? res.data : []
            }).catch(() => { this.downloadedFileIds = [] })
        },
        paystatus() {
            const wasBuyCoins = this.isBuyCoinsPayment
            const orderNo = this.paymentOrderNo
            const buyAmount = Number(this.buyCoinsCount) || 0
            this.dialogTableVisible = false
            this.$axios.post('/queryOrder', { out_trade_no: orderNo }).then(async (res) => {
                const txt = res.data == null ? '' : (typeof res.data === 'string' ? String(res.data).trim() : '')
                if (txt !== '交易完成') {
                    this.$message({ message: txt || '未检测到支付完成，若已付款请稍后刷新或联系客服', type: 'warning' })
                    return
                }
                if (wasBuyCoins) {
                    const token = this.$store.state.user && this.$store.state.user.token
                    if (!token || buyAmount <= 0) {
                        this.$message({ message: '登录已失效或数量异常，请重新登录后再试或联系客服核对订单', type: 'warning' })
                        this.isBuyCoinsPayment = false
                        return
                    }
                    try {
                        const payload = { token, type: 'earn', amount: buyAmount, remark: '购买金币' }
                        if (orderNo) payload.out_trade_no = orderNo
                        const r = await this.$axios.post('/user/coin/log', payload)
                        if (r.data && r.data.coins != null) {
                            this.$store.commit('SetUserCoins', r.data.coins)
                        } else {
                            const cur = this.$store.state.user && this.$store.state.user.coins
                            this.$store.commit('SetUserCoins', (cur || 0) + buyAmount)
                        }
                        this.$message({ message: '购买成功', type: 'success' })
                    } catch (e) {
                        const msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : (e.message || '金币到账失败，请刷新页面或联系客服')
                        this.$message({ message: msg, type: 'warning' })
                        const tok = this.$store.state.user && this.$store.state.user.token
                        if (tok) {
                            this.$axios.get('/user/profile', { params: { token: tok } }).then(pr => {
                                if (pr.data && pr.data.coins != null) this.$store.commit('SetUserCoins', pr.data.coins)
                            }).catch(() => {})
                        }
                    } finally {
                        this.isBuyCoinsPayment = false
                    }
                    return
                }
                this.havecode = true
                if (this.codetype == "下载音频") this.DownFile()
                if (this.codetype == "下载视频") this.Makemp4()
                if (this.codetype == '列表下载音频') {
                    const a = document.createElement('a')
                    a.style.display = 'none'
                    a.href = `${this.$store.state.basicurl}getdownload?id=${this.row.filename}`
                    a.click();
                    a.remove();
                }
                if (this.codetype === '拼接音频') this.doSpliceWithCoin()
                if (this.codetype === '播放音频') {
                    this.ttsPaidCompensation = { mode: 'cash', yuan: Number(this.money) || 0 }
                    if (this.ttsReadMode === 'favorite' || this.isLongPlayBatch()) this.startPlayBatchCash()
                    else this.Makevoice('play', { skipCoinDialog: true })
                }
            }).catch(err => {
                this.$message({ message: (err.response && err.response.data) || err.message || '查询支付状态失败，请稍后重试', type: 'warning' })
            })
        },
        doPayment(money, subject, payType) {
            const method = payType === 'wepay' ? 'wechat' : 'alipay'
            const data = { money, subject, payType: method }
            if (subject === '购买金币') {
                const token = this.$store.state.user && this.$store.state.user.token
                if (token) data.token = token
                data.coinAmount = Number(this.buyCoinsCount) || 0
            }
            this.$axios.post('/qrpayment', data).then(res => {
                if (res.data && (res.data.code === 'WECHAT_NOT_AVAILABLE' || res.data.code === 'WECHAT_ORDER_FAIL' || res.data.code === 'WECHAT_ORDER_ERROR')) {
                    this.$message({ message: res.data.message || '微信支付暂时不可用，请选择支付宝', type: 'warning' })
                    return
                }
                this.money = money
                this.qrimg = res.data.filename
                this.currentPayType = payType || 'alipay'
                this.dialogTableVisible = true
                this.paymentOrderNo = res.data.out_trade_no
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : (err.message || '支付请求失败，请稍后重试')
                this.$message({ message: msg, type: 'warning' })
            })
        },
        alipay() {
            this.showcode = false
            this.isBuyCoinsPayment = false
            this.currentPayType = 'alipay'
            this.doPayment(this.money, '语音合成', 'alipay')
        },
        confirmBuyCoins() {
            const count = Number(this.buyCoinsCount)
            if (isNaN(count) || count < 10) {
                this.$message({ message: '一次最少购买10个金币', type: 'warning' })
                return
            }
            const amount = Number(this.buyPaymentAmount)
            if (isNaN(amount) || amount <= 0) {
                this.$message({ message: '请输入有效的金币数量', type: 'warning' })
                return
            }
            this.showBuyCoinsDialog = false
            this.isBuyCoinsPayment = true
            const payType = this.buyCoinsPayType === 'wechat' ? 'wepay' : 'alipay'
            this.doPayment(amount, '购买金币', payType)
        },
        splicemusic(){
            if (this.multipleSelection.length === 0) {
                this.$alert('没有选中的音频文件', '提示', { confirmButtonText: '确定' })
                return
            }
            if (this.multipleSelection.length === 1) {
                this.$alert('1个文件没法拼接哦', '提示', { confirmButtonText: '确定' })
                return
            }
            if (this.multipleSelection.length > 10) {
                this.$alert('最多只能拼接10个文件哦', '提示', { confirmButtonText: '确定' })
                return
            }
            const user = this.$store.state.user
            if (!user) {
                this.$store.commit('SetPendingDownloadAction', '拼接音频')
                this.showLoginPrompt = true
                return
            }
            const files = this.multipleSelection.map(item => item.filename)
            this.pingjieloading = true
            this.$axios.post('/checksplicemusic', { files }).then(res => {
                this.pingjieloading = false
                if (!res.data || !res.data.ok) {
                    this.$message({ message: res.data && res.data.message ? res.data.message : '文件校验失败', type: 'warning' })
                    return
                }
                this.pendingDownloadType = '拼接音频'
                this.pendingDownloadCharCount = 0
                this.showCoinChoiceDialog = true
            }).catch(() => {
                this.pingjieloading = false
                this.$message({ message: '校验失败，请稍后重试', type: 'warning' })
            })
        },
        doSpliceWithCoin() {
            const token = this.$store.state.user && this.$store.state.user.token
            const orderid = this.userId
            if (!orderid) {
                this.$message({ message: '用户标识异常', type: 'warning' })
                return
            }
            const files = this.multipleSelection.map(r => r.filename)
            const wenben = this.multipleSelection.map(r => (r.data || '').trim()).filter(Boolean).join('')
            this.pingjieloading = true
            this.$axios.post('/getsplicemusic', { files, orderid, token, wenben }).then(res => {
                this.pingjieloading = false
                this.showCoinChoiceDialog = false
                this.pendingDownloadType = null
                if (res.data && res.data.coins != null) this.$store.commit('SetUserCoins', res.data.coins)
                this.$message({ message: '拼接成功，已出现在列表中，可在此播放或下载', type: 'success' })
                this.loadRecordList()
            }).catch(err => {
                this.pingjieloading = false
                const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : (err.response && err.response.status === 401 ? '请先登录' : '拼接失败')
                this.$message({ message: msg, type: 'warning' })
            })
        },
        handleCurrentChange(currentRow){
            if (currentRow) {
                this.voicevalue.wenben = currentRow.data
                this.currentRecordFilename = currentRow.filename
            } else {
                this.currentRecordFilename = null
            }
        },
        selectRecordCard(row) {
            this.currentRecordFilename = row.filename
            this.voicevalue.wenben = row.data || ''
        },
        /** mssql 等驱动可能返回小写 id，与模板里 ID 不一致 */
        ttsRecordRowId(row) {
            if (!row) return null
            const v = row.ID != null ? row.ID : row.id
            if (v == null || v === '') return null
            const n = parseInt(v, 10)
            return isNaN(n) ? v : n
        },
        deleteSelectedRecords() {
            if (!this.multipleSelection || this.multipleSelection.length === 0) {
                this.$message({ message: '请先勾选要删除的文件', type: 'warning' })
                return
            }
            this.$confirm(`确定删除选中的 ${this.multipleSelection.length} 个文件吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const list = this.multipleSelection.slice()
                this.multipleSelection = []
                let done = 0
                let fail = 0
                const total = list.length
                const finish = () => {
                    this.loadRecordList()
                    this.$nextTick(() => {
                        if (this.$refs.multipleTable && this.$refs.multipleTable.clearSelection) {
                            this.$refs.multipleTable.clearSelection()
                        }
                    })
                    if (fail > 0) {
                        this.$message({ type: 'warning', message: `已处理 ${total} 项，其中 ${fail} 项删除失败，请刷新后重试` })
                    } else {
                        this.$message({ type: 'success', message: '已删除选中的文件' })
                    }
                }
                list.forEach(row => {
                    const id = this.ttsRecordRowId(row)
                    this.$axios.post('/deleteAzurettsRecord', { filename: row.filename, ID: id }).then(res => {
                        if (res.data !== 'OK') fail++
                        done++
                        if (done >= total) finish()
                    }).catch(() => {
                        fail++
                        done++
                        if (done >= total) finish()
                    })
                })
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' })
            })
        },
        deleteoldmusic(index, row){
            this.$confirm('确定删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const rid = this.ttsRecordRowId(row)
                this.$axios({
                    url: "/deleteAzurettsRecord",
                    method: 'post',
                    data: { filename: row.filename, ID: rid },
                }).then(res => {
                    if(res.data=='OK'){
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.tableData = this.tableData.filter(value => value != row)
                    }
                    else
                        this.$message({
                            type: 'success',
                            message: '删除失败!'+res.data
                        });
                });
               
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        downloadoldmusic(index, row){
            this.row = row
            this.xuanzhongindex = index
            if (this.havecode) {
                const a = document.createElement('a')
                a.style.display = 'none'
                a.href = `${this.$store.state.basicurl}getdownload?id=${row.filename}`
                a.click()
                a.remove()
            } else {
                this.tryDownload('列表下载音频')
            }
        },        
        isListRowPlaying(row) {
            return this.listPlayingFilename && row.filename === this.listPlayingFilename
        },
        onListAudioPlay() {
            this.clickitem('live2d')
            if (this.listPlayingFilename) this.listAudioPaused = false
        },
        onListAudioPause() {
            if (this.listPlayingFilename) this.listAudioPaused = true
        },
        handleEdit(index, row) {
            const audio = this.$refs.audio
            if (!audio) return
            if (this.listPlayingFilename === row.filename && !this.listAudioPaused) {
                audio.pause()
                this.listAudioPaused = true
                return
            }
            if (this.listPlayingFilename === row.filename && this.listAudioPaused) {
                audio.play()
                this.listAudioPaused = false
                return
            }
            this.voicevalue.wenben = row.data || ''
            this.currentRecordFilename = row.filename
            this.lastPlayedFilename = row.filename
            this.lastPlayedCharCount = (row.data && row.data.length) || 0
            this.listPlayingFilename = row.filename
            this.listAudioPaused = false
            this.clearCurrentVisemeTrack('列表音频暂无视素数据')
            audio.src = this.$store.state.basicurl + row.filename
            audio.play()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        isCardSelected(row) {
            return this.multipleSelection.some(r => r.filename === row.filename);
        },
        toggleCardSelection(row, checked) {
            if (checked) {
                if (!this.multipleSelection.some(r => r.filename === row.filename)) {
                    this.multipleSelection = this.multipleSelection.concat(row);
                }
            } else {
                this.multipleSelection = this.multipleSelection.filter(r => r.filename !== row.filename);
            }
        },
        getFileName(path) {
            var pos1 = path.lastIndexOf('/');
            var pos2 = path.lastIndexOf('\\');
            var pos = Math.max(pos1, pos2);
            if (pos < 0)
                return path;
            else
                return path.substring(pos + 1);
        },
        onCopy() {
            this.$message({
                message: '复制成功',
                type: 'success'
            });
        },
        onError: function () {
            this.$message({
                message: '您还没有生成音频',
                type: 'success'
            });
        },
        Resetmusic() {
            this.uploadfilename = ""
            this.voicevalue.backgroundaudio.src = ""
            this.stopBackgroundMusicPreview()
        },
        uploadsuccess(response, file, fileList) {
            this.handleBackgroundUploadSuccess(response, file)
        },
        InsertBreak() {
            if (this.pausenum >= 5 && this.pauseunit == 's') {
                this.$alert('停顿时间不能大于5秒', '提示', {
                    confirmButtonText: '确定',
                });
                return;
            }
            if (this.pausenum >= 5000 && this.pauseunit == 'ms') {
                this.$alert('停顿时间不能大于5000毫秒', '提示', {
                    confirmButtonText: '确定',
                });
                return;
            }
            if (this.pausenum <= 0) {
                this.$alert('停顿时间不能为0', '提示', {
                    confirmButtonText: '确定',
                });
                return;
            }
            this.InsertData(`<break time="${this.pausenum + this.pauseunit}" />`)
            this.showpause = false
        },
        async InsertData(value) {
            const myField = this.$refs.wenben;
            if (myField.selectionStart || myField.selectionStart === 0) {
                let startPos = myField.selectionStart;
                let endPos = myField.selectionEnd;
                this.voicevalue.wenben = myField.value.substring(0, startPos) + value + myField.value.substring(endPos, myField.value.length);
                await this.$nextTick() // 这句是重点, 圈起来
                myField.focus();
                myField.setSelectionRange(endPos + value.length, endPos + value.length);
            } else {
                this.voicevalue.wenben = value;
            }
        },
        clearText() {
            this.voicevalue.wenben = '';
            this.$message({ message: '已清空文本', type: 'success' });
        },
        async pasteText() {
            const myField = this.$refs.wenben;
            try {
                let text = '';
                if (navigator.clipboard && navigator.clipboard.readText) {
                    text = await navigator.clipboard.readText();
                } else {
                    this.$message({ message: '当前浏览器不支持读取剪贴板，请使用 Ctrl+V 粘贴', type: 'warning' });
                    return;
                }
                if (!text || !text.trim()) {
                    this.$message({ message: '剪贴板为空或无文本', type: 'info' });
                    return;
                }
                const startPos = myField.selectionStart != null ? myField.selectionStart : myField.value.length;
                const endPos = myField.selectionEnd != null ? myField.selectionEnd : startPos;
                this.voicevalue.wenben = myField.value.substring(0, startPos) + text + myField.value.substring(endPos, myField.value.length);
                await this.$nextTick();
                myField.focus();
                const newPos = startPos + text.length;
                myField.setSelectionRange(newPos, newPos);
                this.$message({ message: '已粘贴文本', type: 'success' });
            } catch (err) {
                this.$message({ message: '粘贴失败：请允许剪贴板权限或使用 Ctrl+V 粘贴', type: 'warning' });
            }
        },
        clickitem(type) {
            if (this.ttsEngine !== 'azure' && type !== 'wenben') {
                type = 'wenben'
            }
            if (type == 'wenben') {
                this.ssmlactive = ''
                this.wenbenactive = 'active'
                this.live2dactive = ''
            }
            else if (type == 'ssml') {
                this.ssmlactive = 'active'
                this.wenbenactive = ''
                this.live2dactive = ''
            }
            else {
                this.ssmlactive = ''
                this.wenbenactive = ''
                this.live2dactive = 'active'
            }

        },
        formatTooltip(val) {
            return val / 100;
        },
        audioplayover() {
            this.btnstyleindex = 0
            this.btnAuditionstyleindex = 0
            this.listPlayingFilename = null
            this.listAudioPaused = true
        },
        checkcode(){
            if (this.inputcode.length == 0) {
                this.$message({
                    message: '请输入您获取到的验证码',
                    type: 'warning'
                });
                return;
            }
            const requestType = this.codetype === '赚金币' ? '赚金币' : '音频下载'
            this.$axios({
                url: "/getcode",
                method: 'post',
                data: { code: this.inputcode, type: requestType },
            }).then(res => {
                if(res.data=='OK'){
                    this.showcode=false
                    if (this.codetype === '赚金币') {
                        const user = this.$store.state.user
                        if (user && user.coins != null) {
                            this.$store.commit('SetUserCoins', user.coins + 1)
                        }
                        this.$message({ message: '验证成功，已增加 1 金币', type: 'success' })
                        return
                    }
                    this.havecode=true
                    if(this.codetype=="下载音频")this.DownFile()
                    if(this.codetype=="下载视频")this.Makemp4()
                    if(this.codetype=='列表下载音频'){
                        const a = document.createElement('a')
                        a.style.display = 'none'
                        a.href = `${this.$store.state.basicurl}getdownload?id=${this.row.filename}`
                        a.click();
                        a.remove();
                    }
                    if (this.codetype === '拼接音频') this.doSpliceWithCoin()
                    if (this.codetype === '播放音频') {
                        if (this.ttsReadMode === 'favorite' || this.isLongPlayBatch()) this.startPlayBatchVideo()
                        else this.Makevoice('play', { skipCoinDialog: true })
                    }
                } else if(res.data=='Wrong'){
                    this.$message({
                        message: '验证码错误',
                        type: 'warning'
                    });
                }else if(res.data=='Used'){
                    this.$message({
                        message: '该验证码已经被使用过了',
                        type: 'warning'
                    });
                }               
            })
        },
        DownFile() {
            const fileId = this.lastPlayedFilename || this.datapath
            if (!fileId || fileId.length === 0) {
                this.$message({ message: '请播放音频后再下载', type: 'warning' })
                return
            }
            if (this.havecode) {
                const a = document.createElement('a')
                a.style.display = 'none'
                a.href = `${this.$store.state.basicurl}getdownload?id=${fileId}`
                a.click()
                a.remove()
            } else {
                this.tryDownload('下载音频')
            }
        },
        Makemp4() {
            if (this.datapath == null || this.datapath.length == 0) {
                this.$message({ message: '请播放音频后再下载', type: 'warning' })
                return
            }
            if (this.havecode) {
                this.$axios({ url: "/makemp4", method: 'post', data: { filename: this.datapath } }).then(res => {
                    const a = document.createElement('a')
                    a.style.display = 'none'
                    a.href = `${this.$store.state.basicurl}getmp4file?id=${res.data}`
                    a.click()
                    a.remove()
                })
            } else {
                this.tryDownload('下载视频')
            }
        }, 
    /**
 * @param {string} type - 令牌类型 ok/spare
 * @param {string} btntype - Audition | play
 * @param {object} audioOpts - segmentText, quietPlayer, batchRetainCompensation, skipSaveRecent, skipSynthProgress
 */
makeaudio(type, btntype, audioOpts = {}) {
  const opts = audioOpts || {}
  const segmentRaw = opts.segmentText != null ? String(opts.segmentText) : null
  const textBody = opts.textOverride != null
    ? String(opts.textOverride).replace(/\&/g, '')
    : (segmentRaw != null ? segmentRaw.replace(/\&/g, '') : this.voicetext)
  const ssml = opts.ssmlOverride != null ? String(opts.ssmlOverride) : this.buildSsmlForText(textBody)
  const quietPlayer = !!opts.quietPlayer
  const skipRegisterPaidFile = !!opts.skipRegisterPaidFile
  const batchRetainCompensation = !!opts.batchRetainCompensation
  const skipSaveRecent = !!opts.skipSaveRecent
  const skipSynthProgress = !!opts.skipSynthProgress
  return new Promise((resolve, reject) => {
    this.$axios.post("/GetAccessToken", { tokentype: type }).then(res => {
      if (res.data.token.length > 0) {
        if (!skipSynthProgress) this.startSynthProgressAnim(textBody.length)
        var sdk = require("microsoft-cognitiveservices-speech-sdk");
        const speechConfig = sdk.SpeechConfig.fromSubscription(res.data.token, res.data.area);
        speechConfig.speechSynthesisOutputFormat = sdk.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3;
        const speechSynthesizer = new sdk.SpeechSynthesizer(speechConfig, null);
        const visemeBuffer = []
        speechSynthesizer.visemeReceived = (_, event) => {
          visemeBuffer.push({
            timeMs: this.toVisemeMs(event && event.audioOffset),
            visemeId: event && event.visemeId != null ? event.visemeId : 0
          })
        }
        speechSynthesizer.speakSsmlAsync(
          ssml,
          result => {
            this.loading = false;
            if (result.errorDetails) {
              speechSynthesizer.close();
              var errorcode = result.errorDetails.substring(result.errorDetails.length - 4);
              if (errorcode == '4429') {
                db.sql(`Update AzureTotal set canuse=0 where id=${res.data.id}`, () => {});
              }
              this.loading = false;
              if (!skipSynthProgress) this.cancelSynthProgressAnim();
              reject(new Error(result.errorDetails || 'Speech synthesis failed'));
            } else {
              speechSynthesizer.close();
              var filename = new Date().getTime() + '.' + this.voicevalue.format;
              const blob = new Blob([result.audioData], { type: "audio/x-wav" });
              const file = new File([blob], filename, { type: "audio/x-wav" });
              const visemeTrack = this.buildVisemeTrack({
                key: filename,
                text: textBody,
                audioDurationMs: this.toVisemeMs(result && result.audioDuration),
                visemes: visemeBuffer
              })
              if (!quietPlayer) {
                this.datapath = filename;
                this.lastPlayedFilename = filename;
                this.lastGeneratedWasAudition = (btntype === 'Audition');
                this.lastPlayedCharCount = textBody.length;
                this.listPlayingFilename = null;
                this.$refs.audio.src = URL.createObjectURL(file);
                this.setCurrentVisemeTrack(visemeTrack)
              }
              var formData = new FormData();
              formData.append('Audio', file);
              formData.append('datalenght', textBody.length);
              formData.append('orderid', this.userId != null && this.userId !== '' ? String(this.userId) : '');
              formData.append('wenben', textBody);
              formData.append('maketype', btntype);
              formData.append('platform', "网页");
              formData.append('filename', filename);
              this.$axios.post("/getazurefile", formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
              }).then(() => {
                this.$axios.post("/getAzurettsRecord", { orderid: this.userId }).then(response => {
                  this.tableData = response.data;
                  if (!skipSaveRecent) {
                    this.saveRecentVoice();
                    this.sendBrowserNotification('语音合成完成', '您的音频已生成完毕，点击查看');
                  }
                  const paid = this.ttsPaidCompensation
                  if (btntype === 'play' && !batchRetainCompensation && paid && !quietPlayer && !skipRegisterPaidFile) {
                    this.registerPaidTtsFile(filename)
                  }
                  if (btntype === 'play' && !batchRetainCompensation) this.ttsPaidCompensation = null;
                  if (!skipSynthProgress) this.finishSynthProgressAnim();
                  resolve({ ok: 1, filename, track: visemeTrack, visemes: visemeTrack.visemes, audioDurationMs: visemeTrack.audioDurationMs });
                }).catch((err) => {
                  if (!skipSynthProgress) this.cancelSynthProgressAnim();
                  reject(err);
                });
              }).catch(error => {
                if (!skipSynthProgress) this.cancelSynthProgressAnim();
                reject(error);
              });
            }
          },
          error => {
            this.loading = false;
            speechSynthesizer.close();
            if (!skipSynthProgress) this.cancelSynthProgressAnim();
            reject(new Error((error && error.message) ? error.message : 'Speech synthesis failed'));
          }
        );
      } else {
        this.loading = false;
        if (!skipSynthProgress) this.cancelSynthProgressAnim();
        reject('Token not valid');
      }
    }).catch(error => {
      this.loading = false;
      if (!skipSynthProgress) this.cancelSynthProgressAnim();
      reject(error);
    });
  });
},  

        makeaudio1(type,btntype)   {
            this.$axios.post("/GetAccessToken",{tokentype:type}).then(res=>{
            if(res.data.token.length>0){                  
            var sdk = require("microsoft-cognitiveservices-speech-sdk");
            const speechConfig = sdk.SpeechConfig.fromSubscription(res.data.token,res.data.area);
            speechConfig.speechSynthesisOutputFormat = sdk.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3;//Riff8Khz16BitMonoPcm;
            const speechSynthesizer = new sdk.SpeechSynthesizer(speechConfig,null);
            speechSynthesizer.speakSsmlAsync(
                this.getDataXML,
                result => {
                    this.loading = false
                    if (result.errorDetails) {                
                        speechSynthesizer.close();      
                        var errorcode=result.errorDetails.substring(result.errorDetails.length-4)
                        if(errorcode=='4429'){
                            db.sql(`Update AzureTotal set canuse=0 where id=${res.data.id}`,()=>{})
                        }
                        return 0
                    } 
                    if (result) {
                        speechSynthesizer.close();
                        var filename=new Date().getTime()+'.'+ this.voicevalue.format
                        const blob = new Blob([result.audioData], { type: "audio/x-wav" });
                        const file = new File([blob],filename , { type: "audio/x-wav" });  
                        this.datapath = filename;
                        this.lastPlayedFilename = filename;
                        this.lastGeneratedWasAudition = (btntype === 'Audition');
                        this.lastPlayedCharCount = (this.voicetext || '').length;
                        this.listPlayingFilename = null;
                        this.$refs.audio.src = URL.createObjectURL(file);

                        
                        var formData = new FormData();
                        formData.append('Audio',file);
                        formData.append('datalenght',this.voicetext.length);
                        formData.append('orderid', this.userId != null && this.userId !== '' ? String(this.userId) : '');
                        formData.append('wenben',this.voicetext); 
                        formData.append('maketype',btntype); 
                        formData.append('platform',"网页"); 
                        formData.append('filename',filename);    
                        this.$axios.post("/getazurefile",formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(res=>{
                            this.$axios.post("/getAzurettsRecord", { orderid: this.userId }).then(response => {
                                this.tableData = response.data
                                this.saveRecentVoice();
                                this.sendBrowserNotification('语音合成完成', '您的音频已生成完毕，点击查看');
                            })
                        })
                        return 1
                    }
                },
                error => {
                    this.loading = false;
                    speechSynthesizer.close();
                    return 0
                });
                // this.$axios.post("/azuretts",
                // {
                //     format: this.voicevalue.format,
                //     data: this.getDataXML,
                //     datalenght: this.voicetext.length,
                //     orderid: this.orderid,
                //     wenben: this.voicetext,
                //     maketype: btntype,
                //     platform:"网页"
                // }).then(res => {
                //     this.loading = false
                //     if (res.data.code < 100) {                      
                //         if(res.data.code==50){
                //             this.$alert(res.data.message, '提示', {
                //                 confirmButtonText: '确定',
                //             });
                //         }
                //         this.copydata = "http://47.100.253.234/audio/" + res.data.data
                //         const num=Math.random()*100
                //         if(num<=50) this.havecode=true
                //         if (btntype == "play") {
                //             this.btnstyleindex = 1
                //             this.datapath = this.$store.state.basicurl + res.data.data
                //             this.$refs.audio.src = this.datapath                            
                //         }
                //         else {
                //             this.btnAuditionstyleindex = 1
                //             this.AuditionDatapath = this.$store.state.basicurl + res.data.data
                //             this.$refs.audio.src = this.AuditionDatapath                          
                //         }
                //         this.$axios.post("/getAzurettsRecord", {orderid:this.orderid}).then(response => {
                //             this.tableData = response.data
                //         })
                //     }
                //     else
                //         this.$message({
                //             message: res.data.message,
                //             type: 'warning'
                //         });
                // })
            }
            })
        } , 
        async makeVolcVoice(btntype) {
            const text = btntype === 'Audition'
                ? this.voicevalue.wenben.substring(0, 50).replace(/\&/g, '')
                : this.voicevalue.wenben.replace(/\&/g, '')
            const voiceType = (this.volcVoiceType || '').trim() || 'BV700_V2_streaming'
            const format = 'wav'
            const rate = 24000
            this.voicetext = text
            this.loading = true
            this.clickitem('wenben')
            try {
                const response = await this.$axios.post('/volcengine/tts/synthesize', {
                    text,
                    orderid: this.userId != null ? String(this.userId) : '',
                    maketype: btntype,
                    format,
                    voiceType,
                    rate,
                    speedRatio: this.volcSpeedRatio,
                    volumeRatio: this.volcVolumeRatio,
                    pitchRatio: this.volcPitchRatio,
                    platform: '网页-火山引擎'
                })
                const data = response.data || {}
                if (!data.success || !data.filename) {
                    throw new Error(data.message || '火山引擎语音合成失败')
                }
                const filename = data.filename
                this.datapath = filename
                this.lastPlayedFilename = filename
                this.lastPlayedCharCount = text.length
                this.lastGeneratedWasAudition = (btntype === 'Audition')
                this.listPlayingFilename = null
                this.clearCurrentVisemeTrack('当前音频没有视素数据')
                this.$refs.audio.src = this.$store.state.basicurl + filename
                if (btntype === 'play') this.btnstyleindex = 1
                if (btntype === 'Audition') this.btnAuditionstyleindex = 1
                this.$nextTick(() => {
                    const el = this.$refs.audio
                    if (el && el.play) el.play().catch(() => {})
                })
                await this.loadRecordList()
                if (btntype === 'play') {
                    await this.registerPaidTtsFile(filename)
                    this.ttsPaidCompensation = null
                }
                this.sendBrowserNotification('语音合成完成', '您的音频已生成完毕，点击查看')
            } catch (error) {
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : ((error && error.message) ? error.message : '火山引擎语音合成失败')
                this.$message({ message: msg, type: 'error' })
                if (btntype === 'play') this.compensateTtsFailureIfNeeded()
            } finally {
                this.loading = false
            }
        },
        Makevoice(btntype, opts) {
            if (this.btnstyleindex == 1) {
                this.btnstyleindex = 0
                this.$refs.audio.pause()
                return
            }
            if (this.btnAuditionstyleindex == 1) {
                this.btnAuditionstyleindex = 0
                this.$refs.audio.pause()
                return
            }
            if (btntype === 'play' && !this.$store.state.user) {
                this.$message({ message: '请先登录后再播放音频', type: 'warning' })
                this.$store.commit('SetShowLoginDialog', { show: true, tab: 'login' })
                return
            }
            if (this.voicevalue.wenben == null || this.voicevalue.wenben.length == 0) {
                if (btntype === 'play') this.ttsPaidCompensation = null
                this.$message({
                    message: '请输入内容',
                    type: 'warning'
                });
                return;
            }
            const maxChars = TTS_PLAY_CHUNK_SIZE * TTS_PLAY_MAX_CHUNKS
            if (this.voicevalue.wenben.length > maxChars) {
                if (btntype === 'play') this.ttsPaidCompensation = null
                this.$message({
                    message: `单次最多 ${maxChars} 字（${TTS_PLAY_MAX_CHUNKS} 段×${TTS_PLAY_CHUNK_SIZE} 字），请缩短后再试`,
                    type: 'warning'
                });
                return;
            }
            const currentPath = this.lastPlayedFilename || this.datapath
            const canReuseForPlay = currentPath.length > 0 && !this.lastGeneratedWasAudition
            if (btntype === 'play' && this.voicevalue.wenben.length > 50 && !canReuseForPlay && (!opts || !opts.skipCoinDialog)) {
                const required = this.getCurrentPlayCoinsRequired(this.voicevalue.wenben.length)
                if (!this.coinChargeEnabled) {
                    this.pendingDownloadType = '播放音频'
                    this.pendingDownloadCharCount = this.voicevalue.wenben.length
                    if (this.ttsReadMode === 'favorite' || this.isLongPlayBatch()) this.useCoinAndPlayBatch()
                    else this.useCoinAndDownload('播放音频')
                    this.pendingDownloadType = null
                    return
                }
                const currentCoins = (this.$store.state.user && this.$store.state.user.coins) || 0
                if (currentCoins < required) {
                    this.pendingDownloadType = null
                    this.pendingDownloadCharCount = 0
                    this.openMiniProgramGuide()
                    return
                }
                this.pendingDownloadType = '播放音频'
                this.pendingDownloadCharCount = this.voicevalue.wenben.length
                this.showCoinChoiceDialog = true
                return
            }
            if (this.ttsReadMode === 'favorite' && btntype === 'play' && canReuseForPlay) {
                this.listPlayingFilename = null
                this.$refs.audio.src = this.$store.state.basicurl + currentPath
                if (this.currentVisemeTrack && this.currentVisemeTrack.key === currentPath) {
                    this.setCurrentVisemeTrack(this.currentVisemeTrack)
                } else {
                    this.clearCurrentVisemeTrack('当前音频没有视素数据')
                }
                this.$refs.audio.play()
                this.btnstyleindex = 1
                this.ttsPaidCompensation = null
                return
            }
            if (canReuseForPlay && btntype == "play" && !this.isLongPlayBatch()) {
                this.listPlayingFilename = null
                this.$refs.audio.src = this.$store.state.basicurl + currentPath
                if (this.currentVisemeTrack && this.currentVisemeTrack.key === currentPath) {
                    this.setCurrentVisemeTrack(this.currentVisemeTrack)
                } else {
                    this.clearCurrentVisemeTrack('当前音频没有视素数据')
                }
                this.$refs.audio.play()
                this.btnstyleindex = 1
                this.ttsPaidCompensation = null
                return
            }
            if (btntype == "Audition" && currentPath.length > 0 && this.lastGeneratedWasAudition) {
                this.listPlayingFilename = null
                this.$refs.audio.src = this.$store.state.basicurl + currentPath
                if (this.currentVisemeTrack && this.currentVisemeTrack.key === currentPath) {
                    this.setCurrentVisemeTrack(this.currentVisemeTrack)
                } else {
                    this.clearCurrentVisemeTrack('当前音频没有视素数据')
                }
                this.$refs.audio.play()
                this.btnAuditionstyleindex = 1
                return
            }
            if (this.ttsEngine !== 'azure') {
                if (this.ttsReadMode !== 'single') this.ttsReadMode = 'single'
                this.makeVolcVoice(btntype)
                return
            }
            if (this.ttsReadMode === 'favorite') {
                this.clickitem('live2d')
                const failMsg = '语音合成失败，请检查网络或稍后重试'
                if (btntype === 'Audition') {
                    this.runFavoriteConfiguredAudition().catch((error) => {
                        this.loading = false
                        const msg = (error && error.message) ? error.message : failMsg
                        this.$message({ message: msg, type: 'error' })
                    })
                    return
                }
                this.runFavoriteConfiguredPlayBatch('normal').catch((error) => {
                    this.loading = false
                    this.cancelSynthProgressAnim()
                    const msg = (error && error.message) ? error.message : failMsg
                    this.$message({ message: msg, type: 'error' })
                    if (btntype === 'play') this.compensateTtsFailureIfNeeded()
                })
                return
            }
            
            if (btntype == "Audition")
                this.voicetext = this.voicevalue.wenben.substring(0, 50).replace(/\&/g, '');
            else
                this.voicetext = this.voicevalue.wenben.replace(/\&/g, '');
            this.clickitem('live2d')
            this.loading = true
            const failMsg = '语音合成失败，请检查网络或稍后重试'
            const tryOkThenSpare = () => this.makeaudio('ok', btntype).catch(() => this.makeaudio('spare', btntype))
            const synthOk = (v) => v === 1 || (v && v.ok === 1)
            tryOkThenSpare()
                .then((value) => {
                    this.loading = false
                    if (synthOk(value)) return
                    this.cancelSynthProgressAnim()
                    this.$message({ message: failMsg, type: 'error' })
                    if (btntype === 'play') this.compensateTtsFailureIfNeeded()
                })
                .catch((error) => {
                    this.loading = false
                    this.cancelSynthProgressAnim()
                    const msg = (error && error.message) ? error.message : failMsg
                    this.$message({ message: msg, type: 'error' })
                    if (btntype === 'play') this.compensateTtsFailureIfNeeded()
                })
        },
        compensateTtsFailureIfNeeded() {
            const p = this.ttsPaidCompensation
            if (!p) return
            this.ttsPaidCompensation = null
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.$message({ message: '语音合成失败，金币补偿需登录账号，请登录后联系客服处理', type: 'warning' })
                return
            }
            let coins = 0
            let remark = '语音合成失败补偿'
            if (p.mode === 'coin') {
                coins = Math.max(0, parseInt(p.coins, 10) || 0)
                remark = '语音合成失败返还金币'
            } else if (p.mode === 'cash') {
                const yuan = Number(p.yuan) || 0
                const ppc = Number(this.pricePerCoin) > 0 ? Number(this.pricePerCoin) : 0.1
                coins = yuan > 0 ? Math.max(1, Math.round(yuan / ppc)) : 0
                remark = '语音合成失败（已付款折算金币）'
            }
            if (coins <= 0) return
            const payload = { token, type: 'earn', amount: coins, remark }
            const headers = { Authorization: 'Bearer ' + token }
            this.$axios.post('/user/coin/log', payload, { headers })
                .then((res) => {
                    if (res.data && res.data.coins != null) {
                        this.$store.commit('SetUserCoins', res.data.coins)
                    } else {
                        const cur = (this.$store.state.user && this.$store.state.user.coins) || 0
                        this.$store.commit('SetUserCoins', cur + coins)
                    }
                    this.$message({ message: `语音合成未成功，已补偿 ${coins} 金币`, type: 'success' })
                })
                .catch(() => {
                    this.$message({ message: '语音合成失败，金币补偿发放失败，请联系客服', type: 'warning' })
                })
        },
        // ===== 收藏语音配置 =====
        loadFavorites() {
            const user = this.$store.state.user
            if (!user || !user.token) return
            this.$axios.get('/user/favorites', { params: { token: user.token } }).then(res => {
                this.favoriteList = res.data || []
            }).catch(() => {})
        },
        addFavorite() {
            const user = this.$store.state.user
            if (!user) { this.$message.warning('请先登录'); return }
            this.$prompt('请输入收藏名称', '收藏当前语音配置', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/,
                inputErrorMessage: '名称不能为空'
            }).then(({ value }) => {
                const config = {
                    language: this.voicevalue.language,
                    voice: this.voicevalue.voice,
                    style: this.voicevalue.style,
                    role: this.voicevalue.role,
                    volume: this.voicevalue.volume,
                    speech_rate: this.voicevalue.speech_rate,
                    pitch_rate: this.voicevalue.pitch_rate,
                    Stylestrength: this.voicevalue.Stylestrength
                }
                this.$axios.post('/user/favorites', { token: user.token, name: value.trim(), config }).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success('收藏成功')
                        this.loadFavorites()
                    } else {
                        this.$message.warning((res.data && res.data.message) || '收藏失败')
                    }
                }).catch(err => {
                    this.$message.warning((err.response && err.response.data && err.response.data.message) || '收藏失败')
                })
            }).catch(() => {})
        },
        deleteFavorite(id) {
            const user = this.$store.state.user
            if (!user) return
            this.$confirm('确定删除该收藏？', '提示', { type: 'warning' }).then(() => {
                this.$axios.delete('/user/favorites/' + id, { params: { token: user.token } }).then(() => {
                    this.$message.success('已删除')
                    this.loadFavorites()
                }).catch(() => { this.$message.error('删除失败') })
            }).catch(() => {})
        },
        applyFavorite(fav) {
            if (!fav || !fav.config) return
            let config = fav.config
            if (typeof config === 'string') { try { config = JSON.parse(config) } catch (e) { return } }
            this.applyVoiceConfig(config)
        },
        // ===== 最近使用语音 =====
        loadRecentVoices() {
            const user = this.$store.state.user
            if (!user || !user.token) return
            this.$axios.get('/user/recent-voices', { params: { token: user.token } }).then(res => {
                this.recentVoiceList = res.data || []
            }).catch(() => {})
        },
        saveRecentVoice() {
            const user = this.$store.state.user
            if (!user || !user.token) return
            const config = {
                language: this.voicevalue.language,
                voice: this.voicevalue.voice,
                style: this.voicevalue.style,
                role: this.voicevalue.role,
                volume: this.voicevalue.volume,
                speech_rate: this.voicevalue.speech_rate,
                pitch_rate: this.voicevalue.pitch_rate,
                Stylestrength: this.voicevalue.Stylestrength
            }
            this.$axios.post('/user/recent-voices', { token: user.token, config }).then(() => {
                this.loadRecentVoices()
            }).catch(() => {})
        },
        applyRecentVoice(item) {
            if (!item || !item.config) return
            let config = item.config
            if (typeof config === 'string') { try { config = JSON.parse(config) } catch (e) { return } }
            this.applyVoiceConfig(config)
        },
        getRecentVoiceLabel(item) {
            let config = item.config
            if (typeof config === 'string') { try { config = JSON.parse(config) } catch (e) { return '未知' } }
            const voiceName = (config.voice && config.voice.voicename) || ''
            const styleName = (config.style && config.style.stylename) || ''
            return voiceName + (styleName ? ' - ' + styleName : '')
        },
        // ===== 共用配置恢复方法 =====
        applyVoiceConfig(config) {
            if (!config) return
            this.isRestoringConfig = true
            // 设置语言 → 触发 watcher 加载 voices
            if (config.language && config.language.language) {
                this.voicevalue.language = config.language
            }
            // 延迟等待 voices 加载完成后设置 voice
            setTimeout(() => {
                if (config.voice && config.voice.voice) {
                    const found = this.voices.find(v => v.voice === config.voice.voice)
                    if (found) this.voicevalue.voice = found
                    else this.voicevalue.voice = config.voice
                }
                // 延迟等待 styles/roles 加载完成后设置
                setTimeout(() => {
                    if (config.style) {
                        const sk = config.style.style || config.style.Style
                        const sid = config.style.id != null ? config.style.id : config.style.ID
                        let found = null
                        if (sk) found = this.styles.find(s => s.style === sk || s.Style === sk)
                        if (!found && sid != null) found = this.styles.find(s => s.id === sid || s.ID === sid)
                        if (found) this.voicevalue.style = found
                    }
                    if (config.role) {
                        const rk = config.role.role || config.role.Role
                        const rid = config.role.id != null ? config.role.id : config.role.ID
                        let rf = null
                        if (rk) rf = this.roles.find(r => r.role === rk || r.Role === rk)
                        if (!rf && rid != null) rf = this.roles.find(r => r.id === rid || r.ID === rid)
                        if (rf) this.voicevalue.role = rf
                    }
                    if (config.volume != null) this.voicevalue.volume = config.volume
                    if (config.speech_rate != null) this.voicevalue.speech_rate = config.speech_rate
                    if (config.pitch_rate != null) this.voicevalue.pitch_rate = config.pitch_rate
                    if (config.Stylestrength != null) this.voicevalue.Stylestrength = config.Stylestrength
                    this.isRestoringConfig = false
                    this.$message.success('已恢复语音配置')
                }, 800)
            }, 800)
        },
        // ===== 文本模板 =====
        loadTemplates() {
            this.$axios.get('/text-templates').then(res => {
                this.templateList = res.data || []
            }).catch(() => {})
        },
        openTemplateDialog() {
            this.showTemplateDialog = true
            this.templateCategory = ''
        },
        useTemplate(tpl) {
            this.voicevalue.wenben = tpl.content || ''
            this.showTemplateDialog = false
            this.$message.success('模板已加载')
        },
        // ===== Excel 导出 =====
        exportExcel() {
            if (!this.tableData || this.tableData.length === 0) {
                this.$message.warning('暂无数据可导出')
                return
            }
            const data = this.tableData.map(row => ({
                '内容': (row.data || '').slice(0, 500),
                '类型': row.maketype === 'Audition' ? '试听' : row.maketype === 'Splice' ? '拼接音频' : '完整音频',
                '生成时间': row.datetime || '',
                '状态': this.downloadedFileIds.indexOf(row.filename) >= 0 ? '已下载' : '未下载'
            }))
            const ws = XLSX.utils.json_to_sheet(data)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, '语音记录')
            const dateStr = new Date().toISOString().slice(0, 10)
            XLSX.writeFile(wb, '语音记录_' + dateStr + '.xlsx')
        },
        // ===== 浏览器通知 =====
        sendBrowserNotification(title, body) {
            if (!window.Notification || Notification.permission !== 'granted') return
            if (!document.hidden) return
            const n = new Notification(title, { body, icon: '/favicon.ico' })
            n.onclick = () => { window.focus(); n.close() }
            setTimeout(() => n.close(), 8000)
        },
        getFormatDateTime(){
            var date = new Date();
            var year= date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var second = date.getSeconds();
            return [year, '-', month , '-', day, ' ', hour , ':', minute, ':', second ].join('');
        }
    },
    watch: {
        ttsEngine(value) {
            if (this.$refs.audio) this.$refs.audio.pause()
            this.btnstyleindex = 0
            this.btnAuditionstyleindex = 0
            this.ttsPaidCompensation = null
            this.stopVolcVoicePreview()
            this.invalidateGeneratedAudioState('已切换引擎，请重新生成音频')
            if (value !== 'azure') {
                this.ttsReadMode = 'single'
                this.voicevalue.format = 'wav'
                this.resetVolcRatios()
                this.clickitem('wenben')
                this.showVoicePickerDialog = false
                if (!this.volcVoiceType) this.loadVolcConfig()
            }
        },
        'voicevalue.voice.voice'(value) {
            this.styles = []
            if (!this.isRestoringConfig) this.voicevalue.style = {}
            this.$axios.post("/getAzurettsstyledata", { value }).then(response => {
                this.styles = (response.data || []).map(row => this.normalizeTtsStyleRow(row))
                if (!this.isRestoringConfig) this.voicevalue.style = this.styles[0] || {}
            })
            this.roles = []
            if (!this.isRestoringConfig) this.voicevalue.role = {}
            this.$axios.post("/getAzurettsroledata", { value }).then(response => {
                this.roles = (response.data || []).map(row => this.normalizeTtsRoleRow(row))
                if (!this.isRestoringConfig && this.roles.length > 0) this.voicevalue.role = this.roles[0]
            })
        },
        'voicevalue.language.language'(value) {
            this.rightParamsLoading = true
            this.$axios.post("/getAzurettsvoicedata", { value }).then(response => {
                this.voices = response.data || []
                if (!this.isRestoringConfig) this.voicevalue.voice = this.voices[0]
            }).catch(() => {
                this.$message({ message: '参数加载失败，请检查网络连接或稍后重试', type: 'error', duration: 5000 })
            }).finally(() => {
                this.rightParamsLoading = false
            })
        },
        getDataXML() {
            this.invalidateGeneratedAudioState('等待生成音频')
        },
        'voicevalue.wenben'() {
            this.invalidateGeneratedAudioState('文本已修改，请重新生成音频')
            if (this.ttsReadMode === 'favorite' && !this.isSyncingFavoriteSourceText) this.parsedSegmentsDirty = true
            if (!this.tableData.some(r => r.data === this.voicevalue.wenben)) this.currentRecordFilename = null
        },
        favoriteList() {
            if (this.ttsReadMode === 'favorite' && this.parsedTtsSegments.length) {
                this.parsedSegmentsDirty = true
            }
        },
        filterdata(value) {
            if (value.length > 0)
                this.voicevalue.voice = value[0]
        },
        '$store.state.user'() {
            this.loadRecordList()
            this.loadDownloadedList()
            if (this.$store.state.user) {
                this.loadFavorites()
                this.loadRecentVoices()
            } else {
                this.favoriteList = []
                this.recentVoiceList = []
            }
            if (this.$store.state.user && this.$store.state.pendingDownloadAction) {
                const action = this.$store.state.pendingDownloadAction
                this.$store.commit('SetPendingDownloadAction', null)
                this.$nextTick(() => this.tryDownload(action))
            }
        },
        // TopBar「购买金币」「赚金币」已由 App 内 GlobalCoinDialogs 统一响应，此处不再监听
    },
    created() {
        this.rightParamsLoading = true
        this.$axios.get("/getAzurettslanguagedata").then(response => {
            this.languages = response.data || []
            this.voicevalue.language = this.languages[0]
        }).catch(() => {
            this.rightParamsLoading = false
            this.$message({ message: '参数加载失败，请检查网络连接或稍后重试', type: 'error', duration: 5000 })
        })
       
        this.$axios.get("/getTotalNum").then(response => {
            this.totalnum = response.data[0].total
        })
        this.loadVolcConfig()
        this.loadRecordList()
        this.loadDownloadedList()
        if (innerWidth > 768) this.showwidth = "600px"
        this.showTypeColumn = window.innerWidth > 768
        // 加载收藏、最近使用、文本模板
        this.loadFavorites()
        this.loadRecentVoices()
        this.loadTemplates()
        this.loadBackgroundMusic()
        // 请求浏览器通知权限
        if (window.Notification && Notification.permission === 'default') {
            Notification.requestPermission()
        }
    },
    mounted() {
        const onResize = () => { this.showTypeColumn = window.innerWidth > 768 }
        window.addEventListener('resize', onResize)
        this.attachLive2dAudio()
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('resize', onResize)
            this.cancelSynthProgressAnim()
            this.stopVoicePreview()
            this.stopVolcVoicePreview()
            this.stopBackgroundMusicPreview()
        })
    },
    computed: {
        coinChargeEnabled() {
            return this.$store.state.coinChargeEnabled !== false
        },
        miniProgramTitle() {
            return MINIPROGRAM_WIDGET_TITLE || '微信小程序'
        },
        miniProgramGuideQr() {
            return MINIPROGRAM_TTS_QR_IMAGE
        },
        selectedVoicePickerKey() {
            return this.getVoicePickerKey(this.voicevalue.voice)
        },
        ttsTextareaPlaceholder() {
            if (this.ttsEngine !== 'azure') {
                return '火山引擎当前先支持单人配音，可直接输入文本生成音频'
            }
            if (this.ttsReadMode === 'favorite') {
                return [
                    '每段开头可写收藏名称，例如：',
                    '[女主持] 大家好',
                    '【男嘉宾】 欢迎收听',
                    '未标记的段落默认使用右侧当前配置'
                ].join('\n')
            }
            return '超过2500字将自动按每段2500字拆分合成，完成后自动拼接；单次最多10万字'
        },
        hasSearchParams() {
            return !!(this.recordSearchKeyword && this.recordSearchKeyword.trim()) || this.recordSearchStartDate || this.recordSearchEndDate
        },
        datetimeColLabel() {
            return this.showTypeColumn ? '生成时间' : '时间'
        },
        selectionColWidth() {
            return this.showTypeColumn ? 55 : 40
        },
        datetimeColWidth() {
            return this.showTypeColumn ? 168 : 80
        },
        userId() {
            const u = this.$store.state.user
            return u && (u.id != null && u.id !== '') ? u.id : null
        },
        ttsMaxCharsHint() {
            return TTS_PLAY_CHUNK_SIZE * TTS_PLAY_MAX_CHUNKS
        },
        synthProgressRounded() {
            return Math.min(100, Math.max(0, Math.round(this.synthProgress)))
        },
        synthProgressBarStatus() {
            return this.synthProgressRounded >= 100 ? 'success' : undefined
        },
        rightPanelLoadingHint() {
            if (this.rightParamsLoading) return '加载参数中…'
            if (this.ttsBatchLoadingText) return this.ttsBatchLoadingText
            if (this.loading) return '正在合成语音，请稍候…'
            return ''
        },
        hasSelectedBackgroundMusic() {
            return !!(this.voicevalue.backgroundaudio && this.voicevalue.backgroundaudio.src)
        },
        backgroundMusicDisplayName() {
            if (this.uploadfilename && String(this.uploadfilename).trim()) return String(this.uploadfilename).trim()
            return '未选择背景音乐'
        },
        backgroundMusicSettingsSummary() {
            return `音量 ${(this.voicevalue.backgroundaudio.volume / 10).toFixed(1)}，淡入 ${this.voicevalue.backgroundaudio.fadein}ms，淡出 ${this.voicevalue.backgroundaudio.fadeout}ms`
        },
        musicTypes() {
            const types = []
            this.allBackgroundMusic.forEach(item => {
                const type = item && item.type ? String(item.type).trim() : ''
                if (type && types.indexOf(type) < 0) types.push(type)
            })
            return types
        },
        backgroundUploadAction() {
            return this.$store.state.basicurl + 'upload/'
        },
        backgroundMusicDialogWidth() {
            return this.showTypeColumn ? '1040px' : '94vw'
        },
        downloadCoinsRequired() {
            if (this.pendingDownloadType === '拼接音频') return 1
            if (this.pendingDownloadType === '播放音频') {
                const chunks = this.ttsReadMode === 'favorite' ? [this.buildFavoriteSynthesisText(this.getFavoritePlayUnits())] : this.getPlayTextChunks()
                if (chunks.length > 1) {
                    return chunks.reduce((s, c) => s + Math.max(1, Math.ceil((c.text || c).length / 500)), 0)
                }
                const n = this.pendingDownloadCharCount || 0
                if (this.ttsReadMode === 'favorite' && chunks.length === 1) {
                    return Math.max(1, Math.ceil(String(chunks[0] || '').length / 500))
                }
                return Math.max(1, Math.ceil(n / 500))
            }
            if (this.pendingDownloadType === '下载音频' || this.pendingDownloadType === '列表下载音频') return 1
            const n = this.pendingDownloadCharCount || 0
            return Math.max(1, Math.ceil(n / 500))
        },
        coinChoiceDialogTitle() {
            if (!this.coinChargeEnabled) return '立即使用'
            if (this.pendingDownloadType === '拼接音频') return '拼接音频（扣除1金币）'
            if (this.pendingDownloadType === '播放音频') {
                if (this.ttsEngine !== 'azure') return '播放音频（将消耗金币）'
                const n = this.ttsReadMode === 'favorite' ? 1 : this.getPlayTextChunks().length
                return n > 1 ? `播放长文本（分 ${n} 段合成）` : '播放音频（将消耗金币）'
            }
            return '选择下载方式'
        },
        coinChoiceRuleText() {
            if (!this.coinChargeEnabled) return '当前为限时免费模式，本次不扣金币'
            if (this.pendingDownloadType === '拼接音频') return '固定扣除1金币'
            if (this.pendingDownloadType === '播放音频') {
                if (this.ttsEngine !== 'azure') return '每500字1金币，不足500按500算'
                const chunks = this.ttsReadMode === 'favorite' ? this.getFavoritePlayUnits() : this.getPlayTextChunks()
                if (chunks.length > 1) {
                    return `每段最多 ${TTS_PLAY_CHUNK_SIZE} 字，共 ${chunks.length} 段；每段按 500 字 1 金币计费。全部成功后自动免费拼接为一条完整音频`
                }
                return '每500字1金币，不足500按500算'
            }
            return '下载固定扣除1金币'
        },
        coinChoicePrimaryText() {
            if (!this.coinChargeEnabled) return '立即免费使用'
            if (this.pendingDownloadType === '拼接音频') return '抵扣1金币并拼接'
            if (this.pendingDownloadType === '播放音频') return '抵扣金币并播放'
            return '抵扣金币下载'
        },
        isCurrentAudioDownloaded() {
            const id = this.lastPlayedFilename || this.datapath
            return !!(id && this.downloadedFileIds.indexOf(id) >= 0)
        },
        buyPaymentAmount() {
            const n = Number(this.buyCoinsCount)
            if (isNaN(n) || n < 1) return '0.00'
            return (n * this.pricePerCoin).toFixed(2)
        },
        templateCategories() {
            const cats = []
            this.templateList.forEach(t => { if (t.category && cats.indexOf(t.category) < 0) cats.push(t.category) })
            return cats
        },
        filteredTemplates() {
            if (!this.templateCategory) return this.templateList
            return this.templateList.filter(t => t.category === this.templateCategory)
        },
        favoriteVoiceConfigOptions() {
            const currentVoiceName = (this.voicevalue.voice && this.voicevalue.voice.voicename) || '当前配置'
            const options = [{
                value: 'default',
                label: `当前默认配置 / ${currentVoiceName}`
            }]
            this.favoriteList.forEach(item => {
                options.push({
                    value: this.buildFavoriteConfigKey(item.id),
                    label: `收藏配置 / ${item.name}`
                })
            })
            return options
        },
        selectedVolcVoiceOption() {
            return this.volcVoiceOptions.find(item => item && item.value === this.volcVoiceType) || null
        },
        selectedVolcVoiceLabel() {
            const option = this.selectedVolcVoiceOption
            const value = String(this.volcVoiceType || '').trim()
            if (option && option.label) return option.label
            return value || '请选择发音人'
        },
        selectedVolcVoiceHint() {
            return ''
        },
        selectedVolcVoiceDisplay() {
            const option = this.selectedVolcVoiceOption
            const value = String(this.volcVoiceType || '').trim()
            if (option && option.label) return option.label
            return value || '未设置'
        },
        parsedFavoriteMatchedCount() {
            return this.parsedTtsSegments.filter(item => String(item.configKey || '').indexOf('favorite:') === 0).length
        },
        parsedFavoriteMissingCount() {
            return this.parsedTtsSegments.filter(item => !!item.unmatchedFavoriteName).length
        },
        parsedFavoriteFallbackCount() {
            return this.parsedTtsSegments.filter(item => item.configKey === 'default').length
        },
        filterdata() {
            if (this.sex.length == 0 && this.old.length == 0) {
                return this.voices
            }
            if (this.sex.length == 0 && this.old.length > 0) {
                return this.voices.filter((data) => {
                    return data.old == this.old;
                });
            }
            if (this.sex.length > 0 && this.old.length == 0) {
                return this.voices.filter((data) => {
                    return data.sex == this.sex;
                });
            }
            return this.voices.filter((data) => {
                return data.sex == this.sex && data.old == this.old;
            });
        },
        rolename() {
            if (this.roles.lenght > 0)
                return this.voicevalue.role.rolename
            else return ''
        },
        getDataXML() {
            return this.buildSsmlForText(this.voicetext)
            //let doc = document.implementation.createDocument('', 'speak', null); // 创建一个文档
            // let doc
            // if (window.ActiveXObject) {
            //     doc = new ActiveXObject("Microsoft.XMLDOM");
            // } else  if (typeof document.implementation.createDocument != "undefined") {
            //     doc = document.implementation.createDocument("", "speak", null);
            // }
            // console.log(doc)
            // let speak =doc.documentElement; // 获取文档
            // speak.setAttribute('xmlns', 'http://www.w3.org/2001/10/synthesis') // 设置属性
            // speak.setAttribute('xmlns:mstts', 'http://www.w3.org/2001/mstts') // 设置属性
            // speak.setAttribute('xmlns:emo', 'http://www.w3.org/2009/10/emotionml') // 设置属性
            // speak.setAttribute('version', '1.0') // 设置属性
            // speak.setAttribute('xml:lang', this.voicevalue.language) // 设置属性  
            // let voice = doc.createElement('voice'); // 创建一个元素
            // speak.append(voice) // 
            // voice.setAttribute('name', this.voicevalue.voice) // 设置属性
            // let mstts=doc.createElement('mstts:express-as'); // 创建一个元素
            // voice.append(mstts) 
            // mstts.setAttribute('style', this.voicevalue.style) // 设置属性
            // mstts.setAttribute('role', this.voicevalue.role) // 设置属性           
            // let prosody=doc.createElement('prosody'); // 创建一个元素  
            // mstts.append(prosody)
            // prosody.setAttribute('rate', (this.voicevalue.speech_rate-100)+'%') // 设置属性
            // prosody.setAttribute('pitch', (this.voicevalue.pitch_rate-100)+'%') // 设置属性
            // prosody.setAttribute('volume', (this.voicevalue.volume-100)+"%") // 设置属性
            // prosody.append(doc.createTextNode(this.voicetext)); // 添加 文本属性  
            // return new XMLSerializer().serializeToString(doc).replaceAll("><",">\n<")
        },
    }
}
</script>

<style scoped lang="less">
@media(min-width: 769px) {
    .circle {
        border: #409eff 5px solid;
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }

    .iconfont {
        margin-right: 10px;
    }

    .container {
        border: 1px solid #dedede;
        border-top: none;
        width: 720px;
        display: flex;
        flex-direction: column;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);
    }

    .tts-engine-switch {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 14px 0;
    }

    .tts-engine-switch__label {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
    }

    .nav {
        display: flex;
    }

    .nav span {
        height: 45px;
        width: 120px;
        line-height: 45px;
        text-align: center;
        border-right: 1px solid #dedede;
        border-bottom: 1px solid #dedede;
        cursor: pointer;
        background-color: #f4f4f4;
        font-size: 14px;
    }

    .nav.nav--single span {
        width: 100%;
        border-right: none;
    }

    .nav .active {
        background-color: #eef7ff;
        color: #409eff;
    }

    .contents {
        width: 100%;
        height: 100%;
    }

    .contenttext {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 10px;
    }

    .contenttext--live2d {
        padding: 10px;
    }

    .contenttext--live2d::v-deep .live2d-panel {
        margin-top: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .contenttext--live2d::v-deep .live2d-stage-wrap {
        flex: 1;
        min-height: 0;
    }

    .contenttext--live2d::v-deep .live2d-stage {
        height: 100%;
    }

    .content-toolbar {
        margin-bottom: 8px;
    }

    .volc-control-panel {
        padding: 14px 6px 2px;
    }

    .volc-control-panel__title {
        margin-bottom: 12px;
        font-size: 15px;
        font-weight: 600;
        color: #409eff;
    }

    .volc-control-panel__item {
        margin-bottom: 12px;
        text-align: left;
    }

    .volc-control-panel__voice-row {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        justify-content: flex-start;
    }

    .volc-control-panel__slider-row {
        display: flex;
        align-items: center;
        gap: 18px;
        justify-content: flex-start;
    }

    .volc-control-panel__slider-row .slidertip {
        width: 144px;
        margin-right: 0;
        flex: 0 0 144px;
        white-space: nowrap;
        text-align: left;
    }

    .volc-control-panel__voice-row .slidertip {
        width: 144px;
        margin-right: 0;
        flex: 0 0 144px;
        white-space: nowrap;
        text-align: left;
    }

    .volc-control-panel__voice-select {
        flex: 1;
    }

    .volc-control-panel__voice-main {
        flex: 1;
        min-width: 0;
    }

    .voice-picker-entry--volc {
        margin-bottom: 10px;
    }

    .volc-control-panel__manual-input {
        width: 100%;
    }

    .volc-control-panel__slider-row .slider {
        margin-left: 0;
        width: auto;
        flex: 1;
    }

    .volc-control-panel__slider-row .slidertip .iconfont {
        margin-right: 6px;
        color: #409eff;
    }

    .slidetip--voice {
        line-height: 38px;
    }

    .volc-control-panel__tip {
        font-size: 12px;
        line-height: 1.7;
        color: #909399;
    }

    .volc-format-tip {
        margin: 10px 0 0;
    }

    .tts-segment-panel {
        margin-top: 12px;
        border: 1px solid #ebeef5;
        border-radius: 12px;
        background: #f8fafc;
        padding: 12px;
    }

    .tts-segment-panel__toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        flex-wrap: wrap;
    }

    .tts-segment-panel__actions {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .tts-segment-panel__actions {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .tts-segment-panel__mode {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }

    .tts-segment-panel__label {
        font-size: 13px;
        color: #606266;
        font-weight: 600;
    }

    .tts-segment-panel__body {
        margin-top: 12px;
    }

    .tts-segment-panel__tip {
        margin: 0 0 10px;
        font-size: 12px;
        color: #606266;
        line-height: 1.6;
    }

    .tts-segment-panel__status {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 14px;
        margin-bottom: 10px;
        font-size: 12px;
        color: #909399;
    }

    .tts-segment-panel__warning {
        color: #e6a23c;
    }

    .tts-segment-panel__empty {
        padding: 12px;
        border-radius: 10px;
        background: #fff;
        color: #909399;
        font-size: 13px;
        line-height: 1.6;
    }

    .tts-segment-panel__empty--action {
        min-height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        text-align: center;
    }

    .tts-segment-panel__empty-tip {
        margin: 0;
    }

    .tts-segment-panel__empty--action {
        min-height: 220px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 14px;
        text-align: center;
    }

    .tts-segment-panel__empty-tip {
        margin: 0;
        max-width: 420px;
    }

    .tts-segment-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-height: 260px;
        overflow-y: auto;
        padding-right: 4px;
    }

    .tts-segment-card {
        border-radius: 10px;
        background: #fff;
        border: 1px solid #ebeef5;
        padding: 10px;
    }

    .tts-segment-card__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 8px;
    }

    .tts-segment-card__title-wrap {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        min-width: 0;
    }

    .tts-segment-card__title {
        font-size: 13px;
        font-weight: 600;
        color: #303133;
    }

    .tts-segment-card__speaker {
        font-size: 12px;
        color: #606266;
        line-height: 1.4;
    }

    .tts-segment-card__select {
        width: 220px;
        max-width: 100%;
    }

    .tts-segment-card__meta {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 12px;
        margin-bottom: 8px;
        font-size: 12px;
        color: #909399;
    }

    .tts-segment-card__content {
        padding: 10px 12px;
        border-radius: 10px;
        background: #f7f9fc;
        color: #303133;
        font-size: 14px;
        line-height: 1.7;
        white-space: pre-wrap;
        word-break: break-word;
    }

    .qqtext {
        margin-bottom: 10px;
    }

    .voice-picker-entry {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        padding: 14px 16px;
        margin-bottom: 14px;
        border: 1px solid #dbe7f5;
        border-radius: 14px;
        background: linear-gradient(180deg, #fbfdff 0%, #f3f8ff 100%);
        cursor: pointer;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
    }

    .voice-picker-entry:hover {
        border-color: #8ec5ff;
        box-shadow: 0 10px 24px rgba(64, 158, 255, 0.12);
        transform: translateY(-1px);
    }

    .voice-picker-entry__main {
        min-width: 0;
        flex: 1;
    }

    .voice-picker-entry__label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 6px;
    }

    .voice-picker-entry__value {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
        line-height: 1.5;
        word-break: break-word;
    }

    .voice-picker-entry__meta {
        margin-left: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #909399;
    }

    .voice-picker-entry__actions {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
    }

    .voice-picker-entry__arrow {
        color: #c0c4cc;
        font-size: 16px;
    }

    .mini-program-top-notice {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: calc(100% - 24px);
        margin: 12px auto 0;
        padding: 11px 16px;
        border: 1px solid #bfe8cc;
        border-radius: 14px;
        background: linear-gradient(135deg, #f0fbf4 0%, #f8fffb 58%, #eef7ff 100%);
        color: #244334;
        font-size: 14px;
        line-height: 1.5;
        cursor: pointer;
        box-shadow: 0 10px 24px rgba(47, 158, 68, 0.1);
        transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
    }

    .mini-program-top-notice:hover {
        transform: translateY(-1px);
        border-color: #8ed39f;
        box-shadow: 0 14px 30px rgba(47, 158, 68, 0.16);
    }

    .mini-program-top-notice__badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        min-height: 24px;
        padding: 0 10px;
        border-radius: 999px;
        background: linear-gradient(135deg, #2f9e44 0%, #55c86a 100%);
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.03em;
    }

    .mini-program-top-notice__text {
        min-width: 0;
        font-weight: 600;
    }

    .mini-program-free-tip {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-top: 16px;
        padding: 14px 16px;
        border-radius: 18px;
        background: linear-gradient(135deg, #effaf3 0%, #f8fffb 52%, #eef7ff 100%);
        border: 1px solid #cfe8d7;
        box-shadow: 0 14px 28px rgba(103, 194, 58, 0.12);
        color: #365243;
        line-height: 1.6;
        text-align: left;
    }

    .mini-program-free-tip i {
        color: #2f9e44;
        font-size: 24px;
        flex-shrink: 0;
    }

    .mini-program-free-tip__badge {
        padding: 5px 10px;
        border-radius: 999px;
        background: linear-gradient(135deg, #2f9e44 0%, #55c86a 100%);
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.04em;
        box-shadow: 0 8px 18px rgba(47, 158, 68, 0.22);
        flex-shrink: 0;
    }

    .mini-program-free-tip__content {
        min-width: 0;
        flex: 1;
    }

    .mini-program-free-tip__title {
        font-size: 15px;
        font-weight: 700;
        color: #244334;
    }

    .mini-program-free-tip__desc {
        margin-top: 3px;
        font-size: 12px;
        color: #5f7568;
    }

    .mini-program-free-tip__link {
        border: none;
        background: linear-gradient(135deg, #2f9e44 0%, #55c86a 100%);
        color: #fff;
        cursor: pointer;
        padding: 10px 16px;
        border-radius: 999px;
        font-size: 13px;
        font-weight: 600;
        box-shadow: 0 10px 22px rgba(47, 158, 68, 0.18);
        transition: transform .2s ease, box-shadow .2s ease, opacity .2s ease;
        flex-shrink: 0;
    }

    .mini-program-free-tip__link:hover {
        opacity: .95;
        transform: translateY(-1px);
        box-shadow: 0 12px 24px rgba(47, 158, 68, 0.22);
    }

    .mini-program-guide-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .mini-program-guide-title i {
        margin-right: 8px;
        font-size: 22px;
        color: #67c23a;
    }

    .mini-program-guide-body {
        padding: 8px 0 4px;
    }

    .mini-program-guide-tip {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 14px 16px;
        margin-bottom: 18px;
        border-radius: 10px;
        background: #f0f9eb;
        border: 1px solid #e1f3d8;
        color: #606266;
        font-size: 14px;
        line-height: 1.6;
    }

    .mini-program-guide-tip i {
        color: #67c23a;
        font-size: 18px;
        flex-shrink: 0;
        margin-top: 2px;
    }

    .mini-program-guide-qr-wrap {
        width: 100%;
        max-width: 280px;
        margin: 0 auto 16px;
        padding: 12px;
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 12px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    }

    .mini-program-guide-qr {
        display: block;
        width: 100%;
        border-radius: 8px;
    }

    .mini-program-guide-note {
        margin: 0 0 16px;
        text-align: center;
        color: #909399;
        font-size: 13px;
        line-height: 1.6;
    }

    /* 验证码弹窗（扫码看视频赚金币） */
    .verify-code-dialog ::v-deep .el-dialog__header {
        padding: 16px 20px 14px;
        border-bottom: 1px solid #ebeef5;
    }
    .verify-code-dialog-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }
    .verify-code-dialog-title i {
        margin-right: 8px;
        font-size: 22px;
        color: #67c23a;
    }
    .verify-code-body {
        padding: 20px 0 8px;
    }
    .verify-code-tip {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 12px 14px;
        background: #f0f9eb;
        border: 1px solid #e1f3d8;
        border-radius: 8px;
        margin-bottom: 20px;
        font-size: 14px;
        color: #606266;
        line-height: 1.5;
    }
    .verify-code-tip i {
        font-size: 18px;
        color: #67c23a;
        flex-shrink: 0;
        margin-top: 1px;
    }
    .verify-code-qr-wrap {
        margin: 0 auto 20px;
        width: 100%;
        max-width: 260px;
        padding: 12px;
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0,0,0,.06);
    }
    .verify-code-qr {
        width: 100%;
        display: block;
        border-radius: 6px;
    }
    .verify-code-input-wrap {
        margin-bottom: 0;
    }
    .verify-code-label {
        display: block;
        font-size: 14px;
        color: #606266;
        margin-bottom: 8px;
    }
    .verify-code-input { width: 100%; }
    .verify-code-footer {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-end;
        padding-top: 4px;
    }

    .imgclass {
        margin: 0 auto;
        width: 350px;
    }

    /* 购买金币弹窗 */
    .buy-coins-dialog ::v-deep .el-dialog__header {
        padding: 18px 20px 14px;
        border-bottom: 1px solid #ebeef5;
    }
    .buy-coins-dialog-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }
    .buy-coins-dialog-title i {
        margin-right: 8px;
        font-size: 22px;
        color: #e6a23c;
    }
    .buy-coins-body { padding: 20px 0 8px; }
    .buy-coins-field { margin-bottom: 20px; }
    .buy-coins-label {
        display: block;
        font-size: 14px;
        color: #606266;
        margin-bottom: 10px;
    }
    .buy-coins-input { width: 100%; }
    .buy-coins-input ::v-deep .el-input-number { width: 100%; }
    .buy-coins-summary {
        background: #f5f7fa;
        border-radius: 8px;
        padding: 14px 16px;
        margin-bottom: 22px;
    }
    .buy-coins-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        margin-bottom: 8px;
    }
    .buy-coins-row:last-child { margin-bottom: 0; }
    .buy-coins-desc { color: #909399; }
    .buy-coins-price { color: #e6a23c; font-weight: 500; }
    .buy-coins-row.total .buy-coins-desc { font-weight: 500; color: #606266; }
    .buy-coins-amount { font-size: 18px; font-weight: 600; color: #f56c6c; }
    .buy-coins-footer {
        display: flex;
        gap: 12px;
        justify-content: flex-end;
    }
    .buy-coins-btn { flex: 1; }

    .qqimg {
        width: 100%;
    }

    .musictip {
        font-size: 12px;
        margin-bottom: 10px;
        color: #92929b;
    }

    .param-reset-row {
        display: flex;
        justify-content: flex-end;
        margin-top: 8px;
    }

    .bgm-picker-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 16px 18px;
        margin-bottom: 14px;
        border-radius: 16px;
        background: linear-gradient(180deg, #fbfdff 0%, #f4f8ff 100%);
        border: 1px solid #dbe7f5;
    }

    .bgm-picker-card__main {
        min-width: 0;
        flex: 1;
    }

    .bgm-picker-card__label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 6px;
    }

    .bgm-picker-card__value {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
        word-break: break-all;
    }

    .bgm-picker-card__actions {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .bgm-selected-tip {
        margin: -2px 0 12px;
        padding: 10px 12px;
        border-radius: 12px;
        background: #f0f9eb;
        border: 1px solid #e1f3d8;
        color: #606266;
        font-size: 12px;
        line-height: 1.6;
    }

    .bgm-dialog-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .bgm-dialog-title i {
        color: #409eff;
        font-size: 20px;
    }

    .bgm-dialog-toolbar {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        margin-bottom: 14px;
    }

    .bgm-dialog-toolbar__left {
        min-width: 0;
        flex: 1;
    }

    .bgm-dialog-toolbar__label {
        margin-bottom: 10px;
        font-size: 13px;
        font-weight: 600;
        color: #606266;
    }

    .bgm-dialog-toolbar__right {
        flex-shrink: 0;
    }

    .bgm-type-group {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .bgm-type-group .el-radio-button {
        margin: 0 8px 8px 0;
    }

    .bgm-dialog-current {
        margin-bottom: 14px;
        padding: 12px 14px;
        border-radius: 14px;
        background: #f7f9fc;
        border: 1px solid #ebeef5;
        font-size: 13px;
        color: #606266;
    }

    .bgm-dialog-current__label {
        color: #909399;
    }

    .bgm-dialog-current__value {
        margin-left: 6px;
        color: #303133;
        font-weight: 600;
    }

    .bgm-dialog-settings {
        margin-bottom: 14px;
        padding: 14px 16px 8px;
        border-radius: 16px;
        background: linear-gradient(180deg, #fcfdfd 0%, #f6f9fb 100%);
        border: 1px solid #ebeef5;
    }

    .bgm-dialog-settings__title {
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 600;
        color: #303133;
    }

    .bgm-dialog-settings__row + .bgm-dialog-settings__row {
        margin-top: 10px;
    }

    .bgm-dialog-settings__label {
        margin-bottom: 8px;
        font-size: 13px;
        color: #606266;
    }

    .bgm-dialog-body {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 300px;
        gap: 16px;
        align-items: start;
    }

    .bgm-dialog-library {
        min-width: 0;
    }

    .bgm-dialog-side {
        min-width: 0;
        position: sticky;
        top: 0;
    }

    .bgm-dialog-list {
        max-height: 52vh;
        overflow: auto;
        padding-right: 4px;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
    }

    .bgm-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 16px;
        border-radius: 16px;
        border: 1px solid #ebeef5;
        background: #fff;
        transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
    }

    .bgm-item.active {
        border-color: #67c23a;
        box-shadow: 0 10px 24px rgba(103, 194, 58, 0.12);
        transform: translateY(-1px);
    }

    .bgm-item__main {
        flex: 1;
        min-width: 0;
        cursor: pointer;
    }

    .bgm-item__name {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
        word-break: break-all;
    }

    .bgm-item__meta {
        margin-top: 6px;
        font-size: 12px;
        color: #909399;
    }

    .bgm-item__actions {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .bgm-empty-state {
        padding: 24px 0;
        text-align: center;
        font-size: 13px;
        color: #909399;
    }

    @media (max-width: 768px) {
        .bgm-picker-card {
            flex-direction: column;
            align-items: stretch;
        }

        .bgm-picker-card__actions {
            justify-content: stretch;
        }

        .bgm-picker-card__actions .el-button {
            width: 100%;
            margin-left: 0 !important;
        }

        .bgm-dialog-toolbar {
            flex-direction: column;
        }

        .bgm-dialog-body {
            grid-template-columns: minmax(0, 1fr);
        }

        .bgm-dialog-side {
            position: static;
        }

        .bgm-dialog-toolbar__right,
        .bgm-upload,
        .bgm-upload .el-upload {
            width: 100%;
        }

        .bgm-upload .el-button {
            width: 100%;
        }

        .bgm-dialog-list {
            max-height: 42vh;
            grid-template-columns: minmax(0, 1fr);
        }

        .bgm-item {
            flex-direction: column;
            align-items: stretch;
        }

        .bgm-item__actions {
            justify-content: flex-start;
        }
    }

    .toptip {
        margin-top: 18px;
        padding: 20px 22px 18px;
        border: 1px solid #dbe7f5;
        border-radius: 18px;
        background: linear-gradient(180deg, #fbfdff 0%, #f3f8ff 100%);
        box-shadow: 0 16px 36px rgba(64, 158, 255, 0.08);
    }

    .toptip-section + .toptip-section {
        margin-top: 12px;
    }

    .toptip-toggle {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 0;
        border: 0;
        background: transparent;
        cursor: pointer;
        text-align: left;
    }

    .toptip-toggle__main {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
    }

    .toptip-toggle__title {
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
        padding: 6px 14px;
        border-radius: 999px;
        background: rgba(64, 158, 255, 0.1);
        color: rgb(64, 158, 255);
        font-size: 15px;
        line-height: 1.2;
        font-weight: bold;
        letter-spacing: 0.5px;
    }

    .toptip-toggle__hint {
        min-width: 0;
        color: #6b7a90;
        font-size: 13px;
        line-height: 1.5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .toptip-toggle i {
        color: #409eff;
        font-size: 16px;
        font-weight: 700;
        flex-shrink: 0;
    }

    .toptip-body {
        margin-top: 12px;
    }

    .tishi {
        display: inline-flex;
        align-items: center;
        margin: 0 0 12px;
        padding: 6px 14px;
        border-radius: 999px;
        background: rgba(64, 158, 255, 0.1);
        color: rgb(64, 158, 255);
        font-size: 15px;
        line-height: 1.2;
        font-weight: bold;
        letter-spacing: 0.5px;
    }

    .tishi:not(:first-child) {
        margin-top: 10px;
    }

    .tishitip {
        position: relative;
        margin: 0 0 10px;
        padding: 11px 14px 11px 16px;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.9);
        border: 1px solid rgba(64, 158, 255, 0.12);
        box-shadow: 0 8px 18px rgba(31, 45, 61, 0.05);
        font-size: 13px;
        line-height: 1.75;
        vertical-align: middle;
        color: #4a5568;

        span {
            color: #f00;
        }
    }

    .tishitip:last-child {
        margin-bottom: 0;
    }

    .main {
        width: 100%;
        font-size: 16px;
    }

    .tts {
        display: flex;
        flex-direction: column;
        align-items: stretch;
    }

    .tts-top-row {
        display: flex;
        align-items: stretch;
        width: 100%;
    }

    .synth-progress-strip {
        width: 100%;
        box-sizing: border-box;
        padding: 8px 4px 12px;
        max-width: 1200px;
    }

    .synth-eta-hint {
        margin: 8px 0 0;
        font-size: 13px;
        color: #606266;
        line-height: 1.45;
    }

    .left {
        margin-top: 5px;
        box-sizing: border-box;
        width: 720px;
        font-size: 14px;
    }

    .wenben {
        border-radius: 5px;
        outline: none;
        resize: none;
        padding: 10px;
        overflow: auto;
        margin-top: 8px;
        flex-grow: 1;
    }

    .tts-original-panel {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
    }

    .tts-original-panel .wenben {
        flex: 1;
        min-height: 0;
        height: 100%;
        margin-top: 0;
    }

    .wenben:focus {
        border: 1px solid rgb(64, 158, 255)
    }



    .ssmlwenben {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        outline: none;
        resize: none;
        padding: 10px;
        overflow: auto;
    }

    .ssmlwenben:focus {
        border: 1px solid rgb(64, 158, 255)
    }

    .right {
        margin-left: 20px;
        width: 480px;
        line-height: 20px;
        box-sizing: border-box;
    }

    .right .el-collapse-item__header {
        padding-left: 10px;
    }
    .right .el-collapse-item__header span .iconfont {
        margin-left: 8px;
        margin-right: 10px;
    }

    .uploadclass {
        display: flex;
        justify-content: space-evenly;
        margin-bottom: 10px;
    }

    .slider {
        margin-left: 15px;
        width: 90%;
        box-sizing: border-box;
    }

    .select {
        width: 100%;
        margin: 0 auto;
    }

    .myitem {
        display: flex;
        margin-top: 12px;
        height: 38px;
    }

    .selectinner {
        width: 88%;
        box-sizing: border-box;
    }

    .slidertip {
        width: 12%;
        text-align: right;
        line-height: 38px;
        box-sizing: border-box;
        margin-right: 5px;
    }

    .btngroup {
        margin-top: 15px;
        margin-left: 10px;
    }


    .btn {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .downloaded-tag { margin-right: 8px; vertical-align: middle; }
    .status-pending { color: #909399; font-size: 12px; }
    .record-table-wrap .el-table__empty-block {
        min-height: 56px;
    }
    .record-table-wrap .el-table__empty-text {
        line-height: 1.35;
    }
    .record-table-wrap .record-table-empty {
        margin: 0;
        padding: 4px 0;
        color: #909399;
        font-size: 14px;
    }
    .record-table-wrap .el-table td.col-datetime .record-time-text {
        margin-left: 10px;
    }
    .splice-btns {
        margin-top: 14px;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: center;
        padding: 12px 14px;
        border-radius: 16px;
        background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
        border: 1px solid rgba(64, 158, 255, 0.14);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
    }
    .splice-btns .splice-btn {
        width: 180px;
        min-width: 180px;
        height: 40px;
        border-radius: 999px;
        font-weight: 600;
        letter-spacing: 0.2px;
        box-shadow: 0 10px 20px rgba(64, 158, 255, 0.12);
    }
    .splice-btns .splice-btn.el-button--danger {
        box-shadow: 0 10px 20px rgba(245, 108, 108, 0.14);
    }
    .buttonstyle {
        margin-bottom: 10px;
    }

    .audiodiv {
        height: 65px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    .audiodiv audio {
        width: min(100%, 420px);
        border-radius: 14px;
        color-scheme: light;
    }

    .mysearch {
        display: flex;
        justify-content: center;
        align-items: center;

        .tip {
            text-align: right;
            font-weight: bold;
            width: 65px;
            height: 45px;
            line-height: 45px;
            margin-left: 5px;
            margin-right: 5px;
        }
    }

    .myitemstyle {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 15px;

        .tip {
            width: 62px;
            height: 50px;
            line-height: 50px;
        }

        .styleslider {
            width: 210px;
            margin-left: 15px;
            margin-right: 15px;
            box-sizing: border-box;
        }

        .styleselect {
            box-sizing: border-box;
            margin-right: 15px;
            width: 100px;
        }
    }

    .record-table-wrap .record-search-bar {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 12px;
        align-items: center;
    }
    .record-table-wrap .record-search-bar .record-search-input {
        width: 220px;
        min-width: 160px;
    }
    .record-table-wrap .record-search-bar .record-search-date {
        width: 160px;
    }
    .record-table-wrap .record-search-bar .record-search-actions {
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
    }
    .record-table-wrap .record-search-bar .record-search-btn,
    .record-table-wrap .record-search-bar .record-reset-btn {
        flex-shrink: 0;
    }
    .record-table-wrap .record-table-tip {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 16px 0 12px 0;
        padding: 10px 14px;
        font-size: 14px;
        color: #606266;
        background: linear-gradient(135deg, #f4f7fa 0%, #e8eef5 100%);
        border-radius: 8px;
        border: 1px solid #e4e7ed;
        box-shadow: 0 1px 2px rgba(0,0,0,.04);
    }
    .record-table-wrap .record-table-tip i {
        color: #409eff;
        font-size: 16px;
    }
    .record-table-wrap .el-table td.col-content {
        max-width: 380px;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
    }
    .record-table-wrap .el-table td.col-content .cell {
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
    }
    .record-table-wrap .el-table td.col-content .col-content-text {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

}

@media(max-width: 768px) {
    audio::-internal-media-controls-download-button {
     display:none;
    }
    .uploadclass {
        display: flex;
        justify-content: space-evenly;
        margin-top: 1vh;
        margin-bottom: 1vh;
    }

    .myitem {
        display: flex;
        margin-top: 1vh;
        height: 5vh;
    }

    .selectinner {
        width: 80vw;
        box-sizing: border-box;
    }

    .slidertip {
        width: 20vw;
        text-align: right;
        line-height: 5vh;
        box-sizing: border-box;
        margin-right: 1vw;
    }

    .inputtext {
        font-size: 12px;
        color: #92929b;
    }

    .slider {
        margin-left: 3vw;
        width: 90%;
        box-sizing: border-box;
    }

    .container {
        border: 1px solid #dedede;
        border-top: none;
        width: 100vw;
        min-height: 30vh;
        height: auto;
        display: flex;
        flex-direction: column;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);
    }

    .tts-engine-switch {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 10px 12px 0;
        flex-wrap: wrap;
    }

    .tts-engine-switch__label {
        font-size: 13px;
        font-weight: 600;
        color: #303133;
    }

    .nav {
        display: flex;
    }

    .nav span {
        height: 5vh;
        width: 33.3333%;
        min-width: 0;
        line-height: 5vh;
        text-align: center;
        border-right: 1px solid #dedede;
        border-bottom: 1px solid #dedede;
        cursor: pointer;
        background-color: #f4f4f4;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .nav.nav--single span {
        width: 100%;
        border-right: none;
    }

    .volc-control-panel {
        padding: 12px 4px 2px;
    }

    .volc-control-panel__title {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 600;
        color: #409eff;
    }

    .volc-control-panel__item {
        margin-bottom: 10px;
        text-align: left;
    }

    .volc-control-panel__voice-row {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        justify-content: flex-start;
    }

    .volc-control-panel__slider-row {
        display: flex;
        align-items: center;
        gap: 12px;
        justify-content: flex-start;
    }

    .volc-control-panel__slider-row .slidertip {
        width: 124px;
        margin-right: 0;
        flex: 0 0 124px;
        white-space: nowrap;
        text-align: left;
    }

    .volc-control-panel__voice-row .slidertip {
        width: 124px;
        margin-right: 0;
        flex: 0 0 124px;
        white-space: nowrap;
        text-align: left;
    }

    .volc-control-panel__voice-select {
        flex: 1;
    }

    .volc-control-panel__voice-main {
        flex: 1;
        min-width: 0;
    }

    .voice-picker-entry--volc {
        margin-bottom: 8px;
    }

    .volc-control-panel__manual-input {
        width: 100%;
    }

    .volc-control-panel__slider-row .slider {
        margin-left: 0;
        width: auto;
        flex: 1;
    }

    .volc-control-panel__slider-row .slidertip .iconfont {
        margin-right: 6px;
        color: #409eff;
    }

    .slidetip--voice {
        line-height: 5vh;
    }

    .volc-control-panel__tip {
        font-size: 12px;
        line-height: 1.6;
        color: #909399;
    }

    .volc-format-tip {
        margin: 10px 0 0;
    }

    .nav .active {
        background-color: #eef7ff;
        color: #409eff;
    }

    .contents {
        width: 100%;
        height: auto;
        min-height: 0;
    }

    .contenttext {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        width: 100%;
        height: auto;
        min-height: 0;
        padding: 10px;
    }

    .contenttext--live2d {
        padding: 10px;
        min-height: 56vh;
    }

    .contenttext--live2d::v-deep .live2d-panel {
        margin-top: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .contenttext--live2d::v-deep .live2d-stage-wrap {
        flex: 1;
        min-height: 42vh;
    }

    .contenttext--live2d::v-deep .live2d-stage {
        height: 100%;
    }

    .tts-segment-panel {
        margin-top: 10px;
        padding: 10px;
        border-radius: 10px;
    }

    .tts-segment-panel__toolbar {
        gap: 10px;
    }

    .tts-segment-panel__mode {
        width: 100%;
        align-items: stretch;
        gap: 8px;
    }

    .tts-segment-panel__label {
        font-size: 12px;
    }

    .tts-segment-panel__mode .el-radio-group {
        display: flex;
        width: 100%;
    }

    .tts-segment-panel__mode .el-radio-group .el-radio-button {
        flex: 1;
    }

    .tts-segment-panel__mode .el-radio-group .el-radio-button__inner {
        width: 100%;
        padding: 9px 0;
    }

    .tts-segment-panel__actions {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .tts-segment-panel__actions .el-button {
        width: 100%;
        margin: 0;
    }

    .tts-segment-panel__status {
        gap: 6px 10px;
        font-size: 11px;
    }

    .tts-segment-panel__empty {
        padding: 10px;
        font-size: 12px;
    }

    .tts-segment-panel__empty--action {
        min-height: 148px;
        gap: 10px;
        padding: 16px 12px;
    }

    .tts-segment-panel__empty-tip {
        font-size: 12px;
        line-height: 1.6;
    }

    .tts-segment-list {
        max-height: none;
        overflow: visible;
        padding-right: 0;
    }

    .tts-segment-card {
        padding: 10px;
        border-radius: 12px;
    }

    .tts-segment-card__header {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }

    .tts-segment-card__title-wrap {
        display: grid;
        gap: 6px;
    }

    .tts-segment-card__title {
        font-size: 14px;
    }

    .tts-segment-card__speaker {
        font-size: 12px;
    }

    .tts-segment-card__select {
        width: 100%;
    }

    .tts-segment-card__content {
        padding: 9px 10px;
        font-size: 13px;
        line-height: 1.65;
    }

    .content-toolbar .el-button-group {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        margin: 0;
        padding: 0;
        width: 100%;
    }
    .content-toolbar .el-button-group .el-button {
        border-radius: 20px !important;
        margin: 0 !important;
    }
    .content-toolbar .el-button-group .el-button:nth-child(1),
    .content-toolbar .el-button-group .el-button:nth-child(4) {
        grid-column: 1;
    }
    .content-toolbar .el-button-group .el-button:nth-child(2) { grid-column: 2; }
    .content-toolbar .el-button-group .el-button:nth-child(3) { grid-column: 3; }
    .content-toolbar .el-button-group .el-button:nth-child(5) { grid-column: 2; }

    .qqtext {
        margin-bottom: 1vw;
    }

    .mini-program-top-notice {
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;
        width: calc(100% - 16px);
        margin-top: 8px;
        padding: 10px 12px;
        font-size: 12px;
    }

    .mini-program-top-notice__badge {
        min-height: 22px;
        padding: 0 8px;
        font-size: 11px;
    }

    .mini-program-free-tip {
        margin-top: 12px;
        padding: 14px 12px;
        gap: 10px;
        align-items: flex-start;
        border-radius: 16px;
    }

    .mini-program-free-tip__badge {
        font-size: 11px;
        padding: 4px 9px;
    }

    .mini-program-free-tip__title {
        font-size: 14px;
    }

    .mini-program-free-tip__desc {
        font-size: 12px;
    }

    .voice-picker-entry {
        align-items: flex-start;
        padding: 12px;
    }

    .voice-picker-entry__actions {
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
    }

    .voice-picker-entry__value {
        font-size: 14px;
    }

    .voice-picker-entry__meta {
        display: block;
        margin: 4px 0 0;
    }

    .mini-program-free-tip__link {
        font-size: 12px;
        padding: 9px 14px;
    }

    .mini-program-guide-body {
        padding-top: 4px;
    }

    .mini-program-guide-tip {
        padding: 12px 14px;
        margin-bottom: 14px;
        font-size: 13px;
    }

    .mini-program-guide-qr-wrap {
        max-width: 62vw;
        margin-bottom: 14px;
    }

    .mini-program-guide-note {
        font-size: 12px;
        margin-bottom: 14px;
    }

    .imgclass {
        margin: 0 auto;
        width: 50vw;
    }

    .qqimg {
        width: 100%;
    }

    .toptip {
        width: 94vw;
        margin: 3vw auto;
        padding: 16px 14px 14px;
        box-sizing: border-box;
        border-radius: 16px;
        border: 1px solid #dbe7f5;
        background: linear-gradient(180deg, #fbfdff 0%, #f3f8ff 100%);
        box-shadow: 0 12px 28px rgba(64, 158, 255, 0.08);

    }

    .toptip-toggle__title {
        padding: 5px 12px;
        font-size: 14px;
    }

    .toptip-toggle__main {
        display: block;
    }

    .toptip-toggle__hint {
        display: block;
        margin-top: 7px;
        font-size: 12px;
        white-space: normal;
    }

    .toptip-toggle i {
        font-size: 15px;
    }

    .toptip-body {
        margin-top: 10px;
    }

    .tishi {
        margin: 0 0 10px;
        padding: 5px 12px;
        font-size: 14px;
        line-height: 1.2;
    }

    .tishi:not(:first-child) {
        margin-top: 10px;
    }

    .tishitip {
        margin: 0 0 9px;
        padding: 10px 12px 10px 14px;
        font-size: 12px;
        line-height: 1.7;
        border-radius: 12px;

        span {
            color: #f00;
        }
    }

    .record-table-wrap .el-table td.col-datetime .record-time-icon {
        display: none;
    }
    .record-table-wrap .el-table td.col-datetime .record-time-text {
        margin-left: 0;
        white-space: nowrap;
    }
    .record-table-wrap .el-table thead th:nth-child(1),
    .record-table-wrap .el-table tbody td:nth-child(1) {
        width: 40px;
        min-width: 40px;
        max-width: 40px;
    }
    .record-table-wrap .el-table td.col-selection .cell {
        overflow: visible;
        text-overflow: clip;
    }
    .record-table-wrap .el-table .el-table__body tr.current-row > td {
        background-color: #c6e2ff !important;
    }
    .record-table-wrap .el-table .el-table__body tr.current-row > td:first-child {
        border-left: 3px solid #409eff;
    }
    .record-table-wrap .record-search-bar {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
        margin-bottom: 10px;
    }
    .record-table-wrap .record-search-bar .record-search-input,
    .record-table-wrap .record-search-bar .record-search-date {
        width: 100% !important;
        max-width: 100%;
    }
    .record-table-wrap .record-search-bar .record-search-date .el-input__inner {
        padding-left: 12px;
        padding-right: 12px;
    }
    .record-table-wrap .record-search-bar .record-search-actions {
        display: flex;
        flex-direction: row;
        gap: 12px;
    }
    .record-table-wrap .record-search-bar .record-search-actions .el-button {
        flex: 1;
        margin: 0;
    }
    .record-table-wrap .record-table-tip {
        display: flex;
        align-items: center;
        gap: 6px;
        margin: 0 0 10px 0;
        padding: 8px 12px;
        font-size: 13px;
        color: #606266;
        background: linear-gradient(135deg, #f4f7fa 0%, #e8eef5 100%);
        border-radius: 6px;
        border: 1px solid #e4e7ed;
    }
    .record-table-wrap .record-table-tip i {
        color: #409eff;
        font-size: 14px;
    }
    .record-table-wrap .el-table__empty-block {
        min-height: 48px;
    }
    .record-table-wrap .el-table td.col-content .cell {
        white-space: nowrap !important;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
    }
    .record-table-wrap .el-table td.col-content .col-content-text {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
    }
    .record-table-wrap .el-table thead th:nth-child(3),
    .record-table-wrap .el-table tbody td.col-datetime {
        width: 80px;
        min-width: 80px;
        max-width: 80px;
        white-space: nowrap;
    }

    .record-card-list {
        max-height: 400px;
        overflow-y: auto;
        padding: 0 12px 8px;
    }
    .record-card-list .record-table-empty {
        padding: 4px 0;
        text-align: center;
        color: #909399;
        margin: 0;
    }
    .record-card {
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 6px;
        padding: 12px;
        margin-bottom: 10px;
        box-shadow: 0 1px 2px rgba(0,0,0,.04);
        cursor: pointer;
    }
    .record-card-current {
        border-color: #409eff;
    }
    .record-card-head {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        flex-wrap: wrap;
    }
    .record-card-checkbox {
        margin-right: 4px;
    }
    .record-card-time {
        font-size: 12px;
        color: #909399;
        margin-right: 8px;
    }
    .record-card-type {
        margin-right: 6px;
    }
    .record-card-content {
        font-size: 13px;
        color: #606266;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 10px;
    }
    .record-card-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
    .record-card-actions .el-button {
        margin: 0;
    }

    .splice-btns {
        margin-top: 14px;
        margin-left: 12px;
        margin-right: 12px;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: center;
    }
    .splice-btns .el-button,
    .splice-btns .splice-btn {
        margin: 0;
        flex: 1 1 0;
        min-width: 0;
        padding: 10px 8px;
        font-size: 13px;
        border-radius: 999px;
        text-align: center;
    }

    .main {
        width: 100vw;

    }

    .left {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 96vw;
    }

    .right {
        width: 93vw;
        line-height: 5.5vh;
        box-sizing: content-box;
        padding-left: 3.5vw;
        margin-top: 2vh;
    }
    .right .el-collapse-item__header span .iconfont {
        margin-left: 8px;
        margin-right: 10px;
    }
    .right .el-collapse-item__header {
        padding-left: 10px;
    }

    .select {
        width: 100%;
    }

    .wenben {
        width: 90vw;
        border-radius: 5px;
        font-size: 14px;
        outline: none;
        resize: vertical;
        min-height: 220px;
        padding: 2vw;
        overflow: auto;
        margin-top: 1vh;
        flex-grow: 1;
    }

    .tts-original-panel {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
    }

    .tts-original-panel .wenben {
        flex: 1;
        min-height: 0;
        height: 100%;
    }

    .tts-dialog-textarea {
        width: 100%;
    }

    .tts-dialog-textarea ::v-deep .el-textarea__inner {
        min-height: 58vh !important;
        padding: 18px 20px;
        border-radius: 16px;
        border: 1px solid #d8e1ec;
        background: linear-gradient(180deg, #fbfdff 0%, #f6f9fc 100%);
        color: #2b2f36;
        font-size: 15px;
        line-height: 1.75;
        box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
        transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
    }

    .tts-dialog-textarea ::v-deep .el-textarea__inner:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
        background: #fff;
    }



    .btn {
        margin-top: 2vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .buttonstyle {
        margin-bottom: 2vh;
    }

    .audiodiv {
        margin-top: 2vh;
        height: 5vh;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    .mysearch {
        display: flex;
        justify-content: center;
        align-items: center;

        .tip {
            text-align: right;
            font-weight: bold;
            width: 20vw;
            height: 5vh;
            line-height: 5vh;
            margin-left: 1vw;
            margin-right: 1vw;
        }
    }

    .myitemstyle {
        display: flex;
        align-items: center;
        margin-top: 15px;
        box-sizing: border-box;

        .tip {
            width: 19vw;
            text-align: right;
            height: 5vh;
            line-height: 5vh;
            box-sizing: border-box;
            margin-right: 1vw;

        }

        .styleslider {
            width: 36vw;
            margin-right: 1vw;
            box-sizing: border-box;
        }

        .styleselect {
            box-sizing: border-box;
            margin-right: 1vw;
            width: 20vw;
        }
    }
}
</style>

<style>
/* 百度网盘：更美观的“处理中/已生成”弹窗 */
.baidu-pan-dialog .el-dialog {
  border-radius: 14px;
  overflow: hidden;
}
.baidu-pan-dialog .el-dialog__header {
  padding: 14px 16px 10px;
  background: linear-gradient(135deg, #f3f7ff 0%, #f8f4ff 40%, #fff7f3 100%);
}
.baidu-pan-dialog .el-dialog__body {
  padding: 14px 18px 18px;
}
.baidu-pan-loading-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.baidu-pan-title-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  flex: 0 0 auto;
}
.baidu-pan-title-icon.success {
  background: rgba(103, 194, 58, 0.14);
  color: #67c23a;
}
.baidu-pan-title-text {
  min-width: 0;
}
.baidu-pan-title-main {
  font-size: 14px;
  font-weight: 700;
  color: #303133;
  line-height: 1.2;
}
.baidu-pan-title-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #606266;
  line-height: 1.2;
}
.baidu-pan-loading-body .baidu-pan-status {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f1f7ff 0%, #f6f3ff 60%, #fff6f1 100%);
  border: 1px solid rgba(64, 158, 255, 0.18);
  color: #2b2f36;
}
.baidu-pan-loading-body .baidu-pan-status-icon {
  color: #409eff;
  font-size: 16px;
}
.baidu-pan-loading-body .baidu-pan-status-icon.success {
  color: #67c23a;
}
.baidu-pan-loading-body .baidu-pan-status-text {
  font-size: 14px;
}
.baidu-pan-loading-body .baidu-pan-result {
  margin-top: 12px;
}
.baidu-pan-loading-body .baidu-pan-field + .baidu-pan-field {
  margin-top: 10px;
}
.baidu-pan-loading-body .baidu-pan-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 6px;
}
.baidu-pan-loading-body .baidu-pan-actions {
  margin-top: 12px;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
<style>
/* 插入停顿弹窗（挂到 body，需全局样式） */
.insert-pause-dialog.el-dialog {
    width: 420px !important;
    max-width: 92vw;
    border-radius: 12px;
    overflow: hidden;
}
.insert-pause-dialog .el-dialog__header {
    padding: 18px 24px 14px;
    border-bottom: 1px solid #ebeef5;
    background: linear-gradient(to bottom, #fafbfc 0%, #fff 100%);
}
.insert-pause-dialog .el-dialog__title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}
.insert-pause-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}
.insert-pause-title .el-icon-video-pause {
    font-size: 22px;
    color: #409eff;
}
.insert-pause-desc i {
    margin-right: 6px;
    color: #909399;
    vertical-align: middle;
}
.insert-pause-label i {
    margin-right: 6px;
    color: #409eff;
    font-size: 15px;
}
.insert-pause-dialog .el-dialog__body {
    padding: 20px 24px 24px;
}
.insert-pause-dialog .el-dialog__footer {
    padding: 14px 24px 20px;
    border-top: 1px solid #ebeef5;
}
.tts-editor-dialog.el-dialog {
    width: 900px !important;
    max-width: 94vw;
    border-radius: 14px;
    overflow: hidden;
}
.tts-editor-dialog .el-dialog__header {
    padding: 18px 24px 14px;
    border-bottom: 1px solid #ebeef5;
    background: linear-gradient(to bottom, #fafbfc 0%, #fff 100%);
}
.tts-editor-dialog .el-dialog__body {
    padding: 20px 24px 16px;
}
.tts-editor-dialog .el-dialog__footer {
    padding: 0 24px 20px;
}
.tts-editor-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}
.tts-editor-title .el-icon-edit-outline {
    font-size: 22px;
    color: #409eff;
}
.tts-editor-footer {
    display: flex;
    justify-content: flex-end;
}
.insert-pause-desc {
    margin: 0 0 20px;
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
}
.insert-pause-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.insert-pause-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.insert-pause-label {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
}
.insert-pause-input {
    width: 100%;
    max-width: 200px;
}
.insert-pause-input .el-input__inner {
    text-align: left;
}
.insert-pause-unit .el-radio-button__inner {
    padding: 10px 20px;
}
.insert-pause-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}
.insert-pause-footer .el-button {
    min-width: 88px;
}

/* 插入停顿弹窗 - 移动端适配 */
@media (max-width: 768px) {
    .insert-pause-dialog.el-dialog {
        width: 92vw !important;
        max-width: 92vw;
        margin: 5vh auto !important;
    }
    .insert-pause-dialog .el-dialog__header {
        padding: 16px 18px 12px;
    }
    .insert-pause-title {
        font-size: 17px;
    }
    .insert-pause-title .el-icon-video-pause {
        font-size: 20px;
    }
    .insert-pause-dialog .el-dialog__body {
        padding: 16px 18px 20px;
    }
    .insert-pause-desc {
        font-size: 13px;
        margin-bottom: 18px;
        padding: 10px 12px;
        background: #f4f4f5;
        border-radius: 8px;
        border-left: 3px solid #409eff;
    }
    .insert-pause-desc i {
        font-size: 16px;
    }
    .insert-pause-body {
        gap: 18px;
    }
    .insert-pause-field {
        gap: 10px;
    }
    .insert-pause-label {
        font-size: 14px;
    }
    .insert-pause-input {
        max-width: 100%;
    }
    .insert-pause-input .el-input-number {
        width: 100%;
    }
    .insert-pause-input .el-input-number .el-input__inner {
        font-size: 16px;
        padding: 12px 15px;
        min-height: 48px;
    }
    .insert-pause-unit {
        display: flex;
        width: 100%;
    }
    .insert-pause-unit .el-radio-button {
        flex: 1;
    }
    .insert-pause-unit .el-radio-button__inner {
        width: 100%;
        padding: 12px 16px;
        font-size: 14px;
    }
    .insert-pause-dialog .el-dialog__footer {
        padding: 12px 18px 18px;
    }
    .insert-pause-footer {
        flex-direction: column;
        gap: 10px;
    }
    .insert-pause-footer .el-button {
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 12px 20px;
        font-size: 15px;
    }
}
</style>

<!-- 收藏/最近使用操作栏 + 暗黑模式适配 -->
<style lang="less">
.voice-quick-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin: 10px 0;
    padding: 0 4px;
}

/* 暗黑模式适配 */
.dark-mode .tts .container {
    border-color: var(--border-color);
    box-shadow: 0 0 4px 1px var(--shadow-color);
}
.dark-mode .tts .nav span {
    background: var(--bg-secondary);
    color: var(--text-regular);
    border-color: var(--border-color);
}
.dark-mode .tts .nav span.active {
    background: var(--bg-card);
    color: #409eff;
}
.dark-mode .tts .wenben {
    background: var(--input-bg);
    color: var(--text-primary);
    border-color: var(--border-color);
}
.dark-mode .tts-editor-dialog .el-dialog {
    background: var(--bg-card);
}
.dark-mode .tts-editor-dialog .el-dialog__header {
    border-bottom-color: var(--border-color);
    background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0));
}
.dark-mode .tts-editor-title {
    color: var(--text-primary);
}
.dark-mode .tts-dialog-textarea ::v-deep .el-textarea__inner {
    background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
    border-color: var(--border-color);
    color: var(--text-primary);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.18);
}
.dark-mode .tts-dialog-textarea ::v-deep .el-textarea__inner:focus {
    background: rgba(255,255,255,0.04);
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.18);
}
.dark-mode .tts .right {
    background: var(--bg-card);
    color: var(--text-regular);
}
.dark-mode .tts .contents {
    background: var(--bg-card);
}
.dark-mode .tts .inputtext { color: var(--text-regular); }
.dark-mode .audiodiv {
    padding: 8px 12px;
    border-radius: 16px;
    background: var(--bg-secondary);
    box-shadow: inset 0 0 0 1px var(--border-color);
}
.dark-mode .audiodiv audio {
    color-scheme: dark;
}
.dark-mode .tts-segment-panel {
    background: var(--bg-secondary);
    border-color: var(--border-color);
}
.dark-mode .tts-segment-panel__label,
.dark-mode .tts-segment-panel__tip {
    color: var(--text-regular);
}
.dark-mode .tts-segment-panel__status,
.dark-mode .tts-segment-card__meta {
    color: var(--text-secondary);
}
.dark-mode .tts-segment-card__speaker {
    color: var(--text-secondary);
}
.dark-mode .tts-segment-panel__empty,
.dark-mode .tts-segment-card {
    background: var(--bg-card);
    border-color: var(--border-color);
    color: var(--text-regular);
}
.dark-mode .tts-segment-card__title {
    color: var(--text-primary);
}
.dark-mode .tts-segment-card__content {
    background: rgba(255, 255, 255, 0.03);
    color: var(--text-regular);
    box-shadow: inset 0 0 0 1px var(--border-color);
}
.dark-mode .verify-code-dialog-title,
.dark-mode .buy-coins-dialog-title {
    color: var(--text-primary) !important;
}
.dark-mode .verify-code-tip {
    background: rgba(103, 194, 58, 0.12) !important;
    border-color: rgba(103, 194, 58, 0.22) !important;
    color: var(--text-regular) !important;
}
.dark-mode .verify-code-qr-wrap {
    background: var(--bg-card) !important;
    border-color: var(--border-color) !important;
    box-shadow: 0 2px 8px var(--shadow-color) !important;
}
.dark-mode .verify-code-label,
.dark-mode .buy-coins-label,
.dark-mode .musictip,
.dark-mode .synth-eta-hint {
    color: var(--text-regular) !important;
}
.dark-mode .bgm-picker-card,
.dark-mode .bgm-dialog-current,
.dark-mode .bgm-dialog-settings,
.dark-mode .bgm-item {
    background: var(--bg-secondary) !important;
    border-color: var(--border-color) !important;
}
.dark-mode .bgm-picker-card__value,
.dark-mode .bgm-dialog-current__value,
.dark-mode .bgm-dialog-settings__title,
.dark-mode .bgm-item__name {
    color: var(--text-primary) !important;
}
.dark-mode .bgm-picker-card__label,
.dark-mode .bgm-dialog-current__label,
.dark-mode .bgm-dialog-settings__label,
.dark-mode .bgm-item__meta,
.dark-mode .bgm-empty-state {
    color: var(--text-secondary) !important;
}
.dark-mode .bgm-selected-tip {
    background: var(--tip-bg) !important;
    border-color: var(--tip-border) !important;
    color: var(--text-regular) !important;
}
.dark-mode .mini-program-top-notice {
    background: linear-gradient(135deg, rgba(47, 158, 68, 0.16) 0%, rgba(20, 30, 45, 0.94) 58%, rgba(36, 62, 94, 0.86) 100%) !important;
    border-color: rgba(103, 194, 58, 0.3) !important;
    color: #eaf7ee !important;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.24) !important;
}
.dark-mode .mini-program-free-tip {
    background: linear-gradient(135deg, rgba(47, 158, 68, 0.18) 0%, rgba(20, 30, 45, 0.92) 58%, rgba(36, 62, 94, 0.86) 100%) !important;
    border-color: rgba(103, 194, 58, 0.3) !important;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.24) !important;
    color: var(--text-regular) !important;
}
.dark-mode .mini-program-free-tip__title {
    color: #eaf7ee !important;
}
.dark-mode .mini-program-free-tip__desc {
    color: #bfd6c6 !important;
}
.dark-mode .bgm-item.active {
    border-color: #67c23a !important;
    box-shadow: 0 10px 24px rgba(103, 194, 58, 0.14) !important;
}
.dark-mode .buy-coins-summary {
    background: var(--bg-secondary) !important;
}
.dark-mode .buy-coins-desc {
    color: var(--text-secondary) !important;
}
.dark-mode .buy-coins-row.total .buy-coins-desc {
    color: var(--text-primary) !important;
}
.dark-mode .record-table-wrap {
    background: var(--bg-card);
    color: var(--text-regular);
}
.dark-mode .record-table-wrap .record-table-empty,
.dark-mode .record-card-list .record-table-empty,
.dark-mode .status-pending,
.dark-mode .record-card-time {
    color: var(--text-secondary) !important;
}
.dark-mode .record-card-current {
    border-color: #409eff !important;
    box-shadow: 0 0 0 1px rgba(64, 158, 255, 0.24);
}
.dark-mode .record-table-wrap .record-table-tip {
    background: var(--tip-bg) !important;
    border-color: var(--tip-border) !important;
    color: var(--text-regular) !important;
    box-shadow: 0 1px 2px var(--shadow-color, rgba(0,0,0,.2));
}
.dark-mode .record-table-wrap .record-table-tip i {
    color: #409eff;
}
.dark-mode .record-card {
    background: var(--bg-card) !important;
    border-color: var(--border-color) !important;
}
.dark-mode .record-card-head { color: var(--text-secondary); }
.dark-mode .record-card-content { color: var(--text-regular); }
.dark-mode .toptip {
    color: var(--text-regular);
    background: linear-gradient(180deg, rgba(31, 45, 64, 0.96) 0%, rgba(24, 36, 52, 0.98) 100%);
    border-color: var(--border-color);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
}
.dark-mode .toptip-toggle__title {
    color: #8ec5ff;
    background: rgba(64, 158, 255, 0.16);
}
.dark-mode .toptip-toggle__hint {
    color: var(--text-secondary);
}
.dark-mode .toptip-toggle i {
    color: #8ec5ff;
}
.dark-mode .toptip .tishi {
    color: #8ec5ff;
    background: rgba(64, 158, 255, 0.16);
}
.dark-mode .toptip .tishitip {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(64, 158, 255, 0.18);
    color: var(--text-regular);
    box-shadow: none;
}
.dark-mode .toptip .tishitip span { color: #f56c6c; }
.dark-mode .splice-btns {
    background: linear-gradient(180deg, rgba(30, 42, 58, 0.95) 0%, rgba(24, 33, 46, 0.98) 100%);
    border-color: var(--border-color);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

/* 模板弹窗样式 */
.tpl-dialog-title { font-weight: 600; font-size: 16px; color: var(--text-primary, #303133); }
.tpl-empty { text-align: center; color: var(--text-secondary, #909399); padding: 20px; }
.tpl-list-scroll { max-height: 400px; overflow-y: auto; }
.tpl-card {
    border: 1px solid var(--border-color, #ebeef5);
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    cursor: pointer;
    background: var(--bg-card, #fff);
    transition: border-color .2s, box-shadow .2s;
}
.tpl-card:hover { border-color: #409eff; box-shadow: 0 2px 8px rgba(64,158,255,.12); }
.tpl-card-title { font-weight: 600; margin-bottom: 4px; color: var(--text-primary, #303133); }
.tpl-card-preview { color: var(--text-secondary, #909399); font-size: 13px; line-height: 1.5; }

.dark-mode .baidu-pan-dialog .el-dialog,
.dark-mode .insert-pause-dialog.el-dialog {
    background: var(--dialog-bg);
    border: 1px solid var(--border-color);
}
.dark-mode .baidu-pan-dialog .el-dialog__header {
    background: linear-gradient(135deg, rgba(38, 58, 89, 0.95) 0%, rgba(28, 40, 60, 0.98) 100%);
}
.dark-mode .baidu-pan-title-main,
.dark-mode .insert-pause-dialog .el-dialog__title,
.dark-mode .insert-pause-title,
.dark-mode .insert-pause-label {
    color: var(--text-primary);
}
.dark-mode .baidu-pan-title-sub,
.dark-mode .baidu-pan-loading-body .baidu-pan-label,
.dark-mode .insert-pause-desc {
    color: var(--text-regular);
}
.dark-mode .baidu-pan-loading-body .baidu-pan-status {
    background: rgba(64, 158, 255, 0.12);
    border-color: rgba(64, 158, 255, 0.24);
    color: var(--text-primary);
}
.dark-mode .insert-pause-dialog .el-dialog__header,
.dark-mode .insert-pause-dialog .el-dialog__footer {
    border-color: var(--border-color);
}
.dark-mode .insert-pause-dialog .el-dialog__header {
    background: linear-gradient(180deg, rgba(33, 45, 66, 0.98) 0%, rgba(26, 35, 50, 1) 100%);
}
.dark-mode .insert-pause-desc {
    background: var(--bg-secondary) !important;
    border-left-color: #409eff !important;
}

/* 文本模板弹窗 - 移动端适配 */
@media (max-width: 768px) {
    .tpl-dialog.el-dialog {
        width: 92vw !important;
        max-width: 92vw;
        margin: 5vh auto !important;
    }
    .tpl-dialog .el-dialog__header {
        padding: 12px 15px;
    }
    .tpl-dialog .el-dialog__body {
        padding: 12px 15px;
        max-height: 60vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    .tpl-dialog .el-dialog__title,
    .tpl-dialog .tpl-dialog-title { font-size: 15px; }
    .tpl-dialog .el-radio-group {
        flex-wrap: wrap;
        display: flex;
        gap: 8px;
    }
    .tpl-dialog .el-radio-button { margin: 0; }
    .tpl-dialog .tpl-list-scroll {
        max-height: 50vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        margin-top: 8px;
    }
    .tpl-dialog .tpl-card {
        padding: 10px 12px;
        margin-bottom: 8px;
    }
    .tpl-dialog .tpl-card-preview { font-size: 12px; }
}
</style>
